/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * C-Market 마켓플레이스에서 공급자를 자동으로 등록하거나 로그인하여 JWT 토큰을 발급받습니다.
 * @summary C-Market 공급자 자동 인증 및 세션 생성
 */
export const externalSuppliersControllerAuthenticateSupplierHeader = zod
  .object({
    "X-API-Key": zod.string(),
  })
  .strict();

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneCompanyNameMax = 100;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneBusinessNumberRegExp =
  new RegExp("^\\d{3}-\\d{2}-\\d{5}$");
export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneCeoNameMax = 100;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneAddressFullMax = 255;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneZipCodeMax = 10;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneBusinessTypeMax = 100;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneProductDescriptionMax = 255;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneCompanyPhoneMax = 20;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneManagerNameMax = 100;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneManagerDepartmentMax = 100;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneManagerPositionMax = 100;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneCompanyFaxMax = 20;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneManagerPhoneMax = 20;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneBankNameMax = 50;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneBankAccountNumberMax = 50;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneBankAccountHolderMax = 100;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneCompanySealUrlMax = 2048;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneBusinessLicenseNumberMax = 10;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneBusinessItemMax = 100;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneAddressMainMax = 255;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneAddressDetailMax = 255;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneZipTypeMax = 50;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneBankCodeMax = 10;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneCertificationsItemSourceKeyMax = 120;

export const externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneCertificationsItemNameMax = 200;

export const externalSuppliersControllerAuthenticateSupplierBody = zod
  .object({
    supplierInfo: zod
      .object({
        supplierId: zod.string().describe("C-Market 공급업체 로그인 ID"),
        companyName: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneCompanyNameMax,
          )
          .describe("회사명 (company_name)"),
        businessNumber: zod
          .string()
          .regex(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneBusinessNumberRegExp,
          )
          .describe("사업자등록번호 (business_number)"),
        ceoName: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneCeoNameMax,
          )
          .describe("대표자명 (ceo_name)"),
        addressFull: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneAddressFullMax,
          )
          .describe("회사 주소 (address_full)"),
        zipCode: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneZipCodeMax,
          )
          .nullable()
          .describe("우편번호 (zip_code)"),
        businessType: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneBusinessTypeMax,
          )
          .nullable()
          .describe("업태/종목 (business_type)"),
        productDescription: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneProductDescriptionMax,
          )
          .nullable()
          .describe("취급품목 (product_description)"),
        companyPhone: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneCompanyPhoneMax,
          )
          .describe("회사 전화번호 (company_phone)"),
        managerName: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneManagerNameMax,
          )
          .describe("담당자명 (manager_name)"),
        contactEmail: zod
          .string()
          .nullable()
          .describe("담당자 이메일 (contact_email)"),
        managerDepartment: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneManagerDepartmentMax,
          )
          .nullable()
          .describe("담당자 부서 (manager_department)"),
        managerPosition: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneManagerPositionMax,
          )
          .nullable()
          .describe("담당자 직위 (manager_position)"),
        companyFax: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneCompanyFaxMax,
          )
          .nullable()
          .describe("회사 팩스 (company_fax)"),
        managerPhone: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneManagerPhoneMax,
          )
          .describe("담당자 휴대폰 (manager_phone)"),
        bankName: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneBankNameMax,
          )
          .nullable()
          .describe("은행명 (bank_name)"),
        bankAccountNumber: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneBankAccountNumberMax,
          )
          .nullable()
          .describe("계좌번호 (bank_account_number)"),
        bankAccountHolder: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneBankAccountHolderMax,
          )
          .nullable()
          .describe("예금주 (bank_account_holder)"),
        companySealUrl: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneCompanySealUrlMax,
          )
          .nullable()
          .describe("직인 이미지 URL (company_seal_url)"),
        taxEmail: zod
          .string()
          .nullish()
          .describe(
            "세금계산서 전용 이메일 (tax_email). 담당자 이메일과 다른 칸이며, 계산서는 이쪽으로 발송한다.",
          ),
        businessLicenseNumber: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneBusinessLicenseNumberMax,
          )
          .nullish()
          .describe("종사업장번호 (business_license_number)"),
        businessLicenseNumberUsed: zod
          .boolean()
          .nullish()
          .describe(
            '종사업장번호 사용 여부. null 은 \"정보 없음\" 으로 미사용(false)과 구분한다.',
          ),
        businessItem: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneBusinessItemMax,
          )
          .nullish()
          .describe(
            "종목 (business_item). businessType 은 업태다 — 종전처럼 합쳐 보내지 말고 나눠서 보낸다.",
          ),
        addressMain: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneAddressMainMax,
          )
          .nullish()
          .describe(
            "기본주소 원본 (address_main). 주면 addressFull 파싱 대신 이 값을 그대로 저장한다.",
          ),
        addressDetail: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneAddressDetailMax,
          )
          .nullish()
          .describe(
            "상세주소 원본 (address_detail). 주면 파싱 결과 대신 이 값을 저장한다.",
          ),
        zipType: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneZipTypeMax,
          )
          .nullish()
          .describe("우편번호 유형 (zip_type)"),
        bankCode: zod
          .string()
          .max(
            externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneBankCodeMax,
          )
          .nullish()
          .describe(
            "은행 코드 (bank_code). 은행명 문자열만으로는 이체 자동화가 안 된다.",
          ),
        bankAccountVerified: zod
          .boolean()
          .nullish()
          .describe(
            '예금주 실명확인 완료 여부 (bank_account_verified). null 은 \"확인 정보 없음\" 으로 미확인(false)과 구분한다.',
          ),
        isActive: zod
          .boolean()
          .nullish()
          .describe(
            "파트너가 판정한 활성 여부 (users.is_active). false 면 세모에서도 비활성 처리한다. 보내지 않으면(null) 종전처럼 활성으로 본다.",
          ),
        homepageUrl: zod
          .object({})
          .nullish()
          .describe("회사 홈페이지 URL (b2b_member.homepage)"),
        companyIntro: zod
          .object({})
          .nullish()
          .describe("회사 소개 (b2b_member.gita)"),
        establishedAt: zod
          .object({})
          .nullish()
          .describe("개업연월일 (b2b_member.beginday, YYYY-MM-DD)"),
        certifications: zod
          .array(
            zod
              .object({
                sourceKey: zod
                  .string()
                  .max(
                    externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneCertificationsItemSourceKeyMax,
                  )
                  .describe(
                    "씨마켓 쪽 안정 키 (예: ins:0101 / license:L12 / custom:<uuid>). 재동기화 upsert 기준.",
                  ),
                name: zod
                  .string()
                  .max(
                    externalSuppliersControllerAuthenticateSupplierBodySupplierInfoOneCertificationsItemNameMax,
                  )
                  .describe("인증서/면허 명칭"),
                kind: zod
                  .enum(["CERTIFICATION", "LICENSE", "CUSTOM"])
                  .describe("종류"),
                expiresAt: zod
                  .object({})
                  .nullish()
                  .describe("만료일 (YYYY-MM-DD)"),
                verified: zod
                  .boolean()
                  .describe(
                    '씨마켓 마스터 승인 여부(masterCheckYn=Y). true 면 세모 프로필에 \"검증됨\" 으로 노출.',
                  ),
              })
              .strict(),
          )
          .nullish()
          .describe(
            "씨마켓 회원프로필의 기업 인증서·면허 목록. 보내면 세모의 CMARKET 출처 인증서를 이 목록으로 통째 동기화한다(없어진 항목은 삭제). 보내지 않으면(null) 인증서는 건드리지 않는다.",
          ),
      })
      .strict()
      .describe("공급자 정보 (C-Market 공급업체 데이터)"),
  })
  .strict();

/**
 * 로그인한 공급사의 저장된 회사 정보를 돌려줍니다(견적서 «공급자» 칸에 씀).
 * @summary 내 공급사 정보 조회
 */
export const externalSuppliersControllerGetSupplierMeResponseTwoDataCompanyNameMax = 100;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataBusinessNumberRegExp =
  new RegExp("^\\d{3}-\\d{2}-\\d{5}$");
export const externalSuppliersControllerGetSupplierMeResponseTwoDataCeoNameMax = 100;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataAddressFullMax = 255;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataZipCodeMax = 10;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataBusinessTypeMax = 100;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataProductDescriptionMax = 255;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataCompanyPhoneMax = 20;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataManagerNameMax = 100;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataManagerDepartmentMax = 100;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataManagerPositionMax = 100;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataCompanyFaxMax = 20;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataManagerPhoneMax = 20;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataBankNameMax = 50;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataBankAccountNumberMax = 50;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataBankAccountHolderMax = 100;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataCompanySealUrlMax = 2048;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataBusinessLicenseNumberMax = 10;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataBusinessItemMax = 100;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataAddressMainMax = 255;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataAddressDetailMax = 255;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataZipTypeMax = 50;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataBankCodeMax = 10;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataCertificationsItemSourceKeyMax = 120;

export const externalSuppliersControllerGetSupplierMeResponseTwoDataCertificationsItemNameMax = 200;

export const externalSuppliersControllerGetSupplierMeResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        supplierId: zod.string().describe("C-Market 공급업체 로그인 ID"),
        companyName: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataCompanyNameMax,
          )
          .describe("회사명 (company_name)"),
        businessNumber: zod
          .string()
          .regex(
            externalSuppliersControllerGetSupplierMeResponseTwoDataBusinessNumberRegExp,
          )
          .describe("사업자등록번호 (business_number)"),
        ceoName: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataCeoNameMax,
          )
          .describe("대표자명 (ceo_name)"),
        addressFull: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataAddressFullMax,
          )
          .describe("회사 주소 (address_full)"),
        zipCode: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataZipCodeMax,
          )
          .nullable()
          .describe("우편번호 (zip_code)"),
        businessType: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataBusinessTypeMax,
          )
          .nullable()
          .describe("업태/종목 (business_type)"),
        productDescription: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataProductDescriptionMax,
          )
          .nullable()
          .describe("취급품목 (product_description)"),
        companyPhone: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataCompanyPhoneMax,
          )
          .describe("회사 전화번호 (company_phone)"),
        managerName: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataManagerNameMax,
          )
          .describe("담당자명 (manager_name)"),
        contactEmail: zod
          .string()
          .nullable()
          .describe("담당자 이메일 (contact_email)"),
        managerDepartment: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataManagerDepartmentMax,
          )
          .nullable()
          .describe("담당자 부서 (manager_department)"),
        managerPosition: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataManagerPositionMax,
          )
          .nullable()
          .describe("담당자 직위 (manager_position)"),
        companyFax: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataCompanyFaxMax,
          )
          .nullable()
          .describe("회사 팩스 (company_fax)"),
        managerPhone: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataManagerPhoneMax,
          )
          .describe("담당자 휴대폰 (manager_phone)"),
        bankName: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataBankNameMax,
          )
          .nullable()
          .describe("은행명 (bank_name)"),
        bankAccountNumber: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataBankAccountNumberMax,
          )
          .nullable()
          .describe("계좌번호 (bank_account_number)"),
        bankAccountHolder: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataBankAccountHolderMax,
          )
          .nullable()
          .describe("예금주 (bank_account_holder)"),
        companySealUrl: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataCompanySealUrlMax,
          )
          .nullable()
          .describe("직인 이미지 URL (company_seal_url)"),
        taxEmail: zod
          .string()
          .nullish()
          .describe(
            "세금계산서 전용 이메일 (tax_email). 담당자 이메일과 다른 칸이며, 계산서는 이쪽으로 발송한다.",
          ),
        businessLicenseNumber: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataBusinessLicenseNumberMax,
          )
          .nullish()
          .describe("종사업장번호 (business_license_number)"),
        businessLicenseNumberUsed: zod
          .boolean()
          .nullish()
          .describe(
            '종사업장번호 사용 여부. null 은 \"정보 없음\" 으로 미사용(false)과 구분한다.',
          ),
        businessItem: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataBusinessItemMax,
          )
          .nullish()
          .describe(
            "종목 (business_item). businessType 은 업태다 — 종전처럼 합쳐 보내지 말고 나눠서 보낸다.",
          ),
        addressMain: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataAddressMainMax,
          )
          .nullish()
          .describe(
            "기본주소 원본 (address_main). 주면 addressFull 파싱 대신 이 값을 그대로 저장한다.",
          ),
        addressDetail: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataAddressDetailMax,
          )
          .nullish()
          .describe(
            "상세주소 원본 (address_detail). 주면 파싱 결과 대신 이 값을 저장한다.",
          ),
        zipType: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataZipTypeMax,
          )
          .nullish()
          .describe("우편번호 유형 (zip_type)"),
        bankCode: zod
          .string()
          .max(
            externalSuppliersControllerGetSupplierMeResponseTwoDataBankCodeMax,
          )
          .nullish()
          .describe(
            "은행 코드 (bank_code). 은행명 문자열만으로는 이체 자동화가 안 된다.",
          ),
        bankAccountVerified: zod
          .boolean()
          .nullish()
          .describe(
            '예금주 실명확인 완료 여부 (bank_account_verified). null 은 \"확인 정보 없음\" 으로 미확인(false)과 구분한다.',
          ),
        isActive: zod
          .boolean()
          .nullish()
          .describe(
            "파트너가 판정한 활성 여부 (users.is_active). false 면 세모에서도 비활성 처리한다. 보내지 않으면(null) 종전처럼 활성으로 본다.",
          ),
        homepageUrl: zod
          .object({})
          .nullish()
          .describe("회사 홈페이지 URL (b2b_member.homepage)"),
        companyIntro: zod
          .object({})
          .nullish()
          .describe("회사 소개 (b2b_member.gita)"),
        establishedAt: zod
          .object({})
          .nullish()
          .describe("개업연월일 (b2b_member.beginday, YYYY-MM-DD)"),
        certifications: zod
          .array(
            zod
              .object({
                sourceKey: zod
                  .string()
                  .max(
                    externalSuppliersControllerGetSupplierMeResponseTwoDataCertificationsItemSourceKeyMax,
                  )
                  .describe(
                    "씨마켓 쪽 안정 키 (예: ins:0101 / license:L12 / custom:<uuid>). 재동기화 upsert 기준.",
                  ),
                name: zod
                  .string()
                  .max(
                    externalSuppliersControllerGetSupplierMeResponseTwoDataCertificationsItemNameMax,
                  )
                  .describe("인증서/면허 명칭"),
                kind: zod
                  .enum(["CERTIFICATION", "LICENSE", "CUSTOM"])
                  .describe("종류"),
                expiresAt: zod
                  .object({})
                  .nullish()
                  .describe("만료일 (YYYY-MM-DD)"),
                verified: zod
                  .boolean()
                  .describe(
                    '씨마켓 마스터 승인 여부(masterCheckYn=Y). true 면 세모 프로필에 \"검증됨\" 으로 노출.',
                  ),
              })
              .strict(),
          )
          .nullish()
          .describe(
            "씨마켓 회원프로필의 기업 인증서·면허 목록. 보내면 세모의 CMARKET 출처 인증서를 이 목록으로 통째 동기화한다(없어진 항목은 삭제). 보내지 않으면(null) 인증서는 건드리지 않는다.",
          ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 공급자 설정 변경
 */
export const externalSuppliersControllerUpdateSupplierMeBody = zod
  .object({
    autoQuoteEnabled: zod.boolean().optional().describe("자동 견적 발송 여부"),
    kakaoNotificationEnabled: zod
      .boolean()
      .optional()
      .describe("카카오 알림톡 수신 여부"),
  })
  .strict();

/**
 * 외부 파트너 시스템에서 발주기관(구매사)을 자동으로 등록하거나 로그인하여 JWT 토큰을 발급받습니다. 외부 파트너 검증을 신뢰하므로 별도 NICE 인증 없이 즉시 견적요청 등 NICE-게이트 API를 사용할 수 있습니다.
 * @summary 발주기관(구매사) 자동 인증 및 세션 생성
 */
export const externalBuyersControllerAuthenticateBuyerHeader = zod
  .object({
    "X-API-Key": zod.string(),
  })
  .strict();

export const externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneOrganizationNameMax = 255;

export const externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneBusinessNumberRegExp =
  new RegExp("^\\d{3}-\\d{2}-\\d{5}$");
export const externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneCeoNameMax = 100;

export const externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneAddressFullMax = 255;

export const externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneZipCodeMax = 20;

export const externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneBusinessTypeMax = 100;

export const externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneOrganizationPhoneMax = 20;

export const externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneOrganizationFaxMax = 20;

export const externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneManagerNameMax = 100;

export const externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneManagerPhoneMax = 20;

export const externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneManagerDepartmentMax = 100;

export const externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneManagerPositionMax = 100;

export const externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneBusinessLicenseNumberMax = 10;

export const externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneBusinessItemMax = 100;

export const externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneAddressMainMax = 255;

export const externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneAddressDetailMax = 255;

export const externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneZipTypeMax = 50;

export const externalBuyersControllerAuthenticateBuyerBody = zod
  .object({
    buyerInfo: zod
      .object({
        externalBuyerId: zod.string().describe("외부 시스템 발주기관 고유 ID"),
        organizationName: zod
          .string()
          .max(
            externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneOrganizationNameMax,
          )
          .describe("발주기관/구매사 회사명 (organization_name)"),
        businessNumber: zod
          .string()
          .regex(
            externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneBusinessNumberRegExp,
          )
          .describe("사업자등록번호 (business_number)"),
        ceoName: zod
          .string()
          .max(
            externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneCeoNameMax,
          )
          .describe("대표자명 (ceo_name)"),
        addressFull: zod
          .string()
          .max(
            externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneAddressFullMax,
          )
          .describe("주소 (address_full)"),
        zipCode: zod
          .string()
          .max(
            externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneZipCodeMax,
          )
          .nullable()
          .describe("우편번호 (zip_code)"),
        businessType: zod
          .string()
          .max(
            externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneBusinessTypeMax,
          )
          .nullable()
          .describe("업태/종목 (business_type)"),
        organizationPhone: zod
          .string()
          .max(
            externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneOrganizationPhoneMax,
          )
          .describe("회사 전화번호 (organization_phone)"),
        organizationFax: zod
          .string()
          .max(
            externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneOrganizationFaxMax,
          )
          .nullable()
          .describe("회사 팩스 (organization_fax)"),
        managerName: zod
          .string()
          .max(
            externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneManagerNameMax,
          )
          .describe("담당자명 (manager_name)"),
        managerPhone: zod
          .string()
          .max(
            externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneManagerPhoneMax,
          )
          .nullish()
          .describe(
            "담당자 휴대폰 (manager_phone). 없으면 계정 연락처는 organizationPhone(대표전화)으로 폴백한다.",
          ),
        managerDepartment: zod
          .string()
          .max(
            externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneManagerDepartmentMax,
          )
          .nullable()
          .describe("담당자 부서 (manager_department)"),
        managerPosition: zod
          .string()
          .max(
            externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneManagerPositionMax,
          )
          .nullable()
          .describe("담당자 직위 (manager_position)"),
        contactEmail: zod
          .string()
          .nullable()
          .describe("담당자 이메일 (contact_email)"),
        taxEmail: zod
          .string()
          .nullish()
          .describe(
            "세금계산서 전용 이메일 (tax_email). 담당자 이메일과 다른 칸이며, 계산서는 이쪽으로 발송한다.",
          ),
        businessLicenseNumber: zod
          .string()
          .max(
            externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneBusinessLicenseNumberMax,
          )
          .nullish()
          .describe("종사업장번호 (business_license_number)"),
        businessLicenseNumberUsed: zod
          .boolean()
          .nullish()
          .describe(
            '종사업장번호 사용 여부 (business_license_number_used). null 은 \"정보 없음\" 으로 미사용(false)과 구분한다.',
          ),
        businessItem: zod
          .string()
          .max(
            externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneBusinessItemMax,
          )
          .nullish()
          .describe(
            "종목 (business_item). businessType 은 업태다 — 종전처럼 합쳐 보내지 말고 나눠서 보낸다.",
          ),
        addressMain: zod
          .string()
          .max(
            externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneAddressMainMax,
          )
          .nullish()
          .describe(
            "기본주소 원본 (address_main). 주면 addressFull 파싱 대신 이 값을 그대로 저장한다.",
          ),
        addressDetail: zod
          .string()
          .max(
            externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneAddressDetailMax,
          )
          .nullish()
          .describe(
            "상세주소 원본 (address_detail). 주면 파싱 결과 대신 이 값을 저장한다.",
          ),
        zipType: zod
          .string()
          .max(
            externalBuyersControllerAuthenticateBuyerBodyBuyerInfoOneZipTypeMax,
          )
          .nullish()
          .describe("우편번호 유형 (zip_type)"),
        isActive: zod
          .boolean()
          .nullish()
          .describe(
            "파트너가 판정한 활성 여부 (users.is_active). false 면 세모에서도 비활성 처리한다. 보내지 않으면(null) 종전처럼 활성으로 본다 — 미전송 파트너가 회원을 통째로 잠그는 사고를 막는다.",
          ),
      })
      .strict()
      .describe(
        "발주기관 정보 (외부 파트너 시스템에서 전달하는 구매사 데이터)",
      ),
  })
  .strict();

/**
 * @summary 구매사 설정 변경
 */
export const externalBuyersControllerUpdateBuyerMeBody = zod
  .object({
    kakaoNotificationEnabled: zod
      .boolean()
      .optional()
      .describe("카카오 알림톡 수신 여부"),
  })
  .strict();

/**
 * Embed Token(OTT)을 검증하고 세션으로 교환합니다. 공급사/발주기관 둘 다 지원.
 * @summary Embed 토큰 검증 및 세션 교환
 */
export const externalEmbedControllerVerifyEmbedTokenBody = zod
  .object({
    token: zod.string().describe("JWT 토큰"),
  })
  .strict();

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneCompanyNameMax = 100;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneBusinessNumberRegExp =
  new RegExp("^\\d{3}-\\d{2}-\\d{5}$");
export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneCeoNameMax = 100;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneAddressFullMax = 255;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneZipCodeMax = 10;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneBusinessTypeMax = 100;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneProductDescriptionMax = 255;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneCompanyPhoneMax = 20;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneManagerNameMax = 100;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneManagerDepartmentMax = 100;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneManagerPositionMax = 100;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneCompanyFaxMax = 20;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneManagerPhoneMax = 20;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneBankNameMax = 50;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneBankAccountNumberMax = 50;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneBankAccountHolderMax = 100;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneCompanySealUrlMax = 2048;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneBusinessLicenseNumberMax = 10;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneBusinessItemMax = 100;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneAddressMainMax = 255;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneAddressDetailMax = 255;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneZipTypeMax = 50;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneBankCodeMax = 10;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneCertificationsItemSourceKeyMax = 120;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneCertificationsItemNameMax = 200;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneOrganizationNameMax = 255;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneBusinessNumberRegExp =
  new RegExp("^\\d{3}-\\d{2}-\\d{5}$");
export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneCeoNameMax = 100;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneAddressFullMax = 255;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneZipCodeMax = 20;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneBusinessTypeMax = 100;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneOrganizationPhoneMax = 20;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneOrganizationFaxMax = 20;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneManagerNameMax = 100;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneManagerPhoneMax = 20;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneManagerDepartmentMax = 100;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneManagerPositionMax = 100;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneBusinessLicenseNumberMax = 10;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneBusinessItemMax = 100;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneAddressMainMax = 255;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneAddressDetailMax = 255;

export const externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneZipTypeMax = 50;

export const externalEmbedControllerVerifyEmbedTokenResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        isValid: zod.boolean().describe("JWT 토큰의 유효성 여부"),
        userId: zod
          .string()
          .nullish()
          .describe(
            "토큰에 포함된 공급자 사용자 ID (public.users.id, 유효하지 않으면 null)",
          ),
        accessToken: zod.string().optional().describe("Access Token"),
        refreshToken: zod
          .string()
          .optional()
          .describe(
            "Refresh Token (deprecated — 기본적으로 반환되지 않으며, EMBED_RETURN_REFRESH_TOKEN=true일 때만 임시로 반환됩니다)",
          ),
        supplierId: zod
          .string()
          .nullish()
          .describe(
            "C-Market 공급업체 외부 ID (suppliers.supplier_id, 유효하지 않으면 null)",
          ),
        message: zod
          .string()
          .nullish()
          .describe("토큰이 유효하지 않은 경우 오류 메시지"),
        supplierInfo: zod
          .object({
            supplierId: zod.string().describe("C-Market 공급업체 로그인 ID"),
            companyName: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneCompanyNameMax,
              )
              .describe("회사명 (company_name)"),
            businessNumber: zod
              .string()
              .regex(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneBusinessNumberRegExp,
              )
              .describe("사업자등록번호 (business_number)"),
            ceoName: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneCeoNameMax,
              )
              .describe("대표자명 (ceo_name)"),
            addressFull: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneAddressFullMax,
              )
              .describe("회사 주소 (address_full)"),
            zipCode: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneZipCodeMax,
              )
              .nullable()
              .describe("우편번호 (zip_code)"),
            businessType: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneBusinessTypeMax,
              )
              .nullable()
              .describe("업태/종목 (business_type)"),
            productDescription: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneProductDescriptionMax,
              )
              .nullable()
              .describe("취급품목 (product_description)"),
            companyPhone: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneCompanyPhoneMax,
              )
              .describe("회사 전화번호 (company_phone)"),
            managerName: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneManagerNameMax,
              )
              .describe("담당자명 (manager_name)"),
            contactEmail: zod
              .string()
              .nullable()
              .describe("담당자 이메일 (contact_email)"),
            managerDepartment: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneManagerDepartmentMax,
              )
              .nullable()
              .describe("담당자 부서 (manager_department)"),
            managerPosition: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneManagerPositionMax,
              )
              .nullable()
              .describe("담당자 직위 (manager_position)"),
            companyFax: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneCompanyFaxMax,
              )
              .nullable()
              .describe("회사 팩스 (company_fax)"),
            managerPhone: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneManagerPhoneMax,
              )
              .describe("담당자 휴대폰 (manager_phone)"),
            bankName: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneBankNameMax,
              )
              .nullable()
              .describe("은행명 (bank_name)"),
            bankAccountNumber: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneBankAccountNumberMax,
              )
              .nullable()
              .describe("계좌번호 (bank_account_number)"),
            bankAccountHolder: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneBankAccountHolderMax,
              )
              .nullable()
              .describe("예금주 (bank_account_holder)"),
            companySealUrl: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneCompanySealUrlMax,
              )
              .nullable()
              .describe("직인 이미지 URL (company_seal_url)"),
            taxEmail: zod
              .string()
              .nullish()
              .describe(
                "세금계산서 전용 이메일 (tax_email). 담당자 이메일과 다른 칸이며, 계산서는 이쪽으로 발송한다.",
              ),
            businessLicenseNumber: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneBusinessLicenseNumberMax,
              )
              .nullish()
              .describe("종사업장번호 (business_license_number)"),
            businessLicenseNumberUsed: zod
              .boolean()
              .nullish()
              .describe(
                '종사업장번호 사용 여부. null 은 \"정보 없음\" 으로 미사용(false)과 구분한다.',
              ),
            businessItem: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneBusinessItemMax,
              )
              .nullish()
              .describe(
                "종목 (business_item). businessType 은 업태다 — 종전처럼 합쳐 보내지 말고 나눠서 보낸다.",
              ),
            addressMain: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneAddressMainMax,
              )
              .nullish()
              .describe(
                "기본주소 원본 (address_main). 주면 addressFull 파싱 대신 이 값을 그대로 저장한다.",
              ),
            addressDetail: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneAddressDetailMax,
              )
              .nullish()
              .describe(
                "상세주소 원본 (address_detail). 주면 파싱 결과 대신 이 값을 저장한다.",
              ),
            zipType: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneZipTypeMax,
              )
              .nullish()
              .describe("우편번호 유형 (zip_type)"),
            bankCode: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneBankCodeMax,
              )
              .nullish()
              .describe(
                "은행 코드 (bank_code). 은행명 문자열만으로는 이체 자동화가 안 된다.",
              ),
            bankAccountVerified: zod
              .boolean()
              .nullish()
              .describe(
                '예금주 실명확인 완료 여부 (bank_account_verified). null 은 \"확인 정보 없음\" 으로 미확인(false)과 구분한다.',
              ),
            isActive: zod
              .boolean()
              .nullish()
              .describe(
                "파트너가 판정한 활성 여부 (users.is_active). false 면 세모에서도 비활성 처리한다. 보내지 않으면(null) 종전처럼 활성으로 본다.",
              ),
            homepageUrl: zod
              .object({})
              .nullish()
              .describe("회사 홈페이지 URL (b2b_member.homepage)"),
            companyIntro: zod
              .object({})
              .nullish()
              .describe("회사 소개 (b2b_member.gita)"),
            establishedAt: zod
              .object({})
              .nullish()
              .describe("개업연월일 (b2b_member.beginday, YYYY-MM-DD)"),
            certifications: zod
              .array(
                zod
                  .object({
                    sourceKey: zod
                      .string()
                      .max(
                        externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneCertificationsItemSourceKeyMax,
                      )
                      .describe(
                        "씨마켓 쪽 안정 키 (예: ins:0101 / license:L12 / custom:<uuid>). 재동기화 upsert 기준.",
                      ),
                    name: zod
                      .string()
                      .max(
                        externalEmbedControllerVerifyEmbedTokenResponseTwoDataSupplierInfoOneCertificationsItemNameMax,
                      )
                      .describe("인증서/면허 명칭"),
                    kind: zod
                      .enum(["CERTIFICATION", "LICENSE", "CUSTOM"])
                      .describe("종류"),
                    expiresAt: zod
                      .object({})
                      .nullish()
                      .describe("만료일 (YYYY-MM-DD)"),
                    verified: zod
                      .boolean()
                      .describe(
                        '씨마켓 마스터 승인 여부(masterCheckYn=Y). true 면 세모 프로필에 \"검증됨\" 으로 노출.',
                      ),
                  })
                  .strict(),
              )
              .nullish()
              .describe(
                "씨마켓 회원프로필의 기업 인증서·면허 목록. 보내면 세모의 CMARKET 출처 인증서를 이 목록으로 통째 동기화한다(없어진 항목은 삭제). 보내지 않으면(null) 인증서는 건드리지 않는다.",
              ),
          })
          .strict()
          .nullish()
          .describe("공급자 정보 (토큰이 유효한 경우에만 반환)"),
        userType: zod
          .enum(["supplier", "buyer"])
          .nullish()
          .describe("인증된 사용자 역할"),
        buyerId: zod
          .string()
          .nullish()
          .describe("외부 파트너 발주기관 ID (buyers.external_buyer_id)"),
        buyerInfo: zod
          .object({
            externalBuyerId: zod
              .string()
              .describe("외부 시스템 발주기관 고유 ID"),
            organizationName: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneOrganizationNameMax,
              )
              .describe("발주기관/구매사 회사명 (organization_name)"),
            businessNumber: zod
              .string()
              .regex(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneBusinessNumberRegExp,
              )
              .describe("사업자등록번호 (business_number)"),
            ceoName: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneCeoNameMax,
              )
              .describe("대표자명 (ceo_name)"),
            addressFull: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneAddressFullMax,
              )
              .describe("주소 (address_full)"),
            zipCode: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneZipCodeMax,
              )
              .nullable()
              .describe("우편번호 (zip_code)"),
            businessType: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneBusinessTypeMax,
              )
              .nullable()
              .describe("업태/종목 (business_type)"),
            organizationPhone: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneOrganizationPhoneMax,
              )
              .describe("회사 전화번호 (organization_phone)"),
            organizationFax: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneOrganizationFaxMax,
              )
              .nullable()
              .describe("회사 팩스 (organization_fax)"),
            managerName: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneManagerNameMax,
              )
              .describe("담당자명 (manager_name)"),
            managerPhone: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneManagerPhoneMax,
              )
              .nullish()
              .describe(
                "담당자 휴대폰 (manager_phone). 없으면 계정 연락처는 organizationPhone(대표전화)으로 폴백한다.",
              ),
            managerDepartment: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneManagerDepartmentMax,
              )
              .nullable()
              .describe("담당자 부서 (manager_department)"),
            managerPosition: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneManagerPositionMax,
              )
              .nullable()
              .describe("담당자 직위 (manager_position)"),
            contactEmail: zod
              .string()
              .nullable()
              .describe("담당자 이메일 (contact_email)"),
            taxEmail: zod
              .string()
              .nullish()
              .describe(
                "세금계산서 전용 이메일 (tax_email). 담당자 이메일과 다른 칸이며, 계산서는 이쪽으로 발송한다.",
              ),
            businessLicenseNumber: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneBusinessLicenseNumberMax,
              )
              .nullish()
              .describe("종사업장번호 (business_license_number)"),
            businessLicenseNumberUsed: zod
              .boolean()
              .nullish()
              .describe(
                '종사업장번호 사용 여부 (business_license_number_used). null 은 \"정보 없음\" 으로 미사용(false)과 구분한다.',
              ),
            businessItem: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneBusinessItemMax,
              )
              .nullish()
              .describe(
                "종목 (business_item). businessType 은 업태다 — 종전처럼 합쳐 보내지 말고 나눠서 보낸다.",
              ),
            addressMain: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneAddressMainMax,
              )
              .nullish()
              .describe(
                "기본주소 원본 (address_main). 주면 addressFull 파싱 대신 이 값을 그대로 저장한다.",
              ),
            addressDetail: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneAddressDetailMax,
              )
              .nullish()
              .describe(
                "상세주소 원본 (address_detail). 주면 파싱 결과 대신 이 값을 저장한다.",
              ),
            zipType: zod
              .string()
              .max(
                externalEmbedControllerVerifyEmbedTokenResponseTwoDataBuyerInfoOneZipTypeMax,
              )
              .nullish()
              .describe("우편번호 유형 (zip_type)"),
            isActive: zod
              .boolean()
              .nullish()
              .describe(
                "파트너가 판정한 활성 여부 (users.is_active). false 면 세모에서도 비활성 처리한다. 보내지 않으면(null) 종전처럼 활성으로 본다 — 미전송 파트너가 회원을 통째로 잠그는 사고를 막는다.",
              ),
          })
          .strict()
          .nullish()
          .describe("발주기관 정보 (buyer 토큰일 때만 반환)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 알림톡 링크 생성 (테스트용)
 */
export const externalEmbedControllerGenerateAlimTalkLinksBody = zod
  .object({
    quoteRequestId: zod.string().describe("견적 요청 ID (UUID)"),
    origin: zod
      .string()
      .optional()
      .describe("Base URL (생략 시 서버 환경변수 사용)"),
  })
  .strict();

/**
 * 인증된 사용자의 역할(공급사 또는 발주기관)에 따라 적절한 Embed URL을 생성합니다.
 * @summary Embed URL 생성 (공급사 / 발주기관 공통)
 */
export const externalEmbedControllerGetEmbedUrlBody = zod
  .object({
    type: zod
      .enum([
        "quote-response",
        "quote-detail",
        "chat",
        "dashboard",
        "dashboard-my-projects",
        "dashboard-chat-list",
        "dashboard-settlements",
        "dashboard-contracts",
        "dashboard-products",
        "dashboard-shipments",
        "buyer-quote-request-new",
        "buyer-dashboard",
        "buyer-chat-list",
      ])
      .describe("Embed 인터페이스 타입")
      .describe("Embed 인터페이스 타입"),
    targetId: zod
      .string()
      .optional()
      .describe("임베드 대상 리소스 ID (dashboard 제외 필수)"),
    origin: zod
      .string()
      .optional()
      .describe(
        "Embed base URL (개발용, EMBED_BASE_URL 환경변수가 없을 때만 사용)",
      ),
  })
  .strict();

/**
 * 카테고리 계층 구조를 트리 형태로 조회합니다.
 * @summary 카테고리 트리 조회 (공급자용)
 */
export const externalCategoriesControllerGetCategoryTreeQueryParams = zod
  .object({
    mode: zod.enum(["all", "dealing"]).optional().describe("조회 모드"),
  })
  .strict();

export const externalCategoriesControllerGetCategoryTreeResponseTwoDataItemLevelMax = 4;

export const externalCategoriesControllerGetCategoryTreeResponseTwoDataItemDisplayOrderMin = 0;

export const externalCategoriesControllerGetCategoryTreeResponseTwoDataItemProductCountMin = 0;

export const externalCategoriesControllerGetCategoryTreeResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            id: zod.string().uuid().describe("카테고리 ID (UUID)"),
            name: zod.string().describe("카테고리 이름"),
            level: zod
              .number()
              .min(1)
              .max(
                externalCategoriesControllerGetCategoryTreeResponseTwoDataItemLevelMax,
              )
              .describe("카테고리 레벨"),
            displayOrder: zod
              .number()
              .min(
                externalCategoriesControllerGetCategoryTreeResponseTwoDataItemDisplayOrderMin,
              )
              .describe("표시 순서"),
            icon: zod.string().nullish().describe("아이콘 이름"),
            description: zod.string().nullish().describe("카테고리 설명"),
            isActive: zod.boolean().describe("활성 상태"),
            children: zod
              .array(zod.unknown())
              .describe("자식 카테고리 목록 (재귀적)"),
            productCount: zod
              .number()
              .min(
                externalCategoriesControllerGetCategoryTreeResponseTwoDataItemProductCountMin,
              )
              .optional()
              .describe("하위 상품 개수"),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 공급자 대시보드에서 사용하는 물품 목록 조회 API입니다.
 * @summary 📦 카테고리별 물품 조회 (공급자용)
 */
export const externalItemsControllerGetItemsQueryLimitDefault = 20;
export const externalItemsControllerGetItemsQueryOffsetDefault = 0;

export const externalItemsControllerGetItemsQueryParams = zod
  .object({
    limit: zod.coerce
      .number()
      .default(externalItemsControllerGetItemsQueryLimitDefault)
      .describe("조회 개수 (기본 20)"),
    offset: zod.coerce
      .number()
      .default(externalItemsControllerGetItemsQueryOffsetDefault)
      .describe("페이지네이션 오프셋 (기본 0)"),
    categoryId: zod.coerce.string().optional().describe("카테고리 ID"),
    includeDescendants: zod.coerce
      .boolean()
      .optional()
      .describe("하위 카테고리 포함 여부 (기본 true)"),
    onlyMyProducts: zod.coerce
      .boolean()
      .optional()
      .describe("내 상품만 보기 여부"),
    sellingStatus: zod
      .enum(["active", "inactive", "all"])
      .optional()
      .describe(
        "내 상품의 판매 상태 필터 — onlyMyProducts=true 일 때만 적용. active=판매중(생략 시 기본, 종전 동작), inactive=판매중지, all=둘 다",
      ),
    onlyMyCategories: zod.coerce
      .boolean()
      .optional()
      .describe("내 취급 카테고리 상품만 보기 여부"),
    search: zod.coerce
      .string()
      .optional()
      .describe("검색어 (상품명, 브랜드, 코드 등)"),
    sortBy: zod
      .enum(["name", "price", "updated_at", "supplier_count"])
      .optional()
      .describe("정렬 기준"),
    sortOrder: zod.enum(["ASC", "DESC"]).optional().describe("정렬 순서"),
  })
  .strict();

export const externalItemsControllerGetItemsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              casNo: zod
                .string()
                .nullish()
                .describe(
                  "CAS 등록번호 — 상품명에서 추출한 값. 시약이 아니면 null (KOSHA 매칭 여부와 무관하게 채워진다)",
                ),
              keNo: zod
                .string()
                .nullish()
                .describe(
                  "국내 기존화학물질 고유번호 (KE 번호). KOSHA 미등록이거나 미부여면 null",
                ),
              unNo: zod
                .string()
                .nullish()
                .describe(
                  "UN 번호 (국제 위험물 운송번호). 위험물이 아니면 null",
                ),
              enNo: zod
                .string()
                .nullish()
                .describe("EC 번호 (EU EINECS/ELINCS)"),
              chemNameKor: zod
                .string()
                .nullish()
                .describe("KOSHA 기준 국문 표준 물질명"),
              id: zod.string().describe("품목 ID (items_v2_base.id - UUID)"),
              name: zod.string().describe("상품명"),
              categoryId: zod
                .string()
                .nullable()
                .describe("카테고리 ID (items_v2_categories.id - UUID)"),
              categoryPath: zod.string().describe("카테고리 경로 (표시용)"),
              price: zod.number().describe("기준 가격 (정가)"),
              lowestPrice: zod.number().nullable().describe("최저가 거래 단가"),
              lowestPriceDate: zod
                .string()
                .nullable()
                .describe("최저가 거래 날짜"),
              lowestPriceSupplierName: zod
                .string()
                .nullable()
                .describe("최저가 거래 공급자명"),
              level: zod.number().describe("카테고리 레벨 (0-3)"),
              parentId: zod.string().nullable().describe("부모 카테고리 UUID"),
              manufacturer: zod.string().nullable().describe("제조사"),
              brand: zod.string().nullable().describe("브랜드"),
              code: zod.string().nullable().describe("상품코드"),
              unit: zod.string().describe("단위"),
              imageUrl: zod.string().nullable().describe("이미지 URL"),
              spec1: zod.string().nullable().describe("규격1"),
              spec2: zod.string().nullable().describe("규격2"),
              spec3: zod.string().nullable().describe("규격3"),
              supplierCount: zod.number().describe("취급 공급자 수"),
              createdAt: zod.string().describe("생성 일시"),
              updatedAt: zod.string().describe("수정 일시"),
              myPrice: zod
                .number()
                .nullable()
                .describe("나의 공급가 (items_v2_transactions.거래단가)"),
              isSelling: zod
                .boolean()
                .describe("판매 상태 (items_v2_transactions.status)"),
              priceEntryId: zod
                .string()
                .nullable()
                .describe("단가 레코드 ID (items_v2_transactions.id)"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 특정 물품에 대한 나의 공급가 및 판매 상태를 업데이트합니다.
 * @summary ⚙️ 물품별 공급자 설정 업데이트
 */
export const externalItemsControllerUpdateSettingsParams = zod
  .object({
    id: zod.coerce.string().describe("물품 ID"),
  })
  .strict();

export const externalItemsControllerUpdateSettingsBodyPriceMin = 0;
export const externalItemsControllerUpdateSettingsBodyPriceMax = 999999999;

export const externalItemsControllerUpdateSettingsBody = zod
  .object({
    price: zod
      .number()
      .min(externalItemsControllerUpdateSettingsBodyPriceMin)
      .max(externalItemsControllerUpdateSettingsBodyPriceMax)
      .optional()
      .describe("나의 공급가 (₩, 원 단위 정수, 0 ~ 999,999,999)"),
    isSelling: zod.boolean().optional().describe("판매 상태"),
  })
  .strict();

export const externalItemsControllerUpdateSettingsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("단가 ID"),
        itemId: zod.string().describe("물품 ID"),
        price: zod.number().describe("판매 단가 (₩)"),
        supplierId: zod.string().describe("공급자 ID"),
        status: zod.enum(["active", "inactive"]).describe("판매 상태"),
        taxType: zod
          .enum(["EXCLUSIVE", "INCLUSIVE"])
          .describe(
            "단가의 부가세 축. EXCLUSIVE=공급가액(부가세 별도), INCLUSIVE=부가세 포함가",
          ),
        updatedAt: zod.string().describe("마지막 수정 일시"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 공급자가 새로운 물품 등록을 요청합니다.
 * @summary 물품 등록 요청 제출 (C-Market 전용)
 */
export const externalItemsControllerCreateRequestBodyUnitDefault = "EA";

export const externalItemsControllerCreateRequestBody = zod
  .object({
    name: zod.string().describe("상품명"),
    manufacturer: zod.string().optional().describe("제조사"),
    brand: zod.string().optional().describe("브랜드"),
    unit: zod
      .string()
      .default(externalItemsControllerCreateRequestBodyUnitDefault)
      .describe("단위"),
    spec1: zod.string().optional().describe("규격 1"),
    spec2: zod.string().optional().describe("규격 2"),
    spec3: zod.string().optional().describe("규격 3"),
    categoryId: zod.string().optional().describe("카테고리 ID"),
    additionalCategoryIds: zod
      .object({})
      .optional()
      .describe("추가 카테고리 IDs"),
    requestReason: zod.string().optional().describe("요청 사유"),
  })
  .strict();

/**
 * 공급자가 직접 등록 요청한 품목들의 상태를 조회합니다.
 * @summary 내가 요청한 품목 등록 내역 조회
 */
export const externalItemsControllerGetMyRequestsQueryLimitDefault = 20;
export const externalItemsControllerGetMyRequestsQueryOffsetDefault = 0;

export const externalItemsControllerGetMyRequestsQueryParams = zod
  .object({
    limit: zod.coerce
      .number()
      .default(externalItemsControllerGetMyRequestsQueryLimitDefault)
      .describe("조회 개수 (기본 20)"),
    offset: zod.coerce
      .number()
      .default(externalItemsControllerGetMyRequestsQueryOffsetDefault)
      .describe("페이지네이션 오프셋 (기본 0)"),
    categoryId: zod.coerce.string().optional().describe("카테고리 ID"),
    includeDescendants: zod.coerce
      .boolean()
      .optional()
      .describe("하위 카테고리 포함 여부 (기본 true)"),
    onlyMyProducts: zod.coerce
      .boolean()
      .optional()
      .describe("내 상품만 보기 여부"),
    sellingStatus: zod
      .enum(["active", "inactive", "all"])
      .optional()
      .describe(
        "내 상품의 판매 상태 필터 — onlyMyProducts=true 일 때만 적용. active=판매중(생략 시 기본, 종전 동작), inactive=판매중지, all=둘 다",
      ),
    onlyMyCategories: zod.coerce
      .boolean()
      .optional()
      .describe("내 취급 카테고리 상품만 보기 여부"),
    search: zod.coerce
      .string()
      .optional()
      .describe("검색어 (상품명, 브랜드, 코드 등)"),
    sortBy: zod
      .enum(["name", "price", "updated_at", "supplier_count"])
      .optional()
      .describe("정렬 기준"),
    sortOrder: zod.enum(["ASC", "DESC"]).optional().describe("정렬 순서"),
  })
  .strict();

export const externalItemsControllerGetMyRequestsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("요청 ID"),
              supplierId: zod.string().describe("Supplier ID"),
              name: zod.string().describe("상품명"),
              manufacturer: zod.string().optional().describe("제조사"),
              brand: zod.string().optional().describe("브랜드"),
              unit: zod.string().nullable().describe("단위"),
              spec1: zod.string().optional().describe("규격 1"),
              spec2: zod.string().optional().describe("규격 2"),
              spec3: zod.string().optional().describe("규격 3"),
              categoryId: zod.string().optional().describe("카테고리 ID"),
              additionalCategoryIds: zod
                .object({})
                .optional()
                .describe("추가 카테고리 IDs"),
              requestReason: zod.string().optional().describe("요청 사유"),
              status: zod
                .enum(["pending", "approved", "rejected"])
                .describe("상태"),
              adminComment: zod.string().optional().describe("Admin 거부 사유"),
              approvedByAdminId: zod
                .string()
                .optional()
                .describe("승인한 Admin ID"),
              approvedItemId: zod
                .string()
                .optional()
                .describe("승인 시 생성된 물품 ID"),
              createdAt: zod.string().describe("생성 일시"),
              updatedAt: zod.string().nullable().describe("수정 일시"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 정부 조달 데이터(items_v2_base) 기반 읽기 전용 품목 검색. 파트너 API 키(X-API-Key)로 인증한다(buyer/supplier 세션 토큰도 과도기 동안 함께 허용). 발주기관 공고등록·시약등록 및 공급사 견적 작성에서 공통으로 사용.
 * @summary 🔍 품목 자동완성 검색 (파트너 API 키)
 */
export const externalItemSearchControllerSearchQueryQMin = 2;

export const externalItemSearchControllerSearchQueryLimitDefault = 10;
export const externalItemSearchControllerSearchQueryLimitMax = 50;

export const externalItemSearchControllerSearchQueryOffsetDefault = 0;
export const externalItemSearchControllerSearchQueryOffsetMin = 0;

export const externalItemSearchControllerSearchQuerySortOrderDefault = "desc";

export const externalItemSearchControllerSearchQueryParams = zod
  .object({
    q: zod.coerce
      .string()
      .min(externalItemSearchControllerSearchQueryQMin)
      .describe("검색어 (최소 2글자)"),
    limit: zod.coerce
      .number()
      .min(1)
      .max(externalItemSearchControllerSearchQueryLimitMax)
      .default(externalItemSearchControllerSearchQueryLimitDefault)
      .describe("결과 개수 (기본: 10, 최대: 50)"),
    offset: zod.coerce
      .number()
      .min(externalItemSearchControllerSearchQueryOffsetMin)
      .default(externalItemSearchControllerSearchQueryOffsetDefault)
      .describe(
        "결과 오프셋 (기본: 0). limit 상한(50) 너머로 페이징할 때 사용 — offset=50 이면 51번째부터 반환한다. 응답은 그대로 배열이며, 반환 건수가 limit 과 같으면 다음 페이지가 있을 수 있다.",
      ),
    supplierId: zod.coerce
      .string()
      .optional()
      .describe("공급사 ID (선택사항 - 공급사별 단가 조회 시 필요)"),
    categoryIds: zod
      .array(zod.coerce.string())
      .optional()
      .describe(
        "카테고리 ID 필터 (선택사항). 지정 시 해당 카테고리 품목만 검색한다. 쉼표 구분 또는 반복 쿼리 파라미터(categoryIds=a&categoryIds=b) 모두 허용.",
      ),
    sortBy: zod
      .enum(["name", "supplierCount", "autoQuoteSupplierCount"])
      .optional()
      .describe("정렬 기준"),
    sortOrder: zod
      .enum(["asc", "desc"])
      .default(externalItemSearchControllerSearchQuerySortOrderDefault)
      .describe("정렬 순서"),
    catalogEpoch: zod
      .enum(["legacy", "v2"])
      .optional()
      .describe(
        "카탈로그 epoch 필터. legacy=2026-05-19 이전 등록 품목, v2=이후 등록 품목. 미지정 시 전체.",
      ),
  })
  .strict();

export const externalItemSearchControllerSearchHeader = zod
  .object({
    "X-API-Key": zod.string().optional(),
  })
  .strict();

export const externalItemSearchControllerSearchResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            casNo: zod
              .string()
              .nullish()
              .describe(
                "CAS 등록번호 — 상품명에서 추출한 값. 시약이 아니면 null (KOSHA 매칭 여부와 무관하게 채워진다)",
              ),
            keNo: zod
              .string()
              .nullish()
              .describe(
                "국내 기존화학물질 고유번호 (KE 번호). KOSHA 미등록이거나 미부여면 null",
              ),
            unNo: zod
              .string()
              .nullish()
              .describe("UN 번호 (국제 위험물 운송번호). 위험물이 아니면 null"),
            enNo: zod.string().nullish().describe("EC 번호 (EU EINECS/ELINCS)"),
            chemNameKor: zod
              .string()
              .nullish()
              .describe("KOSHA 기준 국문 표준 물질명"),
            id: zod.string().describe("품목 ID (items_v2_base.id - UUID)"),
            name: zod.string().describe("상품명"),
            categoryId: zod
              .string()
              .nullable()
              .describe(
                "카테고리 ID (items_v2_categories.id - UUID, FK to normalized category table)",
              ),
            categoryPath: zod.string().describe("카테고리 경로 (표시용)"),
            price: zod.number().describe("기준 가격 (정가)"),
            lowestPrice: zod.number().nullable().describe("최저가 거래 단가"),
            lowestPriceDate: zod
              .string()
              .nullable()
              .describe("최저가 거래 날짜"),
            supplierPrice: zod
              .number()
              .nullish()
              .describe("공급사별 단가 (supplierId 파라미터 제공 시에만 반환)"),
            supplierLastTransactionDate: zod
              .string()
              .nullish()
              .describe("공급사별 최근 거래 일자"),
            unit: zod.string().optional().describe("단위"),
            manufacturer: zod.string().optional().describe("제조사"),
            brand: zod.string().optional().describe("브랜드"),
            spec1: zod.string().optional().describe("규격 1"),
            spec2: zod.string().optional().describe("규격 2"),
            spec3: zod.string().optional().describe("규격 3"),
            supplierCount: zod
              .number()
              .optional()
              .describe(
                "이 품목을 취급하는 공급사 수 (활성 거래이력 기준, 탈퇴/정지 계정 제외). 모든 환경에서 반환된다.",
              ),
            autoQuoteSupplierCount: zod
              .number()
              .optional()
              .describe(
                "이 품목을 취급하는 공급사 중 자동견적(auto_quote_enabled)을 켠 공급사 수. supplierCount 의 부분집합이며, 자동견적을 켠 곳이 없으면 0. 집계 시점은 검색 색인 동기화 주기(매일 새벽)를 따른다.",
              ),
            canAutoQuote: zod
              .boolean()
              .optional()
              .describe(
                "자동 견적 가능 여부 (supplierCount > 0, 즉 취급 공급사가 1곳 이상인지). 자동견적을 켠 공급사가 있는지는 autoQuoteSupplierCount 로 판단할 것.",
              ),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 세모 마스터가 해당 쇼핑몰에 승인한 상품과 판매가를 반환한다. 판매가는 마스터가 정한 규칙(공급사 단가 그대로 / 마진율 / 고정가)이 적용된 값이며, 공급사 정보는 포함되지 않는다.
 * @summary 🛒 쇼핑몰 상품 피드 (파트너 API 키)
 */
export const externalStorefrontControllerGetItemsParams = zod
  .object({
    slug: zod.coerce.string().describe("쇼핑몰 식별자"),
  })
  .strict();

export const externalStorefrontControllerGetItemsQueryParams = zod
  .object({
    q: zod.coerce.string().optional().describe("상품명·제조사 검색"),
    categoryId: zod.coerce.string().optional().describe("소분류(말단) 한정"),
    rootCategoryId: zod.coerce
      .string()
      .optional()
      .describe(
        "대분류 한정. 쇼핑몰의 대분류 탭이 이 값으로 서버 조회를 한 번 한다",
      ),
    sort: zod
      .enum(["recommended", "price_asc", "price_desc", "name"])
      .optional()
      .describe("기본은 카테고리→품명. 목록을 잘라 받을 때 정렬은 서버 몫이다"),
    offset: zod.unknown().optional(),
    limit: zod.unknown().optional(),
  })
  .strict();

export const externalStorefrontControllerGetItemsHeader = zod
  .object({
    "X-API-Key": zod.string().optional(),
  })
  .strict();

export const externalStorefrontControllerGetItemsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              itemId: zod.string().describe("품목 ID (items_v2_base.id)"),
              name: zod.string().describe("상품명"),
              price: zod
                .number()
                .describe("판매가(원). 마스터가 정한 가격 규칙이 적용된 값"),
              categoryId: zod.string().nullish().describe("카테고리 ID"),
              categoryName: zod.string().nullish().describe("카테고리명"),
              rootCategoryName: zod
                .string()
                .nullish()
                .describe(
                  "대분류(카테고리 계층 최상위) 이름. categoryName 은 말단 소분류라 개수가 많다(현재 253개). 목록 상단 카테고리 묶음에는 이 값을 쓴다(현재 20개). 계층이 3단을 넘으면 null.",
                ),
              manufacturer: zod.string().nullish().describe("제조사"),
              brand: zod.string().nullish().describe("브랜드"),
              unit: zod.string().nullish().describe("단위"),
              spec1: zod.string().nullish().describe("규격 1"),
              spec2: zod.string().nullish().describe("규격 2"),
              spec3: zod.string().nullish().describe("규격 3"),
              imageUrl: zod.string().nullish().describe("이미지 URL"),
              offerCount: zod
                .number()
                .describe(
                  "이 품목을 대는 공급사 수(익명). 2 이상이면 단가 리스트가 있고 price 는 그중 최저가다",
                ),
              maxPrice: zod
                .number()
                .nullish()
                .describe(
                  "가장 비싼 오퍼. 손님에게 «최대 N원 절약» 을 보여 줄 때 쓴다",
                ),
              taxType: zod
                .string()
                .nullish()
                .describe(
                  "표시가의 부가세 축(EXCLUSIVE=공급가액 / INCLUSIVE=부가세 포함). null 이면 미지정",
                ),
              taxCategory: zod
                .enum(["TAXABLE", "EXEMPT", "ZERO_RATED"])
                .nullish()
                .describe(
                  "품목의 과세 상태. EXEMPT·ZERO_RATED 는 부가세가 0이라 총액이 표시가와 같다. null 이면 미확인이며, 그 경우 총액은 과세로 보고 계산하는 편이 안전하다",
                ),
            })
            .strict(),
        ),
        total: zod.number(),
        limit: zod.number(),
        offset: zod.number(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 노출 중인 상품의 대분류·소분류와 건수. 쇼핑몰이 칩을 그리려고 상품 목록을 통째로 받지 않아도 되게 한다 — 2만 건짜리 몰에서는 그 방식이 성립하지 않는다.
 * @summary 🛒 쇼핑몰 카테고리 인덱스 (파트너 API 키)
 */
export const externalStorefrontControllerGetCategoriesParams = zod
  .object({
    slug: zod.coerce.string(),
  })
  .strict();

export const externalStorefrontControllerGetCategoriesHeader = zod
  .object({
    "X-API-Key": zod.string().optional(),
  })
  .strict();

export const externalStorefrontControllerGetCategoriesResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        groups: zod.array(
          zod
            .object({
              rootCategoryId: zod.string().nullish(),
              rootCategoryName: zod
                .string()
                .nullish()
                .describe(
                  "대분류 이름. 계층이 3단을 넘으면 null 이라 «기타» 로 묶인다",
                ),
              itemCount: zod.number().describe("이 대분류에 노출 중인 상품 수"),
              children: zod.array(
                zod
                  .object({
                    categoryId: zod.string().nullish(),
                    categoryName: zod.string().nullish(),
                    itemCount: zod
                      .number()
                      .describe("이 소분류에 노출 중인 상품 수"),
                  })
                  .strict(),
              ),
            })
            .strict(),
        ),
        total: zod.number().describe("노출 중인 상품 총 수"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 상세 화면용. 목록을 통째로 받아 그 안에서 찾지 않아도 되게 한다 — 승인 품목이 2만 건이 되면 상세 한 장에 목록 100쪽이 딸려온다.
 * @summary 🛒 쇼핑몰 상품 단건 (파트너 API 키)
 */
export const externalStorefrontControllerGetItemParams = zod
  .object({
    slug: zod.coerce.string(),
    itemId: zod.coerce.string().describe("품목 ID"),
  })
  .strict();

export const externalStorefrontControllerGetItemHeader = zod
  .object({
    "X-API-Key": zod.string().optional(),
  })
  .strict();

export const externalStorefrontControllerGetItemResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        itemId: zod.string().describe("품목 ID (items_v2_base.id)"),
        name: zod.string().describe("상품명"),
        price: zod
          .number()
          .describe("판매가(원). 마스터가 정한 가격 규칙이 적용된 값"),
        categoryId: zod.string().nullish().describe("카테고리 ID"),
        categoryName: zod.string().nullish().describe("카테고리명"),
        rootCategoryName: zod
          .string()
          .nullish()
          .describe(
            "대분류(카테고리 계층 최상위) 이름. categoryName 은 말단 소분류라 개수가 많다(현재 253개). 목록 상단 카테고리 묶음에는 이 값을 쓴다(현재 20개). 계층이 3단을 넘으면 null.",
          ),
        manufacturer: zod.string().nullish().describe("제조사"),
        brand: zod.string().nullish().describe("브랜드"),
        unit: zod.string().nullish().describe("단위"),
        spec1: zod.string().nullish().describe("규격 1"),
        spec2: zod.string().nullish().describe("규격 2"),
        spec3: zod.string().nullish().describe("규격 3"),
        imageUrl: zod.string().nullish().describe("이미지 URL"),
        offerCount: zod
          .number()
          .describe(
            "이 품목을 대는 공급사 수(익명). 2 이상이면 단가 리스트가 있고 price 는 그중 최저가다",
          ),
        maxPrice: zod
          .number()
          .nullish()
          .describe(
            "가장 비싼 오퍼. 손님에게 «최대 N원 절약» 을 보여 줄 때 쓴다",
          ),
        taxType: zod
          .string()
          .nullish()
          .describe(
            "표시가의 부가세 축(EXCLUSIVE=공급가액 / INCLUSIVE=부가세 포함). null 이면 미지정",
          ),
        taxCategory: zod
          .enum(["TAXABLE", "EXEMPT", "ZERO_RATED"])
          .nullish()
          .describe(
            "품목의 과세 상태. EXEMPT·ZERO_RATED 는 부가세가 0이라 총액이 표시가와 같다. null 이면 미확인이며, 그 경우 총액은 과세로 보고 계산하는 편이 안전하다",
          ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 같은 품목을 여러 공급사가 낼 수 있다. 손님에게는 «몇 번째로 싼 값» 만 보여 주고 누가 파는지는 내보내지 않는다. 목록의 price 는 이 리스트의 최저가와 같다.
 * @summary 🛒 품목별 익명 단가 리스트 (파트너 API 키)
 */
export const externalStorefrontControllerGetItemOffersParams = zod
  .object({
    slug: zod.coerce.string(),
    itemId: zod.coerce.string().describe("품목 ID"),
  })
  .strict();

export const externalStorefrontControllerGetItemOffersHeader = zod
  .object({
    "X-API-Key": zod.string().optional(),
  })
  .strict();

export const externalStorefrontControllerGetItemOffersResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        offers: zod.array(
          zod
            .object({
              offerId: zod
                .string()
                .describe("이 오퍼의 식별자. 주문할 때 이 값을 지정한다"),
              price: zod.number().describe("판매가(원)"),
              priceRank: zod.number().describe("가격 순위. 1 이 최저가"),
              taxType: zod.string().nullish(),
              taxCategory: zod
                .enum(["TAXABLE", "EXEMPT", "ZERO_RATED"])
                .nullish(),
            })
            .strict(),
        ),
        total: zod.number().describe("오퍼 수"),
        minPrice: zod.number().describe("최저가"),
        maxPrice: zod.number().describe("최고가"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 포인트 결제 몰(POINT_POSTPAID)에서 그 담당자가 지금 쓸 수 있는 포인트와 원장 이력. 원장 정본은 세모 DB(로트별 사용기한·FEFO)다 — 후불 몰이면 409 다.
 * @summary 🛒 쇼핑몰 포인트 — 잔액·만기 임박·이력 (파트너 API 키)
 */
export const externalStorefrontOrdersControllerGetPointBalanceParams = zod
  .object({
    slug: zod.coerce.string(),
    memberNo: zod.coerce.string(),
  })
  .strict();

export const externalStorefrontOrdersControllerGetPointBalanceHeader = zod
  .object({
    "X-API-Key": zod.string().optional(),
  })
  .strict();

export const externalStorefrontOrdersControllerGetPointBalanceResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        balance: zod
          .object({
            total: zod
              .number()
              .describe("사용 가능 포인트(살아 있는 로트의 합)"),
            expiringSoon: zod
              .object({
                amount: zod.number().describe("만기가 가장 가까운 잔액"),
                expiresAt: zod.string(),
              })
              .strict()
              .nullable(),
          })
          .strict(),
        entries: zod
          .array(
            zod
              .object({
                id: zod.string(),
                type: zod.enum([
                  "CHARGE",
                  "SPEND",
                  "REFUND",
                  "DEDUCT",
                  "EXPIRE",
                ]),
                amount: zod
                  .number()
                  .describe("부호 있는 변동량(충전·환불 +, 사용·차감·만료 -)"),
                balanceAfter: zod.number(),
                orderNo: zod.object({}).nullable(),
                expiresAt: zod
                  .object({})
                  .nullable()
                  .describe("충전 로트의 사용기한 / 만료가 닫은 로트의 기한"),
                reason: zod.object({}).nullable(),
                actor: zod.object({}).nullable().describe("관리자 행위의 주체"),
                createdAt: zod.string(),
              })
              .strict(),
          )
          .describe("원장 이력(최신순, 최대 100건)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 장바구니 한 건을 주문으로 남기고 **구매번호**를 채번한다. 단가는 요청 본문에서 받지 않는다 — 서버가 카탈로그에서 다시 확정하므로 화면 금액이 조작돼도 주문 금액은 바뀌지 않는다. `clientOrderKey` 를 같이 보내면 재시도해도 주문이 한 건만 생긴다.
 * @summary 🛒 쇼핑몰 주문 등록 (파트너 API 키)
 */
export const externalStorefrontOrdersControllerCreateOrderParams = zod
  .object({
    slug: zod.coerce.string(),
  })
  .strict();

export const externalStorefrontOrdersControllerCreateOrderHeader = zod
  .object({
    "X-API-Key": zod.string().optional(),
  })
  .strict();

export const externalStorefrontOrdersControllerCreateOrderBody = zod
  .object({
    employeeNo: zod
      .string()
      .optional()
      .describe("주문자 사원번호. ERP 가 주문자를 특정하는 유일한 키다."),
    shipTo: zod
      .object({
        name: zod.string(),
        zip: zod.string(),
        address: zod.string(),
        tel: zod.string().optional(),
        siteCode: zod
          .string()
          .optional()
          .describe("기관 사업장 코드. ERP 가 코드를 쓰면 이 값으로 넘어간다."),
      })
      .strict(),
    items: zod.array(
      zod
        .object({
          itemId: zod.string().describe("품목 id"),
          offeringId: zod
            .string()
            .optional()
            .describe(
              "고른 오퍼 id. 한 품목을 여러 공급사가 대는 몰에서 필요하다. 없으면 대표(최저가) 오퍼로 확정한다.",
            ),
          quantity: zod.number(),
        })
        .strict(),
    ),
    clientOrderKey: zod
      .string()
      .optional()
      .describe(
        "몰이 만든 주문 키. 같은 키로 다시 보내면 새 주문 대신 **먼저 만든 주문**이 돌아온다. 네트워크가 끊겨 재시도할 때 같은 물건을 두 번 사는 것을 막는 자리다.",
      ),
  })
  .strict();

/**
 * `employeeNo` 를 주면 그 담당자의 주문만, 안 주면 그 몰의 전체 주문을 최신순으로 돌려준다.
 * @summary 🛒 쇼핑몰 주문 내역 (파트너 API 키)
 */
export const externalStorefrontOrdersControllerListOrdersParams = zod
  .object({
    slug: zod.coerce.string(),
  })
  .strict();

export const externalStorefrontOrdersControllerListOrdersQueryParams = zod
  .object({
    employeeNo: zod.coerce.string().optional(),
    offset: zod.unknown().optional(),
    limit: zod.unknown().optional(),
  })
  .strict();

export const externalStorefrontOrdersControllerListOrdersHeader = zod
  .object({
    "X-API-Key": zod.string().optional(),
  })
  .strict();

export const externalStorefrontOrdersControllerListOrdersResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        orders: zod.array(
          zod
            .object({
              orderNo: zod.string().describe("구매번호"),
              status: zod.enum([
                "PLACED",
                "QUOTING",
                "QUOTE_CLOSED",
                "SENT_TO_ERP",
                "CONTRACTED",
                "SHIPPING",
                "DELIVERED",
                "INSPECTED",
                "SETTLED",
                "CANCELED",
              ]),
              employeeNo: zod.string().nullish(),
              shipToName: zod.string(),
              shipToZip: zod.string(),
              shipToAddress: zod.string(),
              shipToTel: zod.string().nullish(),
              totalSupply: zod.number().describe("공급가액 합계"),
              totalVat: zod.number().describe("부가세 합계"),
              totalPayable: zod.number().describe("발주기관이 내는 금액"),
              erpRequisitionNo: zod
                .string()
                .nullish()
                .describe(
                  "KCL ERP 가 채번한 구매요구번호. 이 값이 들어오면 계약이 선다.",
                ),
              erpSentAt: zod.string().nullish(),
              erpRequisitionedAt: zod.string().nullish(),
              canceledAt: zod.string().nullish(),
              createdAt: zod.string(),
              items: zod.array(
                zod
                  .object({
                    seq: zod.number(),
                    itemId: zod.string(),
                    offeringId: zod.string().nullish(),
                    name: zod.string(),
                    spec: zod.string().nullish(),
                    unit: zod.string().nullish(),
                    quantity: zod.number(),
                    salePrice: zod.number().describe("주문 시점 판매가 스냅샷"),
                    priceTaxType: zod.enum(["EXCLUSIVE", "INCLUSIVE"]),
                    taxCategory: zod.enum(["TAXABLE", "EXEMPT", "ZERO_RATED"]),
                  })
                  .strict(),
              ),
              shipments: zod
                .array(
                  zod
                    .object({
                      id: zod.string(),
                      courierCode: zod.string().nullish(),
                      courierName: zod.string().nullish(),
                      trackingNo: zod.string().nullish(),
                      status: zod.enum([
                        "READY",
                        "SHIPPED",
                        "IN_TRANSIT",
                        "DELIVERED",
                        "CANCELED",
                      ]),
                      shippedAt: zod.string().nullish(),
                      deliveredAt: zod.string().nullish(),
                      note: zod.string().nullish(),
                      createdAt: zod.string(),
                      items: zod.array(
                        zod
                          .object({
                            itemId: zod.string(),
                            name: zod.string(),
                            quantity: zod.number(),
                          })
                          .strict(),
                      ),
                    })
                    .strict(),
                )
                .optional(),
            })
            .strict(),
        ),
        total: zod.number(),
        limit: zod.number(),
        offset: zod.number(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 🛒 쇼핑몰 주문 1건 (파트너 API 키)
 */
export const externalStorefrontOrdersControllerGetOrderParams = zod
  .object({
    slug: zod.coerce.string(),
    orderNo: zod.coerce.string(),
  })
  .strict();

export const externalStorefrontOrdersControllerGetOrderHeader = zod
  .object({
    "X-API-Key": zod.string().optional(),
  })
  .strict();

export const externalStorefrontOrdersControllerGetOrderResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        orderNo: zod.string().describe("구매번호"),
        status: zod.enum([
          "PLACED",
          "QUOTING",
          "QUOTE_CLOSED",
          "SENT_TO_ERP",
          "CONTRACTED",
          "SHIPPING",
          "DELIVERED",
          "INSPECTED",
          "SETTLED",
          "CANCELED",
        ]),
        employeeNo: zod.string().nullish(),
        shipToName: zod.string(),
        shipToZip: zod.string(),
        shipToAddress: zod.string(),
        shipToTel: zod.string().nullish(),
        totalSupply: zod.number().describe("공급가액 합계"),
        totalVat: zod.number().describe("부가세 합계"),
        totalPayable: zod.number().describe("발주기관이 내는 금액"),
        erpRequisitionNo: zod
          .string()
          .nullish()
          .describe(
            "KCL ERP 가 채번한 구매요구번호. 이 값이 들어오면 계약이 선다.",
          ),
        erpSentAt: zod.string().nullish(),
        erpRequisitionedAt: zod.string().nullish(),
        canceledAt: zod.string().nullish(),
        createdAt: zod.string(),
        items: zod.array(
          zod
            .object({
              seq: zod.number(),
              itemId: zod.string(),
              offeringId: zod.string().nullish(),
              name: zod.string(),
              spec: zod.string().nullish(),
              unit: zod.string().nullish(),
              quantity: zod.number(),
              salePrice: zod.number().describe("주문 시점 판매가 스냅샷"),
              priceTaxType: zod.enum(["EXCLUSIVE", "INCLUSIVE"]),
              taxCategory: zod.enum(["TAXABLE", "EXEMPT", "ZERO_RATED"]),
            })
            .strict(),
        ),
        shipments: zod
          .array(
            zod
              .object({
                id: zod.string(),
                courierCode: zod.string().nullish(),
                courierName: zod.string().nullish(),
                trackingNo: zod.string().nullish(),
                status: zod.enum([
                  "READY",
                  "SHIPPED",
                  "IN_TRANSIT",
                  "DELIVERED",
                  "CANCELED",
                ]),
                shippedAt: zod.string().nullish(),
                deliveredAt: zod.string().nullish(),
                note: zod.string().nullish(),
                createdAt: zod.string(),
                items: zod.array(
                  zod
                    .object({
                      itemId: zod.string(),
                      name: zod.string(),
                      quantity: zod.number(),
                    })
                    .strict(),
                ),
              })
              .strict(),
          )
          .optional(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * KCL ERP 가 채번한 구매요구번호를 받아 주문에 반영한다. **이 시점에 거래가 성립한다.** 같은 회신이 두 번 와도 조용히 통과한다 — 씨마켓 통지와 우리 되읽기 스윕이 같은 값을 들고 올 수 있고, 여기서 4xx 를 내면 씨마켓이 그것을 재시도 금지로 분류해 통지가 사라진다.
 * @summary 🛒 구매요구번호 회신 수신 (씨마켓이 호출)
 */
export const externalStorefrontOrdersControllerApplyRequisitionParams = zod
  .object({
    slug: zod.coerce.string(),
    orderNo: zod.coerce.string(),
  })
  .strict();

export const externalStorefrontOrdersControllerApplyRequisitionHeader = zod
  .object({
    "X-API-Key": zod.string().optional(),
  })
  .strict();

export const externalStorefrontOrdersControllerApplyRequisitionBody = zod
  .object({
    requisitionNo: zod.string().describe("KCL ERP 가 채번한 구매요구번호"),
    requisitionedAt: zod
      .string()
      .optional()
      .describe(
        "구매요구가 만들어진 시각. 씨마켓이 못 받은 경우가 있어 선택이며, 없으면 수신 시각으로 둔다.",
      ),
  })
  .strict();

export const externalStorefrontOrdersControllerApplyRequisitionResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        orderNo: zod.string().describe("구매번호"),
        status: zod.enum([
          "PLACED",
          "QUOTING",
          "QUOTE_CLOSED",
          "SENT_TO_ERP",
          "CONTRACTED",
          "SHIPPING",
          "DELIVERED",
          "INSPECTED",
          "SETTLED",
          "CANCELED",
        ]),
        employeeNo: zod.string().nullish(),
        shipToName: zod.string(),
        shipToZip: zod.string(),
        shipToAddress: zod.string(),
        shipToTel: zod.string().nullish(),
        totalSupply: zod.number().describe("공급가액 합계"),
        totalVat: zod.number().describe("부가세 합계"),
        totalPayable: zod.number().describe("발주기관이 내는 금액"),
        erpRequisitionNo: zod
          .string()
          .nullish()
          .describe(
            "KCL ERP 가 채번한 구매요구번호. 이 값이 들어오면 계약이 선다.",
          ),
        erpSentAt: zod.string().nullish(),
        erpRequisitionedAt: zod.string().nullish(),
        canceledAt: zod.string().nullish(),
        createdAt: zod.string(),
        items: zod.array(
          zod
            .object({
              seq: zod.number(),
              itemId: zod.string(),
              offeringId: zod.string().nullish(),
              name: zod.string(),
              spec: zod.string().nullish(),
              unit: zod.string().nullish(),
              quantity: zod.number(),
              salePrice: zod.number().describe("주문 시점 판매가 스냅샷"),
              priceTaxType: zod.enum(["EXCLUSIVE", "INCLUSIVE"]),
              taxCategory: zod.enum(["TAXABLE", "EXEMPT", "ZERO_RATED"]),
            })
            .strict(),
        ),
        shipments: zod
          .array(
            zod
              .object({
                id: zod.string(),
                courierCode: zod.string().nullish(),
                courierName: zod.string().nullish(),
                trackingNo: zod.string().nullish(),
                status: zod.enum([
                  "READY",
                  "SHIPPED",
                  "IN_TRANSIT",
                  "DELIVERED",
                  "CANCELED",
                ]),
                shippedAt: zod.string().nullish(),
                deliveredAt: zod.string().nullish(),
                note: zod.string().nullish(),
                createdAt: zod.string(),
                items: zod.array(
                  zod
                    .object({
                      itemId: zod.string(),
                      name: zod.string(),
                      quantity: zod.number(),
                    })
                    .strict(),
                ),
              })
              .strict(),
          )
          .optional(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 검수 세션과 진행 상태. 대조할 품목(CAS·용량)이 없는 주문은 세션 자체가 없어 null 이다.
 * @summary 🔬 수령검수 상태
 */
export const externalStorefrontOrdersControllerGetInspectionParams = zod
  .object({
    slug: zod.coerce.string(),
    orderNo: zod.coerce.string(),
  })
  .strict();

export const externalStorefrontOrdersControllerGetInspectionHeader = zod
  .object({
    "X-API-Key": zod.string().optional(),
  })
  .strict();

export const externalStorefrontOrdersControllerGetInspectionResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        status: zod.enum(["OPEN", "COMPLETED", "CANCELED"]),
        verificationUrl: zod
          .string()
          .nullish()
          .describe("담당자가 라벨을 촬영할 팝업 주소"),
        targetCount: zod.number().describe("대조 대상 줄 수"),
        completedAt: zod.string().nullish(),
        reportUrl: zod.string().nullish(),
        matchedCount: zod.number().nullish(),
        unmatchedCount: zod.number().nullish(),
        createdAt: zod.string(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 검수가 끝났음을 받아 **계산서 보류를 푼다.** 불일치가 남아 있어도 완료로 처리한다 — 게이트가 보는 것은 「대조가 전부 일치했는가」가 아니라 「검수를 마쳤는가」다. 같은 회신이 두 번 와도 조용히 통과한다.
 * @summary 🔬 수령검수 완료 수신 (검수 서버가 호출)
 */
export const externalStorefrontOrdersControllerCompleteInspectionParams = zod
  .object({
    slug: zod.coerce.string(),
    orderNo: zod.coerce.string(),
  })
  .strict();

export const externalStorefrontOrdersControllerCompleteInspectionHeader = zod
  .object({
    "X-API-Key": zod.string().optional(),
  })
  .strict();

export const externalStorefrontOrdersControllerCompleteInspectionBody = zod
  .object({
    reportUrl: zod.string().optional().describe("검수확인서 PDF 주소"),
    matchedCount: zod.number().optional().describe("대조가 일치한 줄 수"),
    unmatchedCount: zod
      .number()
      .optional()
      .describe(
        "불일치 줄 수. **남아 있어도 완료로 처리한다** — 게이트는 «마쳤는가» 만 본다.",
      ),
  })
  .strict();

export const externalStorefrontOrdersControllerCompleteInspectionResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        orderNo: zod.string().describe("구매번호"),
        status: zod.enum([
          "PLACED",
          "QUOTING",
          "QUOTE_CLOSED",
          "SENT_TO_ERP",
          "CONTRACTED",
          "SHIPPING",
          "DELIVERED",
          "INSPECTED",
          "SETTLED",
          "CANCELED",
        ]),
        employeeNo: zod.string().nullish(),
        shipToName: zod.string(),
        shipToZip: zod.string(),
        shipToAddress: zod.string(),
        shipToTel: zod.string().nullish(),
        totalSupply: zod.number().describe("공급가액 합계"),
        totalVat: zod.number().describe("부가세 합계"),
        totalPayable: zod.number().describe("발주기관이 내는 금액"),
        erpRequisitionNo: zod
          .string()
          .nullish()
          .describe(
            "KCL ERP 가 채번한 구매요구번호. 이 값이 들어오면 계약이 선다.",
          ),
        erpSentAt: zod.string().nullish(),
        erpRequisitionedAt: zod.string().nullish(),
        canceledAt: zod.string().nullish(),
        createdAt: zod.string(),
        items: zod.array(
          zod
            .object({
              seq: zod.number(),
              itemId: zod.string(),
              offeringId: zod.string().nullish(),
              name: zod.string(),
              spec: zod.string().nullish(),
              unit: zod.string().nullish(),
              quantity: zod.number(),
              salePrice: zod.number().describe("주문 시점 판매가 스냅샷"),
              priceTaxType: zod.enum(["EXCLUSIVE", "INCLUSIVE"]),
              taxCategory: zod.enum(["TAXABLE", "EXEMPT", "ZERO_RATED"]),
            })
            .strict(),
        ),
        shipments: zod
          .array(
            zod
              .object({
                id: zod.string(),
                courierCode: zod.string().nullish(),
                courierName: zod.string().nullish(),
                trackingNo: zod.string().nullish(),
                status: zod.enum([
                  "READY",
                  "SHIPPED",
                  "IN_TRANSIT",
                  "DELIVERED",
                  "CANCELED",
                ]),
                shippedAt: zod.string().nullish(),
                deliveredAt: zod.string().nullish(),
                note: zod.string().nullish(),
                createdAt: zod.string(),
                items: zod.array(
                  zod
                    .object({
                      itemId: zod.string(),
                      name: zod.string(),
                      quantity: zod.number(),
                    })
                    .strict(),
                ),
              })
              .strict(),
          )
          .optional(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * ERP 로 나가기 전(PLACED)에만 취소된다. 전송된 뒤에는 구매요구가 KCL 안에서 돌고 있어 몰이 지울 수 없다 — 그때는 계약 취소 경로다.
 * @summary 🛒 쇼핑몰 주문 취소 (파트너 API 키)
 */
export const externalStorefrontOrdersControllerCancelOrderParams = zod
  .object({
    slug: zod.coerce.string(),
    orderNo: zod.coerce.string(),
  })
  .strict();

export const externalStorefrontOrdersControllerCancelOrderHeader = zod
  .object({
    "X-API-Key": zod.string().optional(),
  })
  .strict();

export const externalStorefrontOrdersControllerCancelOrderBody = zod
  .object({
    reason: zod.string().optional().describe("취소 사유"),
  })
  .strict();

export const externalStorefrontOrdersControllerCancelOrderResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        orderNo: zod.string().describe("구매번호"),
        status: zod.enum([
          "PLACED",
          "QUOTING",
          "QUOTE_CLOSED",
          "SENT_TO_ERP",
          "CONTRACTED",
          "SHIPPING",
          "DELIVERED",
          "INSPECTED",
          "SETTLED",
          "CANCELED",
        ]),
        employeeNo: zod.string().nullish(),
        shipToName: zod.string(),
        shipToZip: zod.string(),
        shipToAddress: zod.string(),
        shipToTel: zod.string().nullish(),
        totalSupply: zod.number().describe("공급가액 합계"),
        totalVat: zod.number().describe("부가세 합계"),
        totalPayable: zod.number().describe("발주기관이 내는 금액"),
        erpRequisitionNo: zod
          .string()
          .nullish()
          .describe(
            "KCL ERP 가 채번한 구매요구번호. 이 값이 들어오면 계약이 선다.",
          ),
        erpSentAt: zod.string().nullish(),
        erpRequisitionedAt: zod.string().nullish(),
        canceledAt: zod.string().nullish(),
        createdAt: zod.string(),
        items: zod.array(
          zod
            .object({
              seq: zod.number(),
              itemId: zod.string(),
              offeringId: zod.string().nullish(),
              name: zod.string(),
              spec: zod.string().nullish(),
              unit: zod.string().nullish(),
              quantity: zod.number(),
              salePrice: zod.number().describe("주문 시점 판매가 스냅샷"),
              priceTaxType: zod.enum(["EXCLUSIVE", "INCLUSIVE"]),
              taxCategory: zod.enum(["TAXABLE", "EXEMPT", "ZERO_RATED"]),
            })
            .strict(),
        ),
        shipments: zod
          .array(
            zod
              .object({
                id: zod.string(),
                courierCode: zod.string().nullish(),
                courierName: zod.string().nullish(),
                trackingNo: zod.string().nullish(),
                status: zod.enum([
                  "READY",
                  "SHIPPED",
                  "IN_TRANSIT",
                  "DELIVERED",
                  "CANCELED",
                ]),
                shippedAt: zod.string().nullish(),
                deliveredAt: zod.string().nullish(),
                note: zod.string().nullish(),
                createdAt: zod.string(),
                items: zod.array(
                  zod
                    .object({
                      itemId: zod.string(),
                      name: zod.string(),
                      quantity: zod.number(),
                    })
                    .strict(),
                ),
              })
              .strict(),
          )
          .optional(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 송장 등록 화면의 선택지. 코드를 자유 문자열로 두지 않는 이유는 나중에 조회 API 를 붙일 때 값들을 사람이 손으로 정리해야 하기 때문이다.
 * @summary 🚚 택배사 목록 (공급사)
 */
export const externalSupplierShipmentsControllerListCouriersResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            code: zod.string(),
            name: zod.string(),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 계약이 선 뒤부터 배송이 끝나기 전까지의 주문. **남은 수량이 있는 줄만** 온다 — 다 보낸 주문은 목록에서 빠지므로 열어 보고 아무것도 없음을 확인할 필요가 없다.
 * @summary 🚚 내가 보낼 몰 주문 (공급사)
 */
export const externalSupplierShipmentsControllerListMyTargetsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            orderNo: zod.string(),
            orderStatus: zod.string().describe("주문 상태"),
            orderedAt: zod.string(),
            shipTo: zod
              .object({
                name: zod.string(),
                zip: zod.string(),
                address: zod.string(),
                tel: zod.string().nullish(),
              })
              .strict(),
            items: zod
              .array(
                zod
                  .object({
                    id: zod.string(),
                    name: zod.string(),
                    spec: zod.string().nullish(),
                    unit: zod.string().nullish(),
                    quantity: zod.number().describe("주문 수량"),
                    shippedQuantity: zod
                      .number()
                      .describe("이미 송장에 실린 수량(취소 제외)"),
                  })
                  .strict(),
              )
              .describe(
                "내 몫 품목 중 **아직 남은 것만**. 다 보낸 줄은 오지 않는다.",
              ),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 🚚 주문의 배송 목록 (공급사 · 발주기관)
 */
export const externalSupplierShipmentsControllerListParams = zod
  .object({
    orderNo: zod.coerce.string(),
  })
  .strict();

export const externalSupplierShipmentsControllerListResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            id: zod.string(),
            courierCode: zod.string().nullish(),
            courierName: zod.string().nullish(),
            trackingNo: zod.string().nullish(),
            status: zod.enum([
              "READY",
              "SHIPPED",
              "IN_TRANSIT",
              "DELIVERED",
              "CANCELED",
            ]),
            shippedAt: zod.string().nullish(),
            deliveredAt: zod.string().nullish(),
            note: zod.string().nullish(),
            createdAt: zod.string(),
            items: zod.array(
              zod
                .object({
                  itemId: zod.string(),
                  name: zod.string(),
                  quantity: zod.number(),
                })
                .strict(),
            ),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 내 몫 품목에 송장을 건다. 주문 수량보다 많이 보낼 수 없고, 송장번호를 적었으면 택배사도 골라야 한다. 마지막 품목까지 도착하면 주문이 배송완료로 바뀐다.
 * @summary 🚚 송장 등록 (공급사)
 */
export const externalSupplierShipmentsControllerRegisterParams = zod
  .object({
    orderNo: zod.coerce.string(),
  })
  .strict();

export const externalSupplierShipmentsControllerRegisterBody = zod
  .object({
    courierCode: zod
      .string()
      .optional()
      .describe(
        "택배사 코드. 목록은 `GET …/couriers`. 직접 배송이면 `DIRECT`.",
      ),
    trackingNo: zod.string().optional().describe("송장번호"),
    status: zod
      .enum(["READY", "SHIPPED", "IN_TRANSIT", "DELIVERED", "CANCELED"])
      .optional()
      .describe("등록 시점 상태. 기본 `SHIPPED`(출고)."),
    note: zod.string().optional().describe("메모(분할 출고 사유 등)"),
    items: zod
      .array(
        zod
          .object({
            itemId: zod
              .string()
              .describe("주문 품목 id(`storefront_order_items.id`)"),
            quantity: zod.number().describe("이 송장에 실은 수량"),
          })
          .strict(),
      )
      .describe("이 송장에 실은 품목"),
  })
  .strict();

/**
 * 그 견적 공고를 낳은 KCL-MRO 몰 주문과 그 주문의 송장을 돌려줍니다. 몰에서 올라온 공고가 아니면 404 입니다.

볼 수 있는 사람은 배송 목록과 같습니다 — 발주기관은 자기 몰 주문, 공급사는 자기 계약이 걸린 주문.
 * @summary 🚚 견적 공고의 몰 주문·배송 현황 (공급사 · 발주기관)
 */
export const externalSupplierShipmentsControllerFindMallOrderParams = zod
  .object({
    quoteRequestId: zod.coerce.string(),
  })
  .strict();

export const externalSupplierShipmentsControllerFindMallOrderResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        orderNo: zod.string().describe("몰 주문번호"),
        status: zod
          .string()
          .describe(
            "주문 상태 — `PLACED` · `QUOTING` · `QUOTE_CLOSED` · `SENT_TO_ERP` · `CONTRACTED` · `SHIPPING` · `DELIVERED` · `INSPECTED` · `SETTLED` · `CANCELED`.",
          ),
        erpRequisitionNo: zod
          .string()
          .nullable()
          .describe("ERP 가 회신한 구매요구번호. 아직이면 null."),
        shipments: zod
          .array(
            zod
              .object({
                id: zod.string(),
                courierCode: zod.string().nullish(),
                courierName: zod.string().nullish(),
                trackingNo: zod.string().nullish(),
                status: zod.enum([
                  "READY",
                  "SHIPPED",
                  "IN_TRANSIT",
                  "DELIVERED",
                  "CANCELED",
                ]),
                shippedAt: zod.string().nullish(),
                deliveredAt: zod.string().nullish(),
                note: zod.string().nullish(),
                createdAt: zod.string(),
                items: zod.array(
                  zod
                    .object({
                      itemId: zod.string(),
                      name: zod.string(),
                      quantity: zod.number(),
                    })
                    .strict(),
                ),
              })
              .strict(),
          )
          .describe("이 주문에 걸린 송장. 아직 없으면 빈 배열이다."),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 출고 → 배송중 → 배송완료. 잘못 등록한 송장은 `CANCELED` 로 무른다.
 * @summary 🚚 배송 상태 변경 (공급사)
 */
export const externalSupplierShipmentsControllerUpdateStatusParams = zod
  .object({
    orderNo: zod.coerce.string(),
    shipmentId: zod.coerce.string(),
  })
  .strict();

export const externalSupplierShipmentsControllerUpdateStatusBody = zod
  .object({
    status: zod.enum([
      "READY",
      "SHIPPED",
      "IN_TRANSIT",
      "DELIVERED",
      "CANCELED",
    ]),
  })
  .strict();

export const externalSupplierShipmentsControllerUpdateStatusResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string(),
        courierCode: zod.string().nullish(),
        courierName: zod.string().nullish(),
        trackingNo: zod.string().nullish(),
        status: zod.enum([
          "READY",
          "SHIPPED",
          "IN_TRANSIT",
          "DELIVERED",
          "CANCELED",
        ]),
        shippedAt: zod.string().nullish(),
        deliveredAt: zod.string().nullish(),
        note: zod.string().nullish(),
        createdAt: zod.string(),
        items: zod.array(
          zod
            .object({
              itemId: zod.string(),
              name: zod.string(),
              quantity: zod.number(),
            })
            .strict(),
        ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 물품관리 표에 생길 단가 열 목록. 마스터가 허용해야 생긴다.
 * @summary 내가 열려 있는 쇼핑몰 (공급사)
 */
export const externalSupplierStorefrontsControllerListMineResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            storefrontId: zod.string(),
            slug: zod.string(),
            name: zod.string(),
            allowedItemCount: zod
              .number()
              .describe("이 쇼핑몰에 허용된 내 품목 수"),
            pricedItemCount: zod
              .number()
              .describe("그중 단가를 입력해 실제 노출 중인 수"),
            includeVat: zod
              .boolean()
              .describe(
                "이 몰의 표시가 축. false 면 공급가액(부가세 별도)으로 표시된다 — 입력 칸의 라벨이 이 값을 따라간다",
              ),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 물품관리 표 한 페이지분의 품목 id 를 넘기면 그 칸 값들을 준다.
 * @summary 품목별 내 쇼핑몰 단가 (공급사)
 */
export const externalSupplierStorefrontsControllerListMyPricesQueryParams = zod
  .object({
    itemIds: zod.coerce.string().describe("쉼표로 구분한 품목 UUID 목록"),
  })
  .strict();

export const externalSupplierStorefrontsControllerListMyPricesResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            storefrontId: zod.string(),
            itemId: zod.string(),
            price: zod
              .number()
              .nullish()
              .describe(
                "내가 이 쇼핑몰용으로 적은 단가. null 이면 아직 안 적었다",
              ),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 마스터가 허용한 조합에만 넣을 수 있다. 값을 넣는 순간 그 쇼핑몰에 노출된다.
 * @summary 쇼핑몰 단가 입력 (공급사)
 */
export const externalSupplierStorefrontsControllerSetPriceParams = zod
  .object({
    storefrontId: zod.coerce.string(),
    itemId: zod.coerce.string(),
  })
  .strict();

export const externalSupplierStorefrontsControllerSetPriceBody = zod
  .object({
    price: zod.number().describe("이 쇼핑몰에서 팔 단가(수수료 포함가)"),
  })
  .strict();

export const externalSupplierStorefrontsControllerSetPriceResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        storefrontId: zod.string(),
        itemId: zod.string(),
        price: zod.number(),
        isListed: zod.boolean().describe("이 값으로 쇼핑몰에 노출되는지"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 이 몰에 허용된 내 품목만 나온다. state 로 «노출 중 / 단가 미입력 / 노출 중지» 를 가른다.
 * @summary 내 몰 상품 목록 (공급사)
 */
export const externalSupplierStorefrontsControllerListMyOfferingsParams = zod
  .object({
    storefrontId: zod.coerce.string(),
  })
  .strict();

export const externalSupplierStorefrontsControllerListMyOfferingsQueryParams =
  zod
    .object({
      state: zod.enum(["all", "listed", "unpriced", "inactive"]).optional(),
      q: zod.coerce.string().optional(),
      offset: zod.unknown().optional(),
      limit: zod.unknown().optional(),
    })
    .strict();

export const externalSupplierStorefrontsControllerListMyOfferingsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              offeringId: zod.string(),
              itemId: zod.string(),
              name: zod.string(),
              manufacturer: zod.string().nullish(),
              spec1: zod.string().nullish(),
              unit: zod.string().nullish(),
              categoryName: zod.string().nullish(),
              imageUrl: zod.string().nullish(),
              basePrice: zod
                .number()
                .nullish()
                .describe("내 일반 공급가(참고용)"),
              enteredPrice: zod
                .number()
                .nullish()
                .describe(
                  "내가 이 몰용으로 적어 넣은 값. 연동 중이면 비어 있다",
                ),
              price: zod
                .number()
                .nullish()
                .describe("실제 노출가. 연동이면 내 단가에서 계산된다"),
              priceSource: zod
                .enum(["manual", "linked"])
                .describe("linked 면 내 단가가 바뀔 때 몰가도 따라간다"),
              priceMarkupBp: zod.number().describe("연동 가산율(만분율)"),
              taxType: zod
                .string()
                .nullish()
                .describe("내가 적어 넣은 값의 부가세 축(기록용)"),
              taxCategory: zod
                .enum(["TAXABLE", "EXEMPT", "ZERO_RATED"])
                .nullish()
                .describe("품목의 과세 상태. 면세·영세는 부가세가 붙지 않는다"),
              state: zod
                .enum(["listed", "unpriced", "inactive"])
                .describe("노출 중 / 단가 미입력 / 노출 중지"),
              isActive: zod.boolean(),
            })
            .strict(),
        ),
        total: zod.number(),
        counts: zod
          .object({
            all: zod.number().describe("허용된 전체"),
            listed: zod.number().describe("노출 중"),
            unpriced: zod.number().describe("단가 미입력"),
            inactive: zod.number().describe("노출 중지"),
          })
          .strict()
          .describe("상태별 건수 — 화면 상단 퍼널에 쓴다"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * copy_base 는 내 단가를 그대로 복사하고, link 는 앞으로도 내 단가를 따라가게 한다. 기본은 미리보기(dryRun)이고, 이미 값이 있는 줄은 덮지 않는다.
 * @summary 몰 단가 일괄 설정 (공급사)
 */
export const externalSupplierStorefrontsControllerBulkSetPricesParams = zod
  .object({
    storefrontId: zod.coerce.string(),
  })
  .strict();

export const externalSupplierStorefrontsControllerBulkSetPricesBodyMarkupBpDefault = 0;
export const externalSupplierStorefrontsControllerBulkSetPricesBodyOverwriteDefault = false;
export const externalSupplierStorefrontsControllerBulkSetPricesBodyDryRunDefault = true;

export const externalSupplierStorefrontsControllerBulkSetPricesBody = zod
  .object({
    mode: zod
      .enum(["copy_base", "link", "unlink", "clear"])
      .describe(
        "copy_base=내 단가 복사 / link=내 단가에 연동(이후 자동 추종) / unlink=지금 값으로 굳히기 / clear=몰 단가 지우기",
      ),
    markupBp: zod
      .number()
      .default(
        externalSupplierStorefrontsControllerBulkSetPricesBodyMarkupBpDefault,
      )
      .describe("가산율(만분율)"),
    overwrite: zod
      .boolean()
      .default(
        externalSupplierStorefrontsControllerBulkSetPricesBodyOverwriteDefault,
      )
      .describe("이미 값이 있는 줄도 덮어쓸지. 기본은 빈 칸만 채운다"),
    itemIds: zod
      .array(zod.string())
      .optional()
      .describe("지정하면 그 품목만. 비우면 이 몰의 내 전 품목"),
    dryRun: zod
      .boolean()
      .default(
        externalSupplierStorefrontsControllerBulkSetPricesBodyDryRunDefault,
      ),
  })
  .strict();

export const externalSupplierStorefrontsControllerBulkSetPricesResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        dryRun: zod.boolean(),
        mode: zod.enum(["copy_base", "link", "unlink", "clear"]),
        targets: zod.number().describe("조건에 걸린 줄 수"),
        willChange: zod.number().describe("값이 바뀔(바뀐) 줄 수"),
        changed: zod.number().describe("실제로 바뀐 줄 수(dryRun 이면 0)"),
        skipped: zod.number().describe("조건에 안 맞아 건너뛴 줄 수"),
        noBasePrice: zod
          .number()
          .describe("공급사 단가가 없어 복사할 값이 없는 줄 수"),
        samples: zod
          .array(
            zod
              .object({
                name: zod.string(),
                oldPrice: zod.number().nullish(),
                newPrice: zod.number().nullish(),
                ratio: zod
                  .number()
                  .describe("변동 배수. 1 에서 멀수록 확인이 필요하다"),
              })
              .strict(),
          )
          .describe(
            "변동폭이 큰 순 최대 20건. 2만 건에서 오타를 찾는 유일한 창",
          ),
        batchId: zod.string().nullish(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 품절·단종을 한 번에 내린다. 승인은 남으므로 다시 켤 수 있다.
 * @summary 내 몰 상품 노출 일괄 중지/재개 (공급사)
 */
export const externalSupplierStorefrontsControllerBulkSetActiveParams = zod
  .object({
    storefrontId: zod.coerce.string(),
  })
  .strict();

export const externalSupplierStorefrontsControllerBulkSetActiveBodyDryRunDefault = true;

export const externalSupplierStorefrontsControllerBulkSetActiveBody = zod
  .object({
    supplierId: zod
      .string()
      .optional()
      .describe("업체 한정. 비우면 이 몰의 전 상품"),
    isActive: zod.boolean().describe("true=노출 재개, false=노출 중지"),
    itemIds: zod.array(zod.string()).optional(),
    dryRun: zod
      .boolean()
      .default(
        externalSupplierStorefrontsControllerBulkSetActiveBodyDryRunDefault,
      ),
  })
  .strict();

export const externalSupplierStorefrontsControllerBulkSetActiveResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        dryRun: zod.boolean(),
        willChange: zod.number(),
        changed: zod.number(),
        batchId: zod.string().nullish(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 허용되지 않은 품목에 단가를 넣으려 할 때 뜨는 안내의 «요청» 버튼이 이걸 부른다.
 * @summary 이 몰에 품목 승인 요청 (공급사)
 */
export const externalSupplierStorefrontsControllerRequestOfferingParams = zod
  .object({
    storefrontId: zod.coerce.string(),
  })
  .strict();

export const externalSupplierStorefrontsControllerRequestOfferingBody = zod
  .object({
    itemId: zod.string().describe("이 몰에 올리고 싶은 품목"),
    note: zod.string().optional().describe("마스터에게 남길 한마디"),
  })
  .strict();

/**
 * @summary 내 승인 요청 목록 (공급사)
 */
export const externalSupplierStorefrontsControllerListMyRequestsParams = zod
  .object({
    storefrontId: zod.coerce.string(),
  })
  .strict();

export const externalSupplierStorefrontsControllerListMyRequestsQueryParams =
  zod
    .object({
      status: zod.coerce.string().optional(),
      offset: zod.unknown().optional(),
      limit: zod.unknown().optional(),
    })
    .strict();

export const externalSupplierStorefrontsControllerListMyRequestsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string(),
              storefrontId: zod.string(),
              supplierId: zod.string(),
              supplierName: zod.string().nullish(),
              itemId: zod.string(),
              itemName: zod.string().nullish(),
              basePrice: zod.number().nullish(),
              note: zod.string().nullish(),
              status: zod.enum(["pending", "approved", "rejected"]),
              decisionNote: zod.string().nullish(),
              createdAt: zod.string(),
            })
            .strict(),
        ),
        total: zod.number(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 외부 임베드 세션에서 견적요청/견적응답 첨부파일을 SEMO 스토리지에 직접 업로드합니다. 최대 10개, 파일당 20MB.
 * @summary 🔼 외부 임시 파일 업로드 (C-Market 발주기관/공급사 공용, 24시간 자동 삭제)
 */
export const externalFilesControllerUploadTemporaryFilesBodyFilesMax = 10;

export const externalFilesControllerUploadTemporaryFilesBody = zod
  .object({
    files: zod
      .array(zod.instanceof(File))
      .max(externalFilesControllerUploadTemporaryFilesBodyFilesMax)
      .describe("업로드할 파일 (최대 10개, 각 파일 최대 20MB)"),
  })
  .strict();

/**
 * 외부 발주기관이 주소를 미리 저장하지 않고도 공고를 등록할 수 있도록 주소와 공고를 한 번에 받습니다. 내부적으로 주소를 upsert 한 뒤 그 ID 로 공고를 생성합니다.
 * @summary 발주기관 공고 등록 — 주소 인라인 입력
 */
export const externalQuoteRequestsControllerCreateWithAddressHeader = zod
  .object({
    "idempotency-key": zod.string(),
  })
  .strict();

export const externalQuoteRequestsControllerCreateWithAddressBodyManagerNameMax = 100;

export const externalQuoteRequestsControllerCreateWithAddressBodyPaymentMethodDefault =
  "postpaid";
export const externalQuoteRequestsControllerCreateWithAddressBodyItemsItemAmountMin = 0;

export const externalQuoteRequestsControllerCreateWithAddressBodyAddressOneLabelMax = 50;

export const externalQuoteRequestsControllerCreateWithAddressBodyAddressOnePostalCodeMax = 10;

export const externalQuoteRequestsControllerCreateWithAddressBodyAddressOneProvinceMax = 50;

export const externalQuoteRequestsControllerCreateWithAddressBodyAddressOneCityMax = 50;

export const externalQuoteRequestsControllerCreateWithAddressBodyAddressOneDistrictMax = 50;

export const externalQuoteRequestsControllerCreateWithAddressBodyAddressOneStreetAddressMax = 200;

export const externalQuoteRequestsControllerCreateWithAddressBodyAddressOneAddressDetailMax = 200;

export const externalQuoteRequestsControllerCreateWithAddressBodyAddressOneRecipientNameMax = 50;

export const externalQuoteRequestsControllerCreateWithAddressBodyAddressOneRecipientPhoneMax = 20;

export const externalQuoteRequestsControllerCreateWithAddressBody = zod
  .object({
    projectName: zod
      .string()
      .optional()
      .describe(
        "프로젝트명 (물품 구매(product) 카테고리는 선택 — 미입력 시 물품 목록으로 자동 생성, 그 외 카테고리는 필수)",
      ),
    categoryType: zod
      .enum(["product", "construction", "manufacturing", "used"])
      .describe("카테고리 타입"),
    managerContact: zod.string().describe("담당자 연락처 (필수)"),
    managerName: zod
      .string()
      .max(externalQuoteRequestsControllerCreateWithAddressBodyManagerNameMax)
      .describe("담당자명"),
    addressDetail: zod
      .string()
      .nullish()
      .describe("주소 상세정보 (예: 동 101호, 3층 등의 추가 정보)"),
    description: zod.string().nullish().describe("견적 요청 설명 및 추가 사항"),
    budgetType: zod
      .enum(["public", "no_budget"])
      .nullish()
      .describe("예산 타입"),
    budgetAmount: zod.number().nullish().describe("예산 금액 (원화)"),
    paymentMethod: zod
      .enum(["prepaid", "postpaid"])
      .default(
        externalQuoteRequestsControllerCreateWithAddressBodyPaymentMethodDefault,
      )
      .describe("결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)"),
    preferredPaymentChannel: zod
      .enum(["card", "cash", "undecided"])
      .optional()
      .describe(
        "공고 결제방법. card/cash/undecided. 미전달 시 미결정으로 취급. paymentMethod(선결제/후불)와 다른 축이다.",
      ),
    sameRegionOnly: zod.boolean().nullish().describe("동일 지역만 선택 여부"),
    isPublic: zod.boolean().nullish().describe("공개 여부"),
    dueDateValue: zod
      .enum(["구체적", "협의가능"])
      .nullish()
      .describe("배송일 값 (사용자 입력값)"),
    dueDate: zod.string().nullish().describe("배송일 (ISO 8601 형식)"),
    attachments: zod
      .array(
        zod
          .object({
            fileName: zod.string().describe("파일명"),
            url: zod.string().url().describe("파일 공개 URL"),
            filePath: zod
              .string()
              .optional()
              .describe(
                "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
              ),
            fileSize: zod.number().describe("파일 크기 (바이트)"),
            contentType: zod.string().optional().describe("MIME 타입"),
          })
          .strict(),
      )
      .nullish()
      .describe("업로드된 파일들의 메타데이터 배열"),
    items: zod
      .array(
        zod
          .object({
            name: zod.string().describe("품목명"),
            quantity: zod.number().min(1).describe("수량"),
            unit: zod.string().describe("단위 (예: 세트, EA, 박스)"),
            amount: zod
              .number()
              .min(
                externalQuoteRequestsControllerCreateWithAddressBodyItemsItemAmountMin,
              )
              .describe("금액 (원 단위, 예상 금액 또는 0)"),
            spec1: zod.string().optional().describe("규격 1"),
            spec2: zod.string().optional().describe("규격 2"),
            spec3: zod.string().optional().describe("규격 3"),
            itemCode: zod.string().optional().describe("품목 코드"),
            manufacturer: zod.string().optional().describe("제조사"),
            brand: zod.string().optional().describe("브랜드"),
            itemId: zod
              .string()
              .optional()
              .describe(
                "품목 ID (items_v2_base.id) - 자동완성 선택 시에만 제공",
              ),
          })
          .strict(),
      )
      .nullish()
      .describe("항목 목록 (Product 카테고리에만 필수)"),
    additionalConditions: zod
      .array(
        zod
          .object({
            value: zod.string().describe("English code identifier"),
            label: zod.string().describe("Korean UI label for display"),
          })
          .strict(),
      )
      .nullish()
      .describe("추가 조건 (물품 구매 카테고리 전용)"),
    additionalRequests: zod
      .array(
        zod
          .object({
            value: zod.string().describe("English code identifier"),
            label: zod.string().describe("Korean UI label for display"),
          })
          .strict(),
      )
      .nullish()
      .describe("추가 요청사항 (모든 카테고리 선택 가능)"),
    constructionType: zod
      .object({
        value: zod
          .enum([
            "facility_maintenance",
            "interior_architecture",
            "waterproofing_plaster_painting",
            "mechanical_equipment",
            "metal_structure_window",
            "paving",
            "electrical",
            "scaffolding_demolition",
            "asbestos_removal",
            "rebar_concrete",
            "fire_safety",
            "landscaping",
            "roofing_assembly",
            "elevator",
            "gas_facility",
            "hvac",
            "telecommunications",
            "cctv",
            "365_corner",
            "civil_construction",
            "building_construction",
            "specialized_construction",
            "water_sewage",
            "stone_work",
            "earthwork",
            "grouting",
            "dredging",
            "outdoor_signage",
            "other",
          ])
          .describe("Construction type code"),
        label: zod.string().describe("Korean label for display"),
      })
      .strict()
      .nullish()
      .describe("공사 타입 (공사 카테고리 전용)"),
    spaceType: zod
      .object({
        value: zod
          .enum(["office", "retail", "factory", "warehouse"])
          .describe("Space type code"),
        label: zod.string().describe("Korean label for display"),
      })
      .strict()
      .nullish()
      .describe("공간 타입 (공사 카테고리 전용)"),
    constructionArea: zod
      .object({
        value: zod
          .enum(["30", "50", "100", "200"])
          .describe("Construction area code"),
        label: zod.string().describe("Korean label for display"),
      })
      .strict()
      .nullish()
      .describe("공사 면적 (공사 카테고리 전용)"),
    address: zod
      .object({
        label: zod
          .string()
          .max(
            externalQuoteRequestsControllerCreateWithAddressBodyAddressOneLabelMax,
          )
          .optional()
          .describe("주소 라벨"),
        isDefault: zod.boolean().describe("기본 주소 설정"),
        postalCode: zod
          .string()
          .max(
            externalQuoteRequestsControllerCreateWithAddressBodyAddressOnePostalCodeMax,
          )
          .describe("우편번호"),
        province: zod
          .string()
          .max(
            externalQuoteRequestsControllerCreateWithAddressBodyAddressOneProvinceMax,
          )
          .describe("시/도"),
        city: zod
          .string()
          .max(
            externalQuoteRequestsControllerCreateWithAddressBodyAddressOneCityMax,
          )
          .describe("시/군/구"),
        district: zod
          .string()
          .max(
            externalQuoteRequestsControllerCreateWithAddressBodyAddressOneDistrictMax,
          )
          .nullish()
          .describe("읍/면/동 (누락 시 null 저장)"),
        streetAddress: zod
          .string()
          .max(
            externalQuoteRequestsControllerCreateWithAddressBodyAddressOneStreetAddressMax,
          )
          .describe("도로명 주소"),
        addressDetail: zod
          .string()
          .max(
            externalQuoteRequestsControllerCreateWithAddressBodyAddressOneAddressDetailMax,
          )
          .optional()
          .describe("상세 주소"),
        recipientName: zod
          .string()
          .max(
            externalQuoteRequestsControllerCreateWithAddressBodyAddressOneRecipientNameMax,
          )
          .describe("수령인 이름"),
        recipientPhone: zod
          .string()
          .max(
            externalQuoteRequestsControllerCreateWithAddressBodyAddressOneRecipientPhoneMax,
          )
          .optional()
          .describe("수령인 연락처"),
      })
      .strict()
      .describe("신규/재사용할 주소 정보 (addresses 테이블에 upsert)"),
    isPrepaid: zod
      .boolean()
      .optional()
      .describe(
        "결제 방법. true=선결제, false=후불결제. 미전달 시 SEMO default(선결제).",
      ),
  })
  .strict();

/**
 * @summary 전체 견적 요청 목록 조회 (공급사 · 발주기관)
 */
export const externalQuoteRequestsControllerFindAllQueryPageDefault = 1;

export const externalQuoteRequestsControllerFindAllQueryLimitDefault = 20;
export const externalQuoteRequestsControllerFindAllQueryLimitMax = 100;

export const externalQuoteRequestsControllerFindAllQuerySortByDefault =
  "created_at";
export const externalQuoteRequestsControllerFindAllQuerySortOrderDefault =
  "desc";

export const externalQuoteRequestsControllerFindAllQueryParams = zod
  .object({
    page: zod.coerce
      .number()
      .min(1)
      .default(externalQuoteRequestsControllerFindAllQueryPageDefault)
      .describe("페이지 번호"),
    limit: zod.coerce
      .number()
      .min(1)
      .max(externalQuoteRequestsControllerFindAllQueryLimitMax)
      .default(externalQuoteRequestsControllerFindAllQueryLimitDefault)
      .describe("페이지당 항목 수"),
    sortBy: zod.coerce
      .string()
      .default(externalQuoteRequestsControllerFindAllQuerySortByDefault)
      .describe("정렬 필드"),
    sortOrder: zod
      .enum(["asc", "desc"])
      .default(externalQuoteRequestsControllerFindAllQuerySortOrderDefault)
      .describe("정렬 순서"),
    search: zod.coerce.string().optional().describe("검색어"),
    status: zod
      .array(
        zod.enum(["IN_PROGRESS", "ON_HOLD", "CLOSED", "CONTRACT_IN_PROGRESS"]),
      )
      .optional()
      .describe("견적 요청 상태 필터"),
    isClosed: zod.coerce
      .boolean()
      .optional()
      .describe("마감 여부 필터 (서버 시각 기준)"),
  })
  .strict();

export const externalQuoteRequestsControllerFindAllResponseTwoDataItemsItemPaymentMethodDefault =
  "postpaid";

export const externalQuoteRequestsControllerFindAllResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("견적 요청 ID (UUID)"),
              requestNumber: zod.string().describe("견적 요청 번호"),
              projectName: zod.string().describe("프로젝트명"),
              organizationName: zod
                .string()
                .nullish()
                .describe(
                  "발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)",
                ),
              status: zod
                .enum([
                  "IN_PROGRESS",
                  "ON_HOLD",
                  "CLOSED",
                  "CONTRACT_IN_PROGRESS",
                ])
                .describe("상태"),
              categoryType: zod
                .enum(["product", "construction", "manufacturing", "used"])
                .describe("카테고리 타입"),
              deadline: zod.string().describe("마감일"),
              createdAt: zod.string().nullish().describe("생성일 (ISO 8601)"),
              updatedAt: zod.string().nullish().describe("수정일 (ISO 8601)"),
              userId: zod.string().describe("사용자 ID (UUID)"),
              managerName: zod.string().nullish().describe("담당자명"),
              managerContact: zod.string().nullish().describe("담당자 연락처"),
              addressId: zod.string().nullish().describe("주소 ID"),
              address: zod
                .object({
                  province: zod.string().describe("시/도"),
                  city: zod.string().describe("시/군/구"),
                  district: zod.string().nullish().describe("읍/면/동"),
                  label: zod
                    .string()
                    .nullish()
                    .describe("배송지 이름 (예: 회사) (작성자 본인만)"),
                  postalCode: zod
                    .string()
                    .nullish()
                    .describe("우편번호 (작성자 본인만)"),
                  addressLine1: zod
                    .string()
                    .nullish()
                    .describe("기본주소 (작성자 본인만)"),
                  addressLine2: zod
                    .string()
                    .nullish()
                    .describe("상세주소 (작성자 본인만)"),
                  recipientName: zod
                    .string()
                    .nullish()
                    .describe("수령인 (작성자 본인만)"),
                })
                .strict()
                .nullish()
                .describe("지역 정보"),
              sameRegionOnly: zod.boolean().nullish().describe("동일 지역만"),
              budgetType: zod
                .enum(["public", "no_budget"])
                .nullish()
                .describe("예산 타입"),
              budgetAmount: zod.number().nullish().describe("예산 금액"),
              paymentMethod: zod
                .enum(["prepaid", "postpaid"])
                .describe(
                  "결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)",
                ),
              isPrepaid: zod
                .boolean()
                .describe(
                  "결제 방법 (boolean form). true=선결제, false=후불결제.",
                ),
              preferredPaymentChannel: zod
                .enum(["card", "cash", "undecided"])
                .nullable()
                .describe(
                  "공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.",
                ),
              isPublic: zod.boolean().nullish().describe("공개 여부"),
              dueDateValue: zod
                .enum(["구체적", "협의가능"])
                .nullish()
                .describe("배송일 (구체적/협의가능)"),
              dueDate: zod
                .string()
                .nullish()
                .describe("희망 배송일 (ISO 8601)"),
              constructionType: zod
                .object({
                  value: zod
                    .enum([
                      "facility_maintenance",
                      "interior_architecture",
                      "waterproofing_plaster_painting",
                      "mechanical_equipment",
                      "metal_structure_window",
                      "paving",
                      "electrical",
                      "scaffolding_demolition",
                      "asbestos_removal",
                      "rebar_concrete",
                      "fire_safety",
                      "landscaping",
                      "roofing_assembly",
                      "elevator",
                      "gas_facility",
                      "hvac",
                      "telecommunications",
                      "cctv",
                      "365_corner",
                      "civil_construction",
                      "building_construction",
                      "specialized_construction",
                      "water_sewage",
                      "stone_work",
                      "earthwork",
                      "grouting",
                      "dredging",
                      "outdoor_signage",
                      "other",
                    ])
                    .describe("Construction type code"),
                  label: zod.string().describe("Korean label for display"),
                })
                .strict()
                .nullish()
                .describe("공사 유형"),
              spaceType: zod
                .object({
                  value: zod
                    .enum(["office", "retail", "factory", "warehouse"])
                    .describe("Space type code"),
                  label: zod.string().describe("Korean label for display"),
                })
                .strict()
                .nullish()
                .describe("공간 유형"),
              constructionArea: zod
                .object({
                  value: zod
                    .enum(["30", "50", "100", "200"])
                    .describe("Construction area code"),
                  label: zod.string().describe("Korean label for display"),
                })
                .strict()
                .nullish()
                .describe("공사 면적"),
              responseCount: zod.number().describe("받은 견적 응답 개수"),
              hasResponded: zod
                .boolean()
                .nullish()
                .describe("현재 판매자의 응답 여부"),
              quoteResponseId: zod
                .string()
                .optional()
                .describe("판매자가 작성한 견적 응답 ID"),
              canAutoQuote: zod
                .boolean()
                .optional()
                .describe("자동 견적 가능 여부 (공급자 전용)"),
              hasMyContract: zod
                .boolean()
                .nullish()
                .describe(
                  "현재 판매자 본인의 비취소 계약 존재 여부 (공급자 전용). 견적요청 단위 status=CONTRACT_IN_PROGRESS 와 달리 타사 계약에는 켜지지 않는다. null=판정 불가(발주기관 조회 등).",
                ),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 나의 공고 목록 조회 (발주기관 전용)
 */
export const externalQuoteRequestsControllerFindMineQueryPageDefault = 1;

export const externalQuoteRequestsControllerFindMineQueryLimitDefault = 20;
export const externalQuoteRequestsControllerFindMineQueryLimitMax = 100;

export const externalQuoteRequestsControllerFindMineQuerySortByDefault =
  "created_at";
export const externalQuoteRequestsControllerFindMineQuerySortOrderDefault =
  "desc";

export const externalQuoteRequestsControllerFindMineQueryParams = zod
  .object({
    page: zod.coerce
      .number()
      .min(1)
      .default(externalQuoteRequestsControllerFindMineQueryPageDefault)
      .describe("페이지 번호"),
    limit: zod.coerce
      .number()
      .min(1)
      .max(externalQuoteRequestsControllerFindMineQueryLimitMax)
      .default(externalQuoteRequestsControllerFindMineQueryLimitDefault)
      .describe("페이지당 항목 수"),
    sortBy: zod.coerce
      .string()
      .default(externalQuoteRequestsControllerFindMineQuerySortByDefault)
      .describe("정렬 필드"),
    sortOrder: zod
      .enum(["asc", "desc"])
      .default(externalQuoteRequestsControllerFindMineQuerySortOrderDefault)
      .describe("정렬 순서"),
    search: zod.coerce.string().optional().describe("검색어"),
    status: zod
      .array(
        zod.enum(["IN_PROGRESS", "ON_HOLD", "CLOSED", "CONTRACT_IN_PROGRESS"]),
      )
      .optional()
      .describe("견적 요청 상태 필터"),
    isClosed: zod.coerce
      .boolean()
      .optional()
      .describe("마감 여부 필터 (서버 시각 기준)"),
  })
  .strict();

export const externalQuoteRequestsControllerFindMineResponseTwoDataItemsItemPaymentMethodDefault =
  "postpaid";

export const externalQuoteRequestsControllerFindMineResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("견적 요청 ID (UUID)"),
              requestNumber: zod.string().describe("견적 요청 번호"),
              projectName: zod.string().describe("프로젝트명"),
              organizationName: zod
                .string()
                .nullish()
                .describe(
                  "발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)",
                ),
              status: zod
                .enum([
                  "IN_PROGRESS",
                  "ON_HOLD",
                  "CLOSED",
                  "CONTRACT_IN_PROGRESS",
                ])
                .describe("상태"),
              categoryType: zod
                .enum(["product", "construction", "manufacturing", "used"])
                .describe("카테고리 타입"),
              deadline: zod.string().describe("마감일"),
              createdAt: zod.string().nullish().describe("생성일 (ISO 8601)"),
              updatedAt: zod.string().nullish().describe("수정일 (ISO 8601)"),
              userId: zod.string().describe("사용자 ID (UUID)"),
              managerName: zod.string().nullish().describe("담당자명"),
              managerContact: zod.string().nullish().describe("담당자 연락처"),
              addressId: zod.string().nullish().describe("주소 ID"),
              address: zod
                .object({
                  province: zod.string().describe("시/도"),
                  city: zod.string().describe("시/군/구"),
                  district: zod.string().nullish().describe("읍/면/동"),
                  label: zod
                    .string()
                    .nullish()
                    .describe("배송지 이름 (예: 회사) (작성자 본인만)"),
                  postalCode: zod
                    .string()
                    .nullish()
                    .describe("우편번호 (작성자 본인만)"),
                  addressLine1: zod
                    .string()
                    .nullish()
                    .describe("기본주소 (작성자 본인만)"),
                  addressLine2: zod
                    .string()
                    .nullish()
                    .describe("상세주소 (작성자 본인만)"),
                  recipientName: zod
                    .string()
                    .nullish()
                    .describe("수령인 (작성자 본인만)"),
                })
                .strict()
                .nullish()
                .describe("지역 정보"),
              sameRegionOnly: zod.boolean().nullish().describe("동일 지역만"),
              budgetType: zod
                .enum(["public", "no_budget"])
                .nullish()
                .describe("예산 타입"),
              budgetAmount: zod.number().nullish().describe("예산 금액"),
              paymentMethod: zod
                .enum(["prepaid", "postpaid"])
                .describe(
                  "결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)",
                ),
              isPrepaid: zod
                .boolean()
                .describe(
                  "결제 방법 (boolean form). true=선결제, false=후불결제.",
                ),
              preferredPaymentChannel: zod
                .enum(["card", "cash", "undecided"])
                .nullable()
                .describe(
                  "공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.",
                ),
              isPublic: zod.boolean().nullish().describe("공개 여부"),
              dueDateValue: zod
                .enum(["구체적", "협의가능"])
                .nullish()
                .describe("배송일 (구체적/협의가능)"),
              dueDate: zod
                .string()
                .nullish()
                .describe("희망 배송일 (ISO 8601)"),
              constructionType: zod
                .object({
                  value: zod
                    .enum([
                      "facility_maintenance",
                      "interior_architecture",
                      "waterproofing_plaster_painting",
                      "mechanical_equipment",
                      "metal_structure_window",
                      "paving",
                      "electrical",
                      "scaffolding_demolition",
                      "asbestos_removal",
                      "rebar_concrete",
                      "fire_safety",
                      "landscaping",
                      "roofing_assembly",
                      "elevator",
                      "gas_facility",
                      "hvac",
                      "telecommunications",
                      "cctv",
                      "365_corner",
                      "civil_construction",
                      "building_construction",
                      "specialized_construction",
                      "water_sewage",
                      "stone_work",
                      "earthwork",
                      "grouting",
                      "dredging",
                      "outdoor_signage",
                      "other",
                    ])
                    .describe("Construction type code"),
                  label: zod.string().describe("Korean label for display"),
                })
                .strict()
                .nullish()
                .describe("공사 유형"),
              spaceType: zod
                .object({
                  value: zod
                    .enum(["office", "retail", "factory", "warehouse"])
                    .describe("Space type code"),
                  label: zod.string().describe("Korean label for display"),
                })
                .strict()
                .nullish()
                .describe("공간 유형"),
              constructionArea: zod
                .object({
                  value: zod
                    .enum(["30", "50", "100", "200"])
                    .describe("Construction area code"),
                  label: zod.string().describe("Korean label for display"),
                })
                .strict()
                .nullish()
                .describe("공사 면적"),
              responseCount: zod.number().describe("받은 견적 응답 개수"),
              hasResponded: zod
                .boolean()
                .nullish()
                .describe("현재 판매자의 응답 여부"),
              quoteResponseId: zod
                .string()
                .optional()
                .describe("판매자가 작성한 견적 응답 ID"),
              canAutoQuote: zod
                .boolean()
                .optional()
                .describe("자동 견적 가능 여부 (공급자 전용)"),
              hasMyContract: zod
                .boolean()
                .nullish()
                .describe(
                  "현재 판매자 본인의 비취소 계약 존재 여부 (공급자 전용). 견적요청 단위 status=CONTRACT_IN_PROGRESS 와 달리 타사 계약에는 켜지지 않는다. null=판정 불가(발주기관 조회 등).",
                ),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 응답한 견적 요청 목록 조회 (공급자 전용)
 */
export const externalQuoteRequestsControllerFindRespondedQueryPageDefault = 1;

export const externalQuoteRequestsControllerFindRespondedQueryLimitDefault = 20;
export const externalQuoteRequestsControllerFindRespondedQueryLimitMax = 100;

export const externalQuoteRequestsControllerFindRespondedQuerySortByDefault =
  "created_at";
export const externalQuoteRequestsControllerFindRespondedQuerySortOrderDefault =
  "desc";

export const externalQuoteRequestsControllerFindRespondedQueryParams = zod
  .object({
    page: zod.coerce
      .number()
      .min(1)
      .default(externalQuoteRequestsControllerFindRespondedQueryPageDefault)
      .describe("페이지 번호"),
    limit: zod.coerce
      .number()
      .min(1)
      .max(externalQuoteRequestsControllerFindRespondedQueryLimitMax)
      .default(externalQuoteRequestsControllerFindRespondedQueryLimitDefault)
      .describe("페이지당 항목 수"),
    sortBy: zod.coerce
      .string()
      .default(externalQuoteRequestsControllerFindRespondedQuerySortByDefault)
      .describe("정렬 필드"),
    sortOrder: zod
      .enum(["asc", "desc"])
      .default(
        externalQuoteRequestsControllerFindRespondedQuerySortOrderDefault,
      )
      .describe("정렬 순서"),
    search: zod.coerce.string().optional().describe("검색어"),
    status: zod
      .array(
        zod.enum(["IN_PROGRESS", "ON_HOLD", "CLOSED", "CONTRACT_IN_PROGRESS"]),
      )
      .optional()
      .describe("견적 요청 상태 필터"),
    isClosed: zod.coerce
      .boolean()
      .optional()
      .describe("마감 여부 필터 (서버 시각 기준)"),
  })
  .strict();

export const externalQuoteRequestsControllerFindRespondedResponseTwoDataItemsItemPaymentMethodDefault =
  "postpaid";

export const externalQuoteRequestsControllerFindRespondedResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("견적 요청 ID (UUID)"),
              requestNumber: zod.string().describe("견적 요청 번호"),
              projectName: zod.string().describe("프로젝트명"),
              organizationName: zod
                .string()
                .nullish()
                .describe(
                  "발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)",
                ),
              status: zod
                .enum([
                  "IN_PROGRESS",
                  "ON_HOLD",
                  "CLOSED",
                  "CONTRACT_IN_PROGRESS",
                ])
                .describe("상태"),
              categoryType: zod
                .enum(["product", "construction", "manufacturing", "used"])
                .describe("카테고리 타입"),
              deadline: zod.string().describe("마감일"),
              createdAt: zod.string().nullish().describe("생성일 (ISO 8601)"),
              updatedAt: zod.string().nullish().describe("수정일 (ISO 8601)"),
              userId: zod.string().describe("사용자 ID (UUID)"),
              managerName: zod.string().nullish().describe("담당자명"),
              managerContact: zod.string().nullish().describe("담당자 연락처"),
              addressId: zod.string().nullish().describe("주소 ID"),
              address: zod
                .object({
                  province: zod.string().describe("시/도"),
                  city: zod.string().describe("시/군/구"),
                  district: zod.string().nullish().describe("읍/면/동"),
                  label: zod
                    .string()
                    .nullish()
                    .describe("배송지 이름 (예: 회사) (작성자 본인만)"),
                  postalCode: zod
                    .string()
                    .nullish()
                    .describe("우편번호 (작성자 본인만)"),
                  addressLine1: zod
                    .string()
                    .nullish()
                    .describe("기본주소 (작성자 본인만)"),
                  addressLine2: zod
                    .string()
                    .nullish()
                    .describe("상세주소 (작성자 본인만)"),
                  recipientName: zod
                    .string()
                    .nullish()
                    .describe("수령인 (작성자 본인만)"),
                })
                .strict()
                .nullish()
                .describe("지역 정보"),
              sameRegionOnly: zod.boolean().nullish().describe("동일 지역만"),
              budgetType: zod
                .enum(["public", "no_budget"])
                .nullish()
                .describe("예산 타입"),
              budgetAmount: zod.number().nullish().describe("예산 금액"),
              paymentMethod: zod
                .enum(["prepaid", "postpaid"])
                .describe(
                  "결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)",
                ),
              isPrepaid: zod
                .boolean()
                .describe(
                  "결제 방법 (boolean form). true=선결제, false=후불결제.",
                ),
              preferredPaymentChannel: zod
                .enum(["card", "cash", "undecided"])
                .nullable()
                .describe(
                  "공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.",
                ),
              isPublic: zod.boolean().nullish().describe("공개 여부"),
              dueDateValue: zod
                .enum(["구체적", "협의가능"])
                .nullish()
                .describe("배송일 (구체적/협의가능)"),
              dueDate: zod
                .string()
                .nullish()
                .describe("희망 배송일 (ISO 8601)"),
              constructionType: zod
                .object({
                  value: zod
                    .enum([
                      "facility_maintenance",
                      "interior_architecture",
                      "waterproofing_plaster_painting",
                      "mechanical_equipment",
                      "metal_structure_window",
                      "paving",
                      "electrical",
                      "scaffolding_demolition",
                      "asbestos_removal",
                      "rebar_concrete",
                      "fire_safety",
                      "landscaping",
                      "roofing_assembly",
                      "elevator",
                      "gas_facility",
                      "hvac",
                      "telecommunications",
                      "cctv",
                      "365_corner",
                      "civil_construction",
                      "building_construction",
                      "specialized_construction",
                      "water_sewage",
                      "stone_work",
                      "earthwork",
                      "grouting",
                      "dredging",
                      "outdoor_signage",
                      "other",
                    ])
                    .describe("Construction type code"),
                  label: zod.string().describe("Korean label for display"),
                })
                .strict()
                .nullish()
                .describe("공사 유형"),
              spaceType: zod
                .object({
                  value: zod
                    .enum(["office", "retail", "factory", "warehouse"])
                    .describe("Space type code"),
                  label: zod.string().describe("Korean label for display"),
                })
                .strict()
                .nullish()
                .describe("공간 유형"),
              constructionArea: zod
                .object({
                  value: zod
                    .enum(["30", "50", "100", "200"])
                    .describe("Construction area code"),
                  label: zod.string().describe("Korean label for display"),
                })
                .strict()
                .nullish()
                .describe("공사 면적"),
              responseCount: zod.number().describe("받은 견적 응답 개수"),
              hasResponded: zod
                .boolean()
                .nullish()
                .describe("현재 판매자의 응답 여부"),
              quoteResponseId: zod
                .string()
                .optional()
                .describe("판매자가 작성한 견적 응답 ID"),
              canAutoQuote: zod
                .boolean()
                .optional()
                .describe("자동 견적 가능 여부 (공급자 전용)"),
              hasMyContract: zod
                .boolean()
                .nullish()
                .describe(
                  "현재 판매자 본인의 비취소 계약 존재 여부 (공급자 전용). 견적요청 단위 status=CONTRACT_IN_PROGRESS 와 달리 타사 계약에는 켜지지 않는다. null=판정 불가(발주기관 조회 등).",
                ),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 견적 요청 상세 조회 (공급자 · 발주기관)
 */
export const externalQuoteRequestsControllerFindOneParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const externalQuoteRequestsControllerFindOneResponseTwoDataPaymentMethodDefault =
  "postpaid";

export const externalQuoteRequestsControllerFindOneResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("견적 요청 ID (UUID)"),
        requestNumber: zod.string().describe("견적 요청 번호"),
        projectName: zod.string().describe("프로젝트명"),
        userId: zod.string().describe("사용자 ID (작성자)"),
        isOwner: zod
          .boolean()
          .optional()
          .describe(
            "현재 인증 사용자가 이 견적 요청의 등록자인지 여부 (클라이언트 소유권 판단용)",
          ),
        status: zod
          .enum(["IN_PROGRESS", "ON_HOLD", "CLOSED", "CONTRACT_IN_PROGRESS"])
          .describe("상태"),
        categoryType: zod.enum(["product"]).describe("카테고리 타입"),
        managerName: zod.string().nullish().describe("담당자명"),
        managerContact: zod.string().nullish().describe("담당자 연락처"),
        organizationName: zod
          .string()
          .nullish()
          .describe(
            "발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)",
          ),
        organizationPhone: zod
          .string()
          .nullish()
          .describe(
            "발주기관 대표번호 (담당자 개인 휴대폰이 아니다. 공개 공고에서만, 비공개는 본인·어드민 외 null)",
          ),
        addressId: zod.string().describe("주소 ID"),
        address: zod
          .object({
            province: zod.string().describe("시/도"),
            city: zod.string().describe("시/군/구"),
            district: zod.string().nullish().describe("읍/면/동"),
            label: zod
              .string()
              .nullish()
              .describe("배송지 이름 (예: 회사) (작성자 본인만)"),
            postalCode: zod
              .string()
              .nullish()
              .describe("우편번호 (작성자 본인만)"),
            addressLine1: zod
              .string()
              .nullish()
              .describe("기본주소 (작성자 본인만)"),
            addressLine2: zod
              .string()
              .nullish()
              .describe("상세주소 (작성자 본인만)"),
            recipientName: zod
              .string()
              .nullish()
              .describe("수령인 (작성자 본인만)"),
          })
          .strict()
          .nullish()
          .describe("주소 정보"),
        description: zod.string().nullish().describe("설명"),
        budgetType: zod
          .enum(["public", "no_budget"])
          .nullish()
          .describe("예산 타입"),
        budgetAmount: zod.number().nullish().describe("예산 금액"),
        paymentMethod: zod
          .enum(["prepaid", "postpaid"])
          .describe("결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)"),
        isPrepaid: zod
          .boolean()
          .describe("결제 방법 (boolean form). true=선결제, false=후불결제."),
        preferredPaymentChannel: zod
          .enum(["card", "cash", "undecided"])
          .nullable()
          .describe(
            "공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.",
          ),
        sameRegionOnly: zod.boolean().nullish().describe("동일 지역만"),
        isPublic: zod.boolean().nullish().describe("공개 여부"),
        deadline: zod.string().describe("마감일"),
        createdAt: zod.string().nullish().describe("생성일 (ISO 8601)"),
        updatedAt: zod.string().nullish().describe("수정일 (ISO 8601)"),
        approvedAt: zod.string().nullish().describe("승인 일시 (ISO 8601)"),
        closedAt: zod.string().nullish().describe("마감 일시 (ISO 8601)"),
        closeReason: zod.string().nullish().describe("마감 사유"),
        onHoldAt: zod.string().nullish().describe("보류 일시 (ISO 8601)"),
        attachments: zod
          .array(
            zod
              .object({
                fileName: zod.string().describe("파일명"),
                url: zod.string().url().describe("파일 공개 URL"),
                filePath: zod
                  .string()
                  .optional()
                  .describe(
                    "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
                  ),
                fileSize: zod.number().describe("파일 크기 (바이트)"),
                contentType: zod.string().optional().describe("MIME 타입"),
              })
              .strict(),
          )
          .nullish()
          .describe("첨부파일 목록"),
        responseCount: zod.number().describe("견적 응답 수"),
        responses: zod
          .array(
            zod
              .object({
                id: zod.string().describe("견적 응답 ID"),
                supplierName: zod.string().describe("공급자명"),
                supplierId: zod.string().describe("공급자 ID (세모 내부 UUID)"),
                supplierMemberId: zod
                  .string()
                  .nullable()
                  .describe(
                    "씨마켓 공급사 회원 ID. 익명화 대상이거나 씨마켓 회원이 아니면 null",
                  ),
                totalAmount: zod.number().describe("견적 금액"),
                trustScore: zod.number().describe("공급자 신뢰 점수"),
                trustPercentile: zod
                  .number()
                  .nullish()
                  .describe("공급자 신뢰 백분위"),
                chatRoomId: zod.string().nullable().describe("채팅방 ID"),
                isAnonymous: zod
                  .boolean()
                  .describe("익명 여부 (블러 처리 필요)"),
                isContracted: zod.boolean().describe("계약 여부 (채팅방 기준)"),
                withdrawnAt: zod
                  .string()
                  .datetime({})
                  .nullish()
                  .describe(
                    "공급사가 견적을 철회한 시각 (ISO 8601). null 이면 철회 안 됨",
                  ),
                attachments: zod
                  .array(
                    zod
                      .object({
                        fileName: zod.string().describe("파일명"),
                        url: zod.string().url().describe("파일 공개 URL"),
                        filePath: zod
                          .string()
                          .optional()
                          .describe(
                            "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
                          ),
                        fileSize: zod.number().describe("파일 크기 (바이트)"),
                        contentType: zod
                          .string()
                          .optional()
                          .describe("MIME 타입"),
                      })
                      .strict(),
                  )
                  .describe(
                    "공급사 첨부. URL 은 1시간 서명. 익명화 대상이면 빈 배열",
                  ),
                createdAt: zod.string().describe("생성일"),
              })
              .strict(),
          )
          .describe("견적 응답 목록"),
        willGenerateAutoQuotes: zod.boolean().describe("자동 견적 발송 여부"),
        autoQuoteStatus: zod
          .enum(["none", "pending", "processing", "completed", "failed"])
          .describe("스마트 견적 생성 상태"),
        contracts: zod
          .array(
            zod
              .object({
                id: zod.string().uuid().describe("계약 ID (UUID)"),
                contractNumber: zod.string().describe("계약 번호 (UI 표시용)"),
                status: zod
                  .enum(["IN_PROGRESS", "COMPLETED", "CANCELED"])
                  .describe("계약 상태"),
                isCanceled: zod.boolean().describe("계약 취소 여부"),
                cancellationRequestedAt: zod
                  .string()
                  .nullish()
                  .describe("계약 취소 요청 일시 (ISO 8601)"),
                canceledAt: zod
                  .string()
                  .nullish()
                  .describe("계약 취소 완료 일시 (ISO 8601)"),
                cancellationReason: zod
                  .string()
                  .nullish()
                  .describe("계약 취소 사유"),
                supplierId: zod
                  .string()
                  .uuid()
                  .describe("계약 공급사 ID (UUID)"),
                supplierName: zod
                  .string()
                  .nullish()
                  .describe(
                    "계약 공급사 상호. 씨마켓 «계약 업체» 칸이 그리는 값 — 참여 업체 목록과 짝맞추지 않아도 되도록 여기서 함께 내려보낸다.",
                  ),
                quoteResponseVersionId: zod
                  .string()
                  .uuid()
                  .nullish()
                  .describe(
                    "이 계약이 선 견적 응답 **버전** id. 씨마켓이 이 계약의 결제창을 되짚는 유일한 키다 — 결제창 발행 시 이 값을 멱등키로 보냈고, 씨마켓은 그 값으로 계약 ↔ 결제창을 1:1 로 묶어 두었다.",
                  ),
                paymentChannel: zod
                  .enum(["cash", "card"])
                  .nullish()
                  .describe(
                    "발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.",
                  ),
                createdAt: zod.string().describe("계약 생성 일시 (ISO 8601)"),
              })
              .strict(),
          )
          .describe(
            "현재 사용자에게 노출 가능한 연결 계약 목록 (external 상세에서 제공)",
          ),
        dueDateValue: zod
          .enum(["구체적", "협의가능"])
          .nullish()
          .describe("배송일 (구체적/협의가능)"),
        dueDate: zod.string().nullish().describe("희망 배송일 (ISO 8601)"),
        additionalRequests: zod
          .array(
            zod
              .object({
                value: zod.string().describe("English code identifier"),
                label: zod.string().describe("Korean UI label for display"),
              })
              .strict(),
          )
          .nullish()
          .describe("추가 요청사항"),
        items: zod
          .array(
            zod
              .object({
                name: zod.string().describe("품목명"),
                quantity: zod.number().describe("수량"),
                unit: zod.string().describe("단위"),
                amount: zod.number().describe("금액"),
                spec1: zod.string().optional().describe("규격 1"),
                spec2: zod.string().optional().describe("규격 2"),
                spec3: zod.string().optional().describe("규격 3"),
                itemCode: zod.string().optional().describe("품목 코드"),
                manufacturer: zod.string().optional().describe("제조사"),
                brand: zod.string().optional().describe("브랜드"),
                itemId: zod.string().optional().describe("품목 ID"),
                itemName: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목명"),
                itemCodeMatch: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목 코드"),
                itemPrice: zod
                  .number()
                  .optional()
                  .describe("매칭된 표준 품목 단가"),
                itemImageUrl: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목 이미지 URL"),
                itemSpec: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목 규격 요약"),
              })
              .strict(),
          )
          .describe("물품 목록"),
        additionalConditions: zod
          .array(
            zod
              .object({
                value: zod.string().describe("English code identifier"),
                label: zod.string().describe("Korean UI label for display"),
              })
              .strict(),
          )
          .nullish()
          .describe("추가 조건"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 본인이 등록한 진행중 공고를 수정합니다. 응답(자동견적 포함)이 하나라도 있거나, 마감됐거나, 진행중이 아니면 409 로 거절합니다. 보내지 않은 필드는 그대로 유지됩니다(PATCH 시맨틱).

**attachments** — 보낸 배열로 목록을 통째로 교체합니다(부분 추가/삭제가 아닙니다). 키를 생략하면 기존 첨부가 유지되고, `[]` 또는 `null` 이면 전체 삭제됩니다. 저장되는 필드는 등록과 같은 `fileName`/`url`/`fileSize`/`contentType` 이며 `filePath` 는 보관하지 않습니다.

**projectName** — 물품(product) 카테고리에서 `items` 를 보내면서 `projectName` 을 생략하면 제목을 품목 기준으로 다시 만듭니다(1건이면 품목명, 2건 이상이면 `첫 품목명 외 N개`). `projectName` 을 명시하면 그 값이 우선합니다. `items` 를 보내지 않으면 제목은 건드리지 않습니다.
 * @summary 발주기관 공고 수정 — 참여 업체가 없을 때만
 */
export const externalQuoteRequestsControllerUpdateOneParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const externalQuoteRequestsControllerUpdateOneBodyManagerNameMax = 100;

export const externalQuoteRequestsControllerUpdateOneBodyPaymentMethodDefault =
  "postpaid";
export const externalQuoteRequestsControllerUpdateOneBodyItemsItemAmountMin = 0;

export const externalQuoteRequestsControllerUpdateOneBody = zod
  .object({
    projectName: zod
      .string()
      .optional()
      .describe(
        "프로젝트명 (물품 구매(product) 카테고리는 선택 — 미입력 시 물품 목록으로 자동 생성, 그 외 카테고리는 필수)",
      ),
    categoryType: zod
      .enum(["product", "construction", "manufacturing", "used"])
      .optional()
      .describe("카테고리 타입"),
    managerContact: zod.string().optional().describe("담당자 연락처 (필수)"),
    managerName: zod
      .string()
      .max(externalQuoteRequestsControllerUpdateOneBodyManagerNameMax)
      .optional()
      .describe("담당자명"),
    addressId: zod
      .string()
      .optional()
      .describe("주소 ID (addresses 테이블 외래키)"),
    addressDetail: zod
      .string()
      .nullish()
      .describe("주소 상세정보 (예: 동 101호, 3층 등의 추가 정보)"),
    description: zod.string().nullish().describe("견적 요청 설명 및 추가 사항"),
    budgetType: zod
      .enum(["public", "no_budget"])
      .nullish()
      .describe("예산 타입"),
    budgetAmount: zod.number().nullish().describe("예산 금액 (원화)"),
    paymentMethod: zod
      .enum(["prepaid", "postpaid"])
      .default(externalQuoteRequestsControllerUpdateOneBodyPaymentMethodDefault)
      .describe("결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)"),
    preferredPaymentChannel: zod
      .enum(["card", "cash", "undecided"])
      .optional()
      .describe(
        "공고 결제방법. card/cash/undecided. 미전달 시 미결정으로 취급. paymentMethod(선결제/후불)와 다른 축이다.",
      ),
    sameRegionOnly: zod.boolean().nullish().describe("동일 지역만 선택 여부"),
    isPublic: zod.boolean().nullish().describe("공개 여부"),
    dueDateValue: zod
      .enum(["구체적", "협의가능"])
      .nullish()
      .describe("배송일 값 (사용자 입력값)"),
    dueDate: zod.string().nullish().describe("배송일 (ISO 8601 형식)"),
    attachments: zod
      .array(
        zod
          .object({
            fileName: zod.string().describe("파일명"),
            url: zod.string().url().describe("파일 공개 URL"),
            filePath: zod
              .string()
              .optional()
              .describe(
                "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
              ),
            fileSize: zod.number().describe("파일 크기 (바이트)"),
            contentType: zod.string().optional().describe("MIME 타입"),
          })
          .strict(),
      )
      .nullish()
      .describe("업로드된 파일들의 메타데이터 배열"),
    items: zod
      .array(
        zod
          .object({
            name: zod.string().describe("품목명"),
            quantity: zod.number().min(1).describe("수량"),
            unit: zod.string().describe("단위 (예: 세트, EA, 박스)"),
            amount: zod
              .number()
              .min(
                externalQuoteRequestsControllerUpdateOneBodyItemsItemAmountMin,
              )
              .describe("금액 (원 단위, 예상 금액 또는 0)"),
            spec1: zod.string().optional().describe("규격 1"),
            spec2: zod.string().optional().describe("규격 2"),
            spec3: zod.string().optional().describe("규격 3"),
            itemCode: zod.string().optional().describe("품목 코드"),
            manufacturer: zod.string().optional().describe("제조사"),
            brand: zod.string().optional().describe("브랜드"),
            itemId: zod
              .string()
              .optional()
              .describe(
                "품목 ID (items_v2_base.id) - 자동완성 선택 시에만 제공",
              ),
          })
          .strict(),
      )
      .nullish()
      .describe("항목 목록 (Product 카테고리에만 필수)"),
    additionalConditions: zod
      .array(
        zod
          .object({
            value: zod.string().describe("English code identifier"),
            label: zod.string().describe("Korean UI label for display"),
          })
          .strict(),
      )
      .nullish()
      .describe("추가 조건 (물품 구매 카테고리 전용)"),
    additionalRequests: zod
      .array(
        zod
          .object({
            value: zod.string().describe("English code identifier"),
            label: zod.string().describe("Korean UI label for display"),
          })
          .strict(),
      )
      .nullish()
      .describe("추가 요청사항 (모든 카테고리 선택 가능)"),
    constructionType: zod
      .object({
        value: zod
          .enum([
            "facility_maintenance",
            "interior_architecture",
            "waterproofing_plaster_painting",
            "mechanical_equipment",
            "metal_structure_window",
            "paving",
            "electrical",
            "scaffolding_demolition",
            "asbestos_removal",
            "rebar_concrete",
            "fire_safety",
            "landscaping",
            "roofing_assembly",
            "elevator",
            "gas_facility",
            "hvac",
            "telecommunications",
            "cctv",
            "365_corner",
            "civil_construction",
            "building_construction",
            "specialized_construction",
            "water_sewage",
            "stone_work",
            "earthwork",
            "grouting",
            "dredging",
            "outdoor_signage",
            "other",
          ])
          .describe("Construction type code"),
        label: zod.string().describe("Korean label for display"),
      })
      .strict()
      .nullish()
      .describe("공사 타입 (공사 카테고리 전용)"),
    spaceType: zod
      .object({
        value: zod
          .enum(["office", "retail", "factory", "warehouse"])
          .describe("Space type code"),
        label: zod.string().describe("Korean label for display"),
      })
      .strict()
      .nullish()
      .describe("공간 타입 (공사 카테고리 전용)"),
    constructionArea: zod
      .object({
        value: zod
          .enum(["30", "50", "100", "200"])
          .describe("Construction area code"),
        label: zod.string().describe("Korean label for display"),
      })
      .strict()
      .nullish()
      .describe("공사 면적 (공사 카테고리 전용)"),
    isPrepaid: zod
      .boolean()
      .optional()
      .describe(
        "결제 방법. true=선결제, false=후불결제. 미전달 시 기존 값 유지(PATCH 시맨틱).",
      ),
  })
  .strict();

export const externalQuoteRequestsControllerUpdateOneResponseTwoDataPaymentMethodDefault =
  "postpaid";

export const externalQuoteRequestsControllerUpdateOneResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("견적 요청 ID (UUID)"),
        requestNumber: zod.string().describe("견적 요청 번호"),
        projectName: zod.string().describe("프로젝트명"),
        userId: zod.string().describe("사용자 ID (작성자)"),
        isOwner: zod
          .boolean()
          .optional()
          .describe(
            "현재 인증 사용자가 이 견적 요청의 등록자인지 여부 (클라이언트 소유권 판단용)",
          ),
        status: zod
          .enum(["IN_PROGRESS", "ON_HOLD", "CLOSED", "CONTRACT_IN_PROGRESS"])
          .describe("상태"),
        categoryType: zod.enum(["product"]).describe("카테고리 타입"),
        managerName: zod.string().nullish().describe("담당자명"),
        managerContact: zod.string().nullish().describe("담당자 연락처"),
        organizationName: zod
          .string()
          .nullish()
          .describe(
            "발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)",
          ),
        organizationPhone: zod
          .string()
          .nullish()
          .describe(
            "발주기관 대표번호 (담당자 개인 휴대폰이 아니다. 공개 공고에서만, 비공개는 본인·어드민 외 null)",
          ),
        addressId: zod.string().describe("주소 ID"),
        address: zod
          .object({
            province: zod.string().describe("시/도"),
            city: zod.string().describe("시/군/구"),
            district: zod.string().nullish().describe("읍/면/동"),
            label: zod
              .string()
              .nullish()
              .describe("배송지 이름 (예: 회사) (작성자 본인만)"),
            postalCode: zod
              .string()
              .nullish()
              .describe("우편번호 (작성자 본인만)"),
            addressLine1: zod
              .string()
              .nullish()
              .describe("기본주소 (작성자 본인만)"),
            addressLine2: zod
              .string()
              .nullish()
              .describe("상세주소 (작성자 본인만)"),
            recipientName: zod
              .string()
              .nullish()
              .describe("수령인 (작성자 본인만)"),
          })
          .strict()
          .nullish()
          .describe("주소 정보"),
        description: zod.string().nullish().describe("설명"),
        budgetType: zod
          .enum(["public", "no_budget"])
          .nullish()
          .describe("예산 타입"),
        budgetAmount: zod.number().nullish().describe("예산 금액"),
        paymentMethod: zod
          .enum(["prepaid", "postpaid"])
          .describe("결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)"),
        isPrepaid: zod
          .boolean()
          .describe("결제 방법 (boolean form). true=선결제, false=후불결제."),
        preferredPaymentChannel: zod
          .enum(["card", "cash", "undecided"])
          .nullable()
          .describe(
            "공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.",
          ),
        sameRegionOnly: zod.boolean().nullish().describe("동일 지역만"),
        isPublic: zod.boolean().nullish().describe("공개 여부"),
        deadline: zod.string().describe("마감일"),
        createdAt: zod.string().nullish().describe("생성일 (ISO 8601)"),
        updatedAt: zod.string().nullish().describe("수정일 (ISO 8601)"),
        approvedAt: zod.string().nullish().describe("승인 일시 (ISO 8601)"),
        closedAt: zod.string().nullish().describe("마감 일시 (ISO 8601)"),
        closeReason: zod.string().nullish().describe("마감 사유"),
        onHoldAt: zod.string().nullish().describe("보류 일시 (ISO 8601)"),
        attachments: zod
          .array(
            zod
              .object({
                fileName: zod.string().describe("파일명"),
                url: zod.string().url().describe("파일 공개 URL"),
                filePath: zod
                  .string()
                  .optional()
                  .describe(
                    "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
                  ),
                fileSize: zod.number().describe("파일 크기 (바이트)"),
                contentType: zod.string().optional().describe("MIME 타입"),
              })
              .strict(),
          )
          .nullish()
          .describe("첨부파일 목록"),
        responseCount: zod.number().describe("견적 응답 수"),
        responses: zod
          .array(
            zod
              .object({
                id: zod.string().describe("견적 응답 ID"),
                supplierName: zod.string().describe("공급자명"),
                supplierId: zod.string().describe("공급자 ID (세모 내부 UUID)"),
                supplierMemberId: zod
                  .string()
                  .nullable()
                  .describe(
                    "씨마켓 공급사 회원 ID. 익명화 대상이거나 씨마켓 회원이 아니면 null",
                  ),
                totalAmount: zod.number().describe("견적 금액"),
                trustScore: zod.number().describe("공급자 신뢰 점수"),
                trustPercentile: zod
                  .number()
                  .nullish()
                  .describe("공급자 신뢰 백분위"),
                chatRoomId: zod.string().nullable().describe("채팅방 ID"),
                isAnonymous: zod
                  .boolean()
                  .describe("익명 여부 (블러 처리 필요)"),
                isContracted: zod.boolean().describe("계약 여부 (채팅방 기준)"),
                withdrawnAt: zod
                  .string()
                  .datetime({})
                  .nullish()
                  .describe(
                    "공급사가 견적을 철회한 시각 (ISO 8601). null 이면 철회 안 됨",
                  ),
                attachments: zod
                  .array(
                    zod
                      .object({
                        fileName: zod.string().describe("파일명"),
                        url: zod.string().url().describe("파일 공개 URL"),
                        filePath: zod
                          .string()
                          .optional()
                          .describe(
                            "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
                          ),
                        fileSize: zod.number().describe("파일 크기 (바이트)"),
                        contentType: zod
                          .string()
                          .optional()
                          .describe("MIME 타입"),
                      })
                      .strict(),
                  )
                  .describe(
                    "공급사 첨부. URL 은 1시간 서명. 익명화 대상이면 빈 배열",
                  ),
                createdAt: zod.string().describe("생성일"),
              })
              .strict(),
          )
          .describe("견적 응답 목록"),
        willGenerateAutoQuotes: zod.boolean().describe("자동 견적 발송 여부"),
        autoQuoteStatus: zod
          .enum(["none", "pending", "processing", "completed", "failed"])
          .describe("스마트 견적 생성 상태"),
        contracts: zod
          .array(
            zod
              .object({
                id: zod.string().uuid().describe("계약 ID (UUID)"),
                contractNumber: zod.string().describe("계약 번호 (UI 표시용)"),
                status: zod
                  .enum(["IN_PROGRESS", "COMPLETED", "CANCELED"])
                  .describe("계약 상태"),
                isCanceled: zod.boolean().describe("계약 취소 여부"),
                cancellationRequestedAt: zod
                  .string()
                  .nullish()
                  .describe("계약 취소 요청 일시 (ISO 8601)"),
                canceledAt: zod
                  .string()
                  .nullish()
                  .describe("계약 취소 완료 일시 (ISO 8601)"),
                cancellationReason: zod
                  .string()
                  .nullish()
                  .describe("계약 취소 사유"),
                supplierId: zod
                  .string()
                  .uuid()
                  .describe("계약 공급사 ID (UUID)"),
                supplierName: zod
                  .string()
                  .nullish()
                  .describe(
                    "계약 공급사 상호. 씨마켓 «계약 업체» 칸이 그리는 값 — 참여 업체 목록과 짝맞추지 않아도 되도록 여기서 함께 내려보낸다.",
                  ),
                quoteResponseVersionId: zod
                  .string()
                  .uuid()
                  .nullish()
                  .describe(
                    "이 계약이 선 견적 응답 **버전** id. 씨마켓이 이 계약의 결제창을 되짚는 유일한 키다 — 결제창 발행 시 이 값을 멱등키로 보냈고, 씨마켓은 그 값으로 계약 ↔ 결제창을 1:1 로 묶어 두었다.",
                  ),
                paymentChannel: zod
                  .enum(["cash", "card"])
                  .nullish()
                  .describe(
                    "발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.",
                  ),
                createdAt: zod.string().describe("계약 생성 일시 (ISO 8601)"),
              })
              .strict(),
          )
          .describe(
            "현재 사용자에게 노출 가능한 연결 계약 목록 (external 상세에서 제공)",
          ),
        dueDateValue: zod
          .enum(["구체적", "협의가능"])
          .nullish()
          .describe("배송일 (구체적/협의가능)"),
        dueDate: zod.string().nullish().describe("희망 배송일 (ISO 8601)"),
        additionalRequests: zod
          .array(
            zod
              .object({
                value: zod.string().describe("English code identifier"),
                label: zod.string().describe("Korean UI label for display"),
              })
              .strict(),
          )
          .nullish()
          .describe("추가 요청사항"),
        items: zod
          .array(
            zod
              .object({
                name: zod.string().describe("품목명"),
                quantity: zod.number().describe("수량"),
                unit: zod.string().describe("단위"),
                amount: zod.number().describe("금액"),
                spec1: zod.string().optional().describe("규격 1"),
                spec2: zod.string().optional().describe("규격 2"),
                spec3: zod.string().optional().describe("규격 3"),
                itemCode: zod.string().optional().describe("품목 코드"),
                manufacturer: zod.string().optional().describe("제조사"),
                brand: zod.string().optional().describe("브랜드"),
                itemId: zod.string().optional().describe("품목 ID"),
                itemName: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목명"),
                itemCodeMatch: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목 코드"),
                itemPrice: zod
                  .number()
                  .optional()
                  .describe("매칭된 표준 품목 단가"),
                itemImageUrl: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목 이미지 URL"),
                itemSpec: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목 규격 요약"),
              })
              .strict(),
          )
          .describe("물품 목록"),
        additionalConditions: zod
          .array(
            zod
              .object({
                value: zod.string().describe("English code identifier"),
                label: zod.string().describe("Korean UI label for display"),
              })
              .strict(),
          )
          .nullish()
          .describe("추가 조건"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 해당 견적요청이 언제 무엇이 바뀌었는지를 최신순으로 돌려줍니다. 씨마켓 경유 수정뿐 아니라 **세모에서 직접 수정한 건도 포함**됩니다.

수정이 없으면 빈 배열입니다(404 아님). 등록·마감은 이 목록에 포함되지 않습니다 — 수정만 담습니다.

`summary` 는 조회 시점에 `changes` 로부터 만들어집니다.

**식별자는 상세 조회와 같습니다** — UUID 뿐 아니라 공고번호(`AA0007`·`SEAA0007`)와 bid id(`AA0014_2`)도 받습니다. 없는 공고면 404 입니다(빈 배열이 아닙니다).
 * @summary 견적 요청 수정 이력 조회 (최신순)
 */
export const externalQuoteRequestsControllerFindModificationsParams = zod
  .object({
    id: zod.coerce
      .string()
      .describe("UUID · 공고번호(AA0007) · bid id(AA0014_2) 모두 허용"),
  })
  .strict();

export const externalQuoteRequestsControllerFindModificationsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            modifiedAt: zod.string().describe("수정 시각 (ISO 8601, UTC)"),
            summary: zod.string().describe("무엇이 바뀌었는지 한 줄 요약"),
            modifiedBy: zod
              .string()
              .nullish()
              .describe("수정 주체(발주기관 사용자 ID). 알 수 없으면 null"),
            changes: zod
              .array(
                zod
                  .object({
                    field: zod.string().describe("영속 컬럼명"),
                    label: zod.string().describe("사람이 읽는 필드 이름"),
                    before: zod.object({}).nullish().describe("변경 전 값"),
                    after: zod.object({}).nullish().describe("변경 후 값"),
                  })
                  .strict(),
              )
              .describe("필드별 변경 내역"),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 해당 견적요청으로 체결된 계약의 계약서류를 계약별로 묶어 돌려줍니다. 발주기관은 전체 계약을, 공급사는 자기 계약만 봅니다.

계약이 아직 없으면 빈 배열입니다(404 아님). 취소된 계약은 제외됩니다.

**식별자는 상세 조회와 같습니다** — UUID 뿐 아니라 공고번호(`AA0007`·`SEAA0007`)와 bid id(`AA0014_2`)도 받습니다.
 * @summary 견적 요청의 계약서류 조회 (공급자 · 발주기관)
 */
export const externalQuoteRequestsControllerFindContractDocumentsParams = zod
  .object({
    id: zod.coerce
      .string()
      .describe("UUID · 공고번호(AA0007) · bid id(AA0014_2) 모두 허용"),
  })
  .strict();

export const externalQuoteRequestsControllerFindContractDocumentsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            contractId: zod.string().describe("계약 id"),
            contractNumber: zod.string().describe("계약번호"),
            supplierId: zod.string().describe("이 계약의 공급사 id"),
            supplierName: zod.string().nullable().describe("공급사 상호"),
            pendingCount: zod
              .number()
              .describe("아직 제출되지 않은 서류 수. 0 이면 다 냈다."),
            documents: zod
              .array(
                zod
                  .object({
                    paperCode: zod.number().describe("서류 코드"),
                    name: zod.string().describe("서류명"),
                    kind: zod
                      .string()
                      .describe(
                        "서류 종류. `auto` 는 견적서 등에서 자동 생성돼 이미 파일이 있고, `auto_pending_input` 은 공급사가 값을 채우면 생성되며, `manual` 은 공급사가 파일을 직접 올린다.",
                      ),
                    status: zod
                      .string()
                      .describe(
                        "진행 상태 — `pending`(제출 전) · `completed`(제출됨).",
                      ),
                    fileUrl: zod
                      .string()
                      .nullable()
                      .describe(
                        "제출된 파일 주소. 아직 제출 전이면 null 이다.",
                      ),
                    fileName: zod.string().nullable().describe("제출된 파일명"),
                    uploadedAt: zod
                      .string()
                      .nullable()
                      .describe("제출 시각(ISO 8601)"),
                  })
                  .strict(),
              )
              .describe("이 계약에 걸린 서류 목록"),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 본인이 등록한 공고의 마감일시를 뒤로 미룹니다. 공고 수정과 달리 응답이 있어도 연장할 수 있습니다(연장은 이미 받은 견적을 무효화하지 않습니다). 마감일이 지나 대기(ON_HOLD)로 내려간 공고는 연장과 함께 진행중으로 되돌아갑니다. 새 마감일시가 과거이거나 기존 마감일시보다 앞서거나 30일을 넘겨 미루면 400, 이미 마감(CLOSED)된 공고는 409 입니다.
 * @summary 발주기관 공고 마감 연장 — 참여 업체가 있어도 가능
 */
export const externalQuoteRequestsControllerExtendDeadlineParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const externalQuoteRequestsControllerExtendDeadlineBody = zod
  .object({
    deadline: zod
      .string()
      .describe(
        "새 마감일시 (ISO 8601). 현재 시각과 기존 마감일시보다 뒤여야 하며, 한 번에 30일까지 연장할 수 있습니다.",
      ),
  })
  .strict();

export const externalQuoteRequestsControllerExtendDeadlineResponseTwoDataPaymentMethodDefault =
  "postpaid";

export const externalQuoteRequestsControllerExtendDeadlineResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("견적 요청 ID (UUID)"),
        requestNumber: zod.string().describe("견적 요청 번호"),
        projectName: zod.string().describe("프로젝트명"),
        userId: zod.string().describe("사용자 ID (작성자)"),
        isOwner: zod
          .boolean()
          .optional()
          .describe(
            "현재 인증 사용자가 이 견적 요청의 등록자인지 여부 (클라이언트 소유권 판단용)",
          ),
        status: zod
          .enum(["IN_PROGRESS", "ON_HOLD", "CLOSED", "CONTRACT_IN_PROGRESS"])
          .describe("상태"),
        categoryType: zod.enum(["product"]).describe("카테고리 타입"),
        managerName: zod.string().nullish().describe("담당자명"),
        managerContact: zod.string().nullish().describe("담당자 연락처"),
        organizationName: zod
          .string()
          .nullish()
          .describe(
            "발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)",
          ),
        organizationPhone: zod
          .string()
          .nullish()
          .describe(
            "발주기관 대표번호 (담당자 개인 휴대폰이 아니다. 공개 공고에서만, 비공개는 본인·어드민 외 null)",
          ),
        addressId: zod.string().describe("주소 ID"),
        address: zod
          .object({
            province: zod.string().describe("시/도"),
            city: zod.string().describe("시/군/구"),
            district: zod.string().nullish().describe("읍/면/동"),
            label: zod
              .string()
              .nullish()
              .describe("배송지 이름 (예: 회사) (작성자 본인만)"),
            postalCode: zod
              .string()
              .nullish()
              .describe("우편번호 (작성자 본인만)"),
            addressLine1: zod
              .string()
              .nullish()
              .describe("기본주소 (작성자 본인만)"),
            addressLine2: zod
              .string()
              .nullish()
              .describe("상세주소 (작성자 본인만)"),
            recipientName: zod
              .string()
              .nullish()
              .describe("수령인 (작성자 본인만)"),
          })
          .strict()
          .nullish()
          .describe("주소 정보"),
        description: zod.string().nullish().describe("설명"),
        budgetType: zod
          .enum(["public", "no_budget"])
          .nullish()
          .describe("예산 타입"),
        budgetAmount: zod.number().nullish().describe("예산 금액"),
        paymentMethod: zod
          .enum(["prepaid", "postpaid"])
          .describe("결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)"),
        isPrepaid: zod
          .boolean()
          .describe("결제 방법 (boolean form). true=선결제, false=후불결제."),
        preferredPaymentChannel: zod
          .enum(["card", "cash", "undecided"])
          .nullable()
          .describe(
            "공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.",
          ),
        sameRegionOnly: zod.boolean().nullish().describe("동일 지역만"),
        isPublic: zod.boolean().nullish().describe("공개 여부"),
        deadline: zod.string().describe("마감일"),
        createdAt: zod.string().nullish().describe("생성일 (ISO 8601)"),
        updatedAt: zod.string().nullish().describe("수정일 (ISO 8601)"),
        approvedAt: zod.string().nullish().describe("승인 일시 (ISO 8601)"),
        closedAt: zod.string().nullish().describe("마감 일시 (ISO 8601)"),
        closeReason: zod.string().nullish().describe("마감 사유"),
        onHoldAt: zod.string().nullish().describe("보류 일시 (ISO 8601)"),
        attachments: zod
          .array(
            zod
              .object({
                fileName: zod.string().describe("파일명"),
                url: zod.string().url().describe("파일 공개 URL"),
                filePath: zod
                  .string()
                  .optional()
                  .describe(
                    "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
                  ),
                fileSize: zod.number().describe("파일 크기 (바이트)"),
                contentType: zod.string().optional().describe("MIME 타입"),
              })
              .strict(),
          )
          .nullish()
          .describe("첨부파일 목록"),
        responseCount: zod.number().describe("견적 응답 수"),
        responses: zod
          .array(
            zod
              .object({
                id: zod.string().describe("견적 응답 ID"),
                supplierName: zod.string().describe("공급자명"),
                supplierId: zod.string().describe("공급자 ID (세모 내부 UUID)"),
                supplierMemberId: zod
                  .string()
                  .nullable()
                  .describe(
                    "씨마켓 공급사 회원 ID. 익명화 대상이거나 씨마켓 회원이 아니면 null",
                  ),
                totalAmount: zod.number().describe("견적 금액"),
                trustScore: zod.number().describe("공급자 신뢰 점수"),
                trustPercentile: zod
                  .number()
                  .nullish()
                  .describe("공급자 신뢰 백분위"),
                chatRoomId: zod.string().nullable().describe("채팅방 ID"),
                isAnonymous: zod
                  .boolean()
                  .describe("익명 여부 (블러 처리 필요)"),
                isContracted: zod.boolean().describe("계약 여부 (채팅방 기준)"),
                withdrawnAt: zod
                  .string()
                  .datetime({})
                  .nullish()
                  .describe(
                    "공급사가 견적을 철회한 시각 (ISO 8601). null 이면 철회 안 됨",
                  ),
                attachments: zod
                  .array(
                    zod
                      .object({
                        fileName: zod.string().describe("파일명"),
                        url: zod.string().url().describe("파일 공개 URL"),
                        filePath: zod
                          .string()
                          .optional()
                          .describe(
                            "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
                          ),
                        fileSize: zod.number().describe("파일 크기 (바이트)"),
                        contentType: zod
                          .string()
                          .optional()
                          .describe("MIME 타입"),
                      })
                      .strict(),
                  )
                  .describe(
                    "공급사 첨부. URL 은 1시간 서명. 익명화 대상이면 빈 배열",
                  ),
                createdAt: zod.string().describe("생성일"),
              })
              .strict(),
          )
          .describe("견적 응답 목록"),
        willGenerateAutoQuotes: zod.boolean().describe("자동 견적 발송 여부"),
        autoQuoteStatus: zod
          .enum(["none", "pending", "processing", "completed", "failed"])
          .describe("스마트 견적 생성 상태"),
        contracts: zod
          .array(
            zod
              .object({
                id: zod.string().uuid().describe("계약 ID (UUID)"),
                contractNumber: zod.string().describe("계약 번호 (UI 표시용)"),
                status: zod
                  .enum(["IN_PROGRESS", "COMPLETED", "CANCELED"])
                  .describe("계약 상태"),
                isCanceled: zod.boolean().describe("계약 취소 여부"),
                cancellationRequestedAt: zod
                  .string()
                  .nullish()
                  .describe("계약 취소 요청 일시 (ISO 8601)"),
                canceledAt: zod
                  .string()
                  .nullish()
                  .describe("계약 취소 완료 일시 (ISO 8601)"),
                cancellationReason: zod
                  .string()
                  .nullish()
                  .describe("계약 취소 사유"),
                supplierId: zod
                  .string()
                  .uuid()
                  .describe("계약 공급사 ID (UUID)"),
                supplierName: zod
                  .string()
                  .nullish()
                  .describe(
                    "계약 공급사 상호. 씨마켓 «계약 업체» 칸이 그리는 값 — 참여 업체 목록과 짝맞추지 않아도 되도록 여기서 함께 내려보낸다.",
                  ),
                quoteResponseVersionId: zod
                  .string()
                  .uuid()
                  .nullish()
                  .describe(
                    "이 계약이 선 견적 응답 **버전** id. 씨마켓이 이 계약의 결제창을 되짚는 유일한 키다 — 결제창 발행 시 이 값을 멱등키로 보냈고, 씨마켓은 그 값으로 계약 ↔ 결제창을 1:1 로 묶어 두었다.",
                  ),
                paymentChannel: zod
                  .enum(["cash", "card"])
                  .nullish()
                  .describe(
                    "발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.",
                  ),
                createdAt: zod.string().describe("계약 생성 일시 (ISO 8601)"),
              })
              .strict(),
          )
          .describe(
            "현재 사용자에게 노출 가능한 연결 계약 목록 (external 상세에서 제공)",
          ),
        dueDateValue: zod
          .enum(["구체적", "협의가능"])
          .nullish()
          .describe("배송일 (구체적/협의가능)"),
        dueDate: zod.string().nullish().describe("희망 배송일 (ISO 8601)"),
        additionalRequests: zod
          .array(
            zod
              .object({
                value: zod.string().describe("English code identifier"),
                label: zod.string().describe("Korean UI label for display"),
              })
              .strict(),
          )
          .nullish()
          .describe("추가 요청사항"),
        items: zod
          .array(
            zod
              .object({
                name: zod.string().describe("품목명"),
                quantity: zod.number().describe("수량"),
                unit: zod.string().describe("단위"),
                amount: zod.number().describe("금액"),
                spec1: zod.string().optional().describe("규격 1"),
                spec2: zod.string().optional().describe("규격 2"),
                spec3: zod.string().optional().describe("규격 3"),
                itemCode: zod.string().optional().describe("품목 코드"),
                manufacturer: zod.string().optional().describe("제조사"),
                brand: zod.string().optional().describe("브랜드"),
                itemId: zod.string().optional().describe("품목 ID"),
                itemName: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목명"),
                itemCodeMatch: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목 코드"),
                itemPrice: zod
                  .number()
                  .optional()
                  .describe("매칭된 표준 품목 단가"),
                itemImageUrl: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목 이미지 URL"),
                itemSpec: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목 규격 요약"),
              })
              .strict(),
          )
          .describe("물품 목록"),
        additionalConditions: zod
          .array(
            zod
              .object({
                value: zod.string().describe("English code identifier"),
                label: zod.string().describe("Korean UI label for display"),
              })
              .strict(),
          )
          .nullish()
          .describe("추가 조건"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 현재 로그인된 공급자의 모든 계약 내역을 조회합니다.
 * @summary 공급자 계약 리스트 조회 (C-Market)
 */
export const externalContractsControllerGetContractsResponseTwoDataItemQuoteRequestOneResponseCountMin = 0;

export const externalContractsControllerGetContractsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            id: zod.string().uuid().describe("계약 ID (UUID)"),
            contractNumber: zod
              .string()
              .describe("계약 번호 (UI 표시용 - SE 제외)"),
            status: zod
              .enum(["IN_PROGRESS", "COMPLETED", "CANCELED"])
              .describe("계약 상태"),
            totalAmount: zod.number().describe("총 금액"),
            pdfUrl: zod
              .string()
              .nullable()
              .describe("계약서 PDF URL (생성 중이면 null)"),
            supplier: zod
              .object({
                name: zod.string().describe("공급자 회사명"),
              })
              .strict()
              .describe("공급자 정보"),
            quoteRequest: zod
              .object({
                id: zod.string().uuid().describe("견적 요청 ID"),
                requestNumber: zod
                  .string()
                  .describe("견적 요청 번호 (UI 표시용 - SE 제외)"),
                projectName: zod.string().describe("프로젝트명"),
                status: zod
                  .enum([
                    "TEMP_SAVE",
                    "WAITING_APPROVAL",
                    "IN_PROGRESS",
                    "ON_HOLD",
                    "CLOSED",
                    "CANCELLED",
                  ])
                  .describe("견적 요청 상태"),
                deadline: zod
                  .string()
                  .datetime({})
                  .nullable()
                  .describe("마감일 (ISO 8601)"),
                responseCount: zod
                  .number()
                  .min(
                    externalContractsControllerGetContractsResponseTwoDataItemQuoteRequestOneResponseCountMin,
                  )
                  .describe("응답 수"),
              })
              .strict()
              .describe("견적 요청 정보 (참조용)"),
            quoteResponseVersionId: zod
              .string()
              .uuid()
              .nullish()
              .describe(
                "이 계약이 선 견적 응답 **버전** id. 씨마켓이 이 계약의 결제창을 되짚는 유일한 키다 — 결제창 발행 시 이 값을 멱등키로 보냈고(`externalRef`), 씨마켓은 그 값으로 계약 ↔ 결제창을 1:1 로 묶어 두었다. 계약 목록에서 [카드결제]/[카드영수증] 을 그리는 재료.",
              ),
            settlementStatus: zod
              .enum(["PENDING", "COMPLETED", "DEFERRED"])
              .describe("정산상태"),
            paymentMethod: zod
              .enum(["CARD", "BANK_TRANSFER"])
              .nullish()
              .describe("결제방식 (결제 수단 유형: CARD, BANK_TRANSFER)"),
            paymentChannel: zod
              .enum(["cash", "card"])
              .nullish()
              .describe(
                "발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. 위 `paymentMethod` 는 **결제 거래**의 수단(DIRECT/CMARKET_CARD 등)이라 이것과 다른 축이다 — 현금/카드 배지는 반드시 이 필드로 그릴 것.",
              ),
            taxInvoiceStatus: zod
              .enum(["REQUESTED", "ISSUED", "CANCELLED"])
              .nullish()
              .describe(
                "씨마켓 세금계산서 상태. NULL 은 아직 발행요청 전. REQUESTED=발주기관이 요청함, ISSUED=공급기업이 발행함, CANCELLED=발행취소됨.",
              ),
            taxInvoiceTargetId: zod
              .object({})
              .nullish()
              .describe(
                "씨마켓 세금계산서 축 id(`SI…`). 씨마켓 계산서 화면으로 넘길 때의 키.",
              ),
            buyer: zod
              .object({
                name: zod.string().optional().describe("구매자명"),
              })
              .strict()
              .nullish()
              .describe("발주자 정보"),
            constructionType: zod
              .object({
                value: zod.string().describe("내부 코드"),
                label: zod.string().describe("표시 라벨"),
              })
              .strict()
              .nullish()
              .describe("공사 유형 (공사 카테고리인 경우)"),
            spaceType: zod
              .object({
                value: zod.string().describe("내부 코드"),
                label: zod.string().describe("표시 라벨"),
              })
              .strict()
              .nullish()
              .describe("공사 장소 (공사 카테고리인 경우)"),
            constructionArea: zod
              .object({
                value: zod.string().describe("내부 코드"),
                label: zod.string().describe("표시 라벨"),
              })
              .strict()
              .nullish()
              .describe("공사 면적 (공사 카테고리인 경우)"),
            cancellationReason: zod
              .string()
              .nullish()
              .describe(
                "계약 취소 사유 (발주기관이 취소 요청 시 입력한 값. 취소 요청 접수 시점부터 세팅되며, 취소 확정 후에도 원본이 유지됨)",
              ),
            cancellationRequestedAt: zod
              .string()
              .datetime({})
              .nullish()
              .describe(
                "계약 취소 요청 일시 (환불 승인 대기 상태일 때부터 존재)",
              ),
            cancellationRequestedBy: zod
              .enum(["buyer", "supplier"])
              .nullish()
              .describe(
                "계약 취소 요청 주체 (buyer: 발주기관 요청, supplier: 공급사 요청). 취소 요청이 없거나 반려된 경우 null.",
              ),
            canceledAt: zod
              .string()
              .datetime({})
              .nullish()
              .describe("계약 취소 일시 (status=CANCELED일 때만 존재)"),
            createdAt: zod
              .string()
              .datetime({})
              .describe("계약 생성 일시 (ISO 8601)"),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 현재 로그인된 발주기관이 체결한 계약을 SEMO 나의 계약과 동일한 기준으로 조회합니다.
 * @summary 발주기관 나의 계약 목록 조회 (C-Market)
 */
export const externalContractsControllerGetMyContractsQueryPageDefault = 1;

export const externalContractsControllerGetMyContractsQueryLimitDefault = 20;
export const externalContractsControllerGetMyContractsQueryLimitMax = 100;

export const externalContractsControllerGetMyContractsQuerySortByDefault =
  "created_at";
export const externalContractsControllerGetMyContractsQuerySortOrderDefault =
  "desc";

export const externalContractsControllerGetMyContractsQueryParams = zod
  .object({
    page: zod.coerce
      .number()
      .min(1)
      .default(externalContractsControllerGetMyContractsQueryPageDefault)
      .describe("페이지 번호"),
    limit: zod.coerce
      .number()
      .min(1)
      .max(externalContractsControllerGetMyContractsQueryLimitMax)
      .default(externalContractsControllerGetMyContractsQueryLimitDefault)
      .describe("페이지당 항목 수"),
    sortBy: zod.coerce
      .string()
      .default(externalContractsControllerGetMyContractsQuerySortByDefault)
      .describe("정렬 필드"),
    sortOrder: zod
      .enum(["asc", "desc"])
      .default(externalContractsControllerGetMyContractsQuerySortOrderDefault)
      .describe("정렬 순서"),
    search: zod.coerce.string().optional().describe("검색어"),
    statuses: zod
      .array(zod.enum(["IN_PROGRESS", "COMPLETED", "CANCELED"]))
      .optional(),
  })
  .strict();

export const externalContractsControllerGetMyContractsResponseTwoDataItemsItemQuoteRequestOneResponseCountMin = 0;

export const externalContractsControllerGetMyContractsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().uuid().describe("계약 ID (UUID)"),
              contractNumber: zod
                .string()
                .describe("계약 번호 (UI 표시용 - SE 제외)"),
              status: zod
                .enum(["IN_PROGRESS", "COMPLETED", "CANCELED"])
                .describe("계약 상태"),
              totalAmount: zod.number().describe("총 금액"),
              pdfUrl: zod
                .string()
                .nullable()
                .describe("계약서 PDF URL (생성 중이면 null)"),
              supplier: zod
                .object({
                  name: zod.string().describe("공급자 회사명"),
                })
                .strict()
                .describe("공급자 정보"),
              quoteRequest: zod
                .object({
                  id: zod.string().uuid().describe("견적 요청 ID"),
                  requestNumber: zod
                    .string()
                    .describe("견적 요청 번호 (UI 표시용 - SE 제외)"),
                  projectName: zod.string().describe("프로젝트명"),
                  status: zod
                    .enum([
                      "TEMP_SAVE",
                      "WAITING_APPROVAL",
                      "IN_PROGRESS",
                      "ON_HOLD",
                      "CLOSED",
                      "CANCELLED",
                    ])
                    .describe("견적 요청 상태"),
                  deadline: zod
                    .string()
                    .datetime({})
                    .nullable()
                    .describe("마감일 (ISO 8601)"),
                  responseCount: zod
                    .number()
                    .min(
                      externalContractsControllerGetMyContractsResponseTwoDataItemsItemQuoteRequestOneResponseCountMin,
                    )
                    .describe("응답 수"),
                })
                .strict()
                .describe("견적 요청 정보 (참조용)"),
              quoteResponseVersionId: zod
                .string()
                .uuid()
                .nullish()
                .describe(
                  "이 계약이 선 견적 응답 **버전** id. 씨마켓이 이 계약의 결제창을 되짚는 유일한 키다 — 결제창 발행 시 이 값을 멱등키로 보냈고(`externalRef`), 씨마켓은 그 값으로 계약 ↔ 결제창을 1:1 로 묶어 두었다. 계약 목록에서 [카드결제]/[카드영수증] 을 그리는 재료.",
                ),
              settlementStatus: zod
                .enum(["PENDING", "COMPLETED", "DEFERRED"])
                .describe("정산상태"),
              paymentMethod: zod
                .enum(["CARD", "BANK_TRANSFER"])
                .nullish()
                .describe("결제방식 (결제 수단 유형: CARD, BANK_TRANSFER)"),
              paymentChannel: zod
                .enum(["cash", "card"])
                .nullish()
                .describe(
                  "발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. 위 `paymentMethod` 는 **결제 거래**의 수단(DIRECT/CMARKET_CARD 등)이라 이것과 다른 축이다 — 현금/카드 배지는 반드시 이 필드로 그릴 것.",
                ),
              taxInvoiceStatus: zod
                .enum(["REQUESTED", "ISSUED", "CANCELLED"])
                .nullish()
                .describe(
                  "씨마켓 세금계산서 상태. NULL 은 아직 발행요청 전. REQUESTED=발주기관이 요청함, ISSUED=공급기업이 발행함, CANCELLED=발행취소됨.",
                ),
              taxInvoiceTargetId: zod
                .object({})
                .nullish()
                .describe(
                  "씨마켓 세금계산서 축 id(`SI…`). 씨마켓 계산서 화면으로 넘길 때의 키.",
                ),
              buyer: zod
                .object({
                  name: zod.string().optional().describe("구매자명"),
                })
                .strict()
                .nullish()
                .describe("발주자 정보"),
              constructionType: zod
                .object({
                  value: zod.string().describe("내부 코드"),
                  label: zod.string().describe("표시 라벨"),
                })
                .strict()
                .nullish()
                .describe("공사 유형 (공사 카테고리인 경우)"),
              spaceType: zod
                .object({
                  value: zod.string().describe("내부 코드"),
                  label: zod.string().describe("표시 라벨"),
                })
                .strict()
                .nullish()
                .describe("공사 장소 (공사 카테고리인 경우)"),
              constructionArea: zod
                .object({
                  value: zod.string().describe("내부 코드"),
                  label: zod.string().describe("표시 라벨"),
                })
                .strict()
                .nullish()
                .describe("공사 면적 (공사 카테고리인 경우)"),
              cancellationReason: zod
                .string()
                .nullish()
                .describe(
                  "계약 취소 사유 (발주기관이 취소 요청 시 입력한 값. 취소 요청 접수 시점부터 세팅되며, 취소 확정 후에도 원본이 유지됨)",
                ),
              cancellationRequestedAt: zod
                .string()
                .datetime({})
                .nullish()
                .describe(
                  "계약 취소 요청 일시 (환불 승인 대기 상태일 때부터 존재)",
                ),
              cancellationRequestedBy: zod
                .enum(["buyer", "supplier"])
                .nullish()
                .describe(
                  "계약 취소 요청 주체 (buyer: 발주기관 요청, supplier: 공급사 요청). 취소 요청이 없거나 반려된 경우 null.",
                ),
              canceledAt: zod
                .string()
                .datetime({})
                .nullish()
                .describe("계약 취소 일시 (status=CANCELED일 때만 존재)"),
              createdAt: zod
                .string()
                .datetime({})
                .describe("계약 생성 일시 (ISO 8601)"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 현재 로그인된 공급자의 정산 내역을 조회합니다.
 * @summary 공급자 정산 내역 조회 (C-Market)
 */
export const externalContractsControllerGetSettlementsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            id: zod.string().uuid().describe("계약 ID"),
            contractNumber: zod.string().describe("계약 번호"),
            contractDate: zod.string().describe("계약 생성 일시"),
            totalAmount: zod.number().describe("총 계약 금액"),
            commissionAmount: zod.number().describe("플랫폼 수수료"),
            settlementAmount: zod
              .number()
              .describe("정산 금액 (총액 - 수수료)"),
            paymentMethod: zod.enum(["CARD", "CASH"]).describe("결제 수단"),
            settlementStatus: zod
              .enum(["WAITING", "PENDING", "COMPLETED", "DEFERRED"])
              .describe("정산 상태"),
            projectName: zod.string().optional().describe("프로젝트명"),
            buyerName: zod.string().optional().describe("구매자명"),
            completedAt: zod.string().optional().describe("구매확정 일시"),
            settlementExpectedDate: zod
              .string()
              .optional()
              .describe("정산 예정일"),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 특정 계약의 상세 정보를 조회합니다.
 * @summary 공급자 계약 상세 조회 (C-Market)
 */
export const externalContractsControllerGetContractParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const externalContractsControllerGetContractResponseTwoDataItemsItemNameMax = 255;

export const externalContractsControllerGetContractResponseTwoDataItemsItemUnitPriceMin = 0;

export const externalContractsControllerGetContractResponseTwoDataItemsItemUnitMax = 10;

export const externalContractsControllerGetContractResponseTwoDataItemsItemSpec1Max = 255;

export const externalContractsControllerGetContractResponseTwoDataItemsItemSpec2Max = 255;

export const externalContractsControllerGetContractResponseTwoDataItemsItemSpec3Max = 255;

export const externalContractsControllerGetContractResponseTwoDataItemsItemAmountMin = 0;

export const externalContractsControllerGetContractResponseTwoDataItemsItemItemCodeMax = 100;

export const externalContractsControllerGetContractResponseTwoDataItemsItemManufacturerMax = 100;

export const externalContractsControllerGetContractResponseTwoDataItemsItemBrandMax = 100;

export const externalContractsControllerGetContractResponseTwoDataIsPrepaidDefault = true;

export const externalContractsControllerGetContractResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().uuid().describe("계약 ID"),
        paymentTransactionId: zod.string().describe("결제 거래 ID"),
        contractNumber: zod.string().describe("계약번호"),
        totalAmount: zod.number().describe("총 금액"),
        taxAmount: zod.number().optional().describe("세금 (선택사항)"),
        status: zod
          .enum(["IN_PROGRESS", "COMPLETED", "CANCELED"])
          .describe("계약 상태"),
        pdfUrl: zod.string().nullable().describe("계약서 PDF URL"),
        pdfGeneratedAt: zod
          .string()
          .datetime({})
          .describe("계약서 PDF 생성 일시 (ISO 8601)"),
        items: zod
          .array(
            zod
              .object({
                name: zod
                  .string()
                  .max(
                    externalContractsControllerGetContractResponseTwoDataItemsItemNameMax,
                  )
                  .describe("품목명 (필수)"),
                unitPrice: zod
                  .number()
                  .min(
                    externalContractsControllerGetContractResponseTwoDataItemsItemUnitPriceMin,
                  )
                  .describe("단가 (부가세 포함, 원 단위)"),
                unit: zod
                  .string()
                  .max(
                    externalContractsControllerGetContractResponseTwoDataItemsItemUnitMax,
                  )
                  .describe("단위 (예: EA, 박스, 세트)"),
                spec1: zod
                  .string()
                  .max(
                    externalContractsControllerGetContractResponseTwoDataItemsItemSpec1Max,
                  )
                  .optional()
                  .describe("규격 1 (예: A4, 500ml)"),
                spec2: zod
                  .string()
                  .max(
                    externalContractsControllerGetContractResponseTwoDataItemsItemSpec2Max,
                  )
                  .optional()
                  .describe("규격 2 - 재질/타입 (예: 80g, 스테인리스)"),
                spec3: zod
                  .string()
                  .max(
                    externalContractsControllerGetContractResponseTwoDataItemsItemSpec3Max,
                  )
                  .optional()
                  .describe("규격 3 - 패키징 (예: 2500매/박스)"),
                quantity: zod
                  .number()
                  .min(1)
                  .describe("수량 (견적응답 전용 - items 테이블에는 없음)"),
                amount: zod
                  .number()
                  .min(
                    externalContractsControllerGetContractResponseTwoDataItemsItemAmountMin,
                  )
                  .describe("품목별 총액 (단가 x 수량, 견적응답 전용)"),
                itemCode: zod
                  .string()
                  .max(
                    externalContractsControllerGetContractResponseTwoDataItemsItemItemCodeMax,
                  )
                  .optional()
                  .describe("상품코드 (items 테이블 선택사항)"),
                manufacturer: zod
                  .string()
                  .max(
                    externalContractsControllerGetContractResponseTwoDataItemsItemManufacturerMax,
                  )
                  .optional()
                  .describe("제조사 (items 테이블 선택사항)"),
                brand: zod
                  .string()
                  .max(
                    externalContractsControllerGetContractResponseTwoDataItemsItemBrandMax,
                  )
                  .optional()
                  .describe("브랜드 (items 테이블 선택사항)"),
                itemId: zod
                  .string()
                  .optional()
                  .describe("시스템 아이템 ID (자동 견적 매칭용)"),
              })
              .strict(),
          )
          .describe("계약 항목"),
        supplier: zod
          .object({
            id: zod.string().uuid().describe("공급자 ID"),
            name: zod.string().describe("공급자 회사명"),
            ceoName: zod.string().describe("대표자명"),
            businessNumber: zod.string().describe("사업자등록번호"),
            address: zod.string().optional().describe("회사 주소"),
            phone: zod.string().optional().describe("회사 전화번호"),
            email: zod.string().optional().describe("공급자 이메일"),
            managerName: zod.string().optional().describe("담당자명"),
            managerPhone: zod.string().optional().describe("담당자 전화번호"),
            companySealUrl: zod.string().optional().describe("회사 직인 URL"),
            bankName: zod.string().optional().describe("은행명"),
            bankAccountNumber: zod.string().optional().describe("계좌번호"),
            bankAccountHolder: zod.string().optional().describe("예금주"),
          })
          .strict()
          .describe("공급자 정보"),
        description: zod.string().optional().describe("견적 설명/비고"),
        createdAt: zod
          .string()
          .datetime({})
          .describe("계약 생성 일시 (ISO 8601)"),
        updatedAt: zod
          .string()
          .datetime({})
          .describe("계약 수정 일시 (ISO 8601)"),
        canceledAt: zod
          .string()
          .datetime({})
          .nullish()
          .describe("계약 취소 일시 (status=CANCELED일 때만 존재)"),
        cancellationReason: zod
          .string()
          .nullish()
          .describe(
            "계약 취소 사유 (발주기관이 취소 요청 시 입력한 값. 취소 요청 접수 시점부터 세팅되며, 취소 확정 후에도 원본이 유지됨)",
          ),
        cancellationRequestedAt: zod
          .string()
          .datetime({})
          .nullish()
          .describe("계약 취소 요청 일시 (환불 승인 대기 상태일 때부터 존재)"),
        cancellationRequestedBy: zod
          .enum(["buyer", "supplier"])
          .nullish()
          .describe(
            "계약 취소 요청 주체 (buyer: 발주기관 요청, supplier: 공급사 요청). 취소 요청이 없거나 반려된 경우 null.",
          ),
        completedAt: zod
          .string()
          .datetime({})
          .nullish()
          .describe("구매확정 일시 (status=COMPLETED일 때만 존재)"),
        projectName: zod.string().optional().describe("프로젝트명 (거래명)"),
        categoryType: zod
          .enum(["product", "construction", "manufacturing", "used"])
          .optional()
          .describe("카테고리 유형"),
        quoteRequestId: zod.string().uuid().optional().describe("견적 요청 ID"),
        quoteResponseVersionId: zod
          .string()
          .uuid()
          .optional()
          .describe(
            "견적 응답 버전 ID (2026-07-31). 계약 카드의 [결제하기] 가 씨마켓 결제창을 발행할 때 이 값을 필요로 한다.",
          ),
        chatRoomId: zod
          .string()
          .uuid()
          .optional()
          .describe("채팅방 ID (채팅 시작용)"),
        chatMessageId: zod
          .string()
          .uuid()
          .optional()
          .describe("채팅 메시지 ID"),
        reviewId: zod
          .string()
          .uuid()
          .optional()
          .describe("리뷰 ID (작성된 리뷰가 있는 경우)"),
        paymentMethod: zod
          .enum(["CARD", "BANK_TRANSFER"])
          .optional()
          .describe("결제방식 (결제 수단 유형: CARD, BANK_TRANSFER)"),
        settlementStatus: zod
          .enum(["PENDING", "COMPLETED", "DEFERRED"])
          .describe("정산상태"),
        refundStatus: zod
          .string()
          .nullish()
          .describe(
            "환불 상태 (REQUESTED, APPROVED, REJECTED, PROCESSING, COMPLETED, FAILED)",
          ),
        rejectionReason: zod
          .string()
          .nullish()
          .describe("환불 반려 사유 (refundStatus=REJECTED일 때만 존재)"),
        buyer: zod
          .object({
            name: zod.string().optional().describe("구매자명"),
            company: zod.string().optional().describe("발주기관명"),
            representativeName: zod
              .string()
              .optional()
              .describe("발주기관 대표자"),
            businessNumber: zod
              .string()
              .optional()
              .describe("발주기관 사업자등록번호"),
            address: zod.string().optional().describe("발주기관 주소"),
            phone: zod.string().optional().describe("구매자 전화번호"),
            email: zod.string().optional().describe("구매자 이메일"),
          })
          .strict()
          .nullish()
          .describe("발주자 정보"),
        deliveryAddress: zod
          .object({
            id: zod.string().describe("주소 ID (UUID)"),
            userId: zod.string().describe("사용자 ID (UUID)"),
            label: zod
              .string()
              .optional()
              .describe("주소 라벨 (회사, 집, 창고 등)"),
            isDefault: zod.boolean().describe("기본 배송지 여부"),
            postalCode: zod.string().describe("우편번호 (5자리 숫자)"),
            province: zod.string().describe("시/도 (광역시 또는 도 단위)"),
            city: zod.string().describe("시/군/구 (기초자치단체)"),
            district: zod.string().optional().describe("읍/면/동 (선택사항)"),
            streetAddress: zod.string().describe("도로명 주소"),
            addressDetail: zod
              .string()
              .optional()
              .describe("상세 주소 (건물명, 동/호 등)"),
            recipientName: zod.string().optional().describe("수령인 이름"),
            recipientPhone: zod
              .string()
              .optional()
              .describe("수령인 연락처 (휴대폰 또는 일반전화)"),
            createdAt: zod
              .string()
              .optional()
              .describe("생성일 (ISO 8601 형식)"),
            updatedAt: zod
              .string()
              .optional()
              .describe("수정일 (ISO 8601 형식)"),
          })
          .strict()
          .nullish()
          .describe("배송지 정보"),
        isPrepaid: zod
          .boolean()
          .describe(
            "결제 방법 (계약 시점 스냅샷). true=선결제(prepaid, 계약 체결과 결제 동시), false=후불결제(postpaid, 결제 없이 계약 체결 후 별도 결제).",
          ),
        paidAt: zod
          .string()
          .datetime({})
          .nullish()
          .describe(
            "결제 완료 시각. NULL 이면 미결제(postpaid 만 가능). prepaid 는 created_at 과 동일.",
          ),
        paymentChannel: zod
          .enum(["cash", "card"])
          .nullish()
          .describe(
            "발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.",
          ),
        taxInvoiceStatus: zod
          .enum(["REQUESTED", "ISSUED", "CANCELLED"])
          .nullish()
          .describe(
            "씨마켓 세금계산서 상태. NULL 은 아직 발행요청 전. REQUESTED=발주기관이 요청함, ISSUED=공급기업이 발행함, CANCELLED=발행취소됨. 발행 자체는 씨마켓 나의 계약 관리에서 일어난다.",
          ),
        taxInvoiceTargetId: zod
          .object({})
          .nullish()
          .describe(
            "씨마켓 세금계산서 축 id(`SI…`). 씨마켓 계산서 화면으로 넘길 때의 키다. NULL 이면 씨마켓에 발행 대상이 없는 계약(미연동 계정이거나 등록 실패).",
          ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 계약 당사자(발주기관 또는 공급사)가 취소를 요청합니다. 요청 주체는 세션의 userType에서 판정되며, 반대편 당사자에게 알림/채팅이 발송됩니다. 공급사 요청 시 환불 계좌 정보는 무시되고 결제 원장의 원래 결제 방식대로 처리됩니다.
 * @summary 계약 취소 요청 (C-Market 발주기관 또는 공급사 → 상대편 승인 대기)
 */
export const externalContractsControllerRequestCancellationParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const externalContractsControllerRequestCancellationBody = zod
  .object({
    reason: zod
      .string()
      .min(1)
      .optional()
      .describe(
        "계약 취소 사유 (canonical). reason 또는 refund_reason 중 최소 하나는 필수.",
      ),
    refund_reason: zod
      .string()
      .min(1)
      .optional()
      .describe(
        "[Deprecated] 취소 사유의 구버전 필드명. reason 필드로 마이그레이션 예정. reason이 없을 때만 fallback으로 사용됨.",
      ),
    refund_bank: zod
      .string()
      .optional()
      .describe("환불 받을 은행명 (현금 결제 & 발주기관 요청 시에만 유효)"),
    refund_account_number: zod
      .string()
      .optional()
      .describe("환불 받을 계좌번호 (현금 결제 시 필수)"),
    refund_account_holder: zod
      .string()
      .optional()
      .describe("환불 계좌 예금주 (현금 결제 시 필수)"),
    tempId: zod
      .string()
      .optional()
      .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
  })
  .strict();

export const externalContractsControllerRequestCancellationResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod.object({}).optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 씨마켓 결제창에서 카드 승인이 완료되면 호출된다. 수신 즉시 세모에 계약을 확정한다. 재전송돼도 계약이 중복 생성되지 않는다(멱등) — 이미 확정된 건은 alreadyConfirmed=true 로 응답.
 * @summary 씨마켓 카드결제 완료 통지 (업체 직접 계약)
 */
export const externalPaymentsControllerConfirmCardPaymentHeader = zod
  .object({
    "X-API-Key": zod.string(),
  })
  .strict();

export const externalPaymentsControllerConfirmCardPaymentBody = zod
  .object({
    cardPaymentRequestId: zod
      .string()
      .describe("씨마켓 결제창 번호 (b2b_card_payment_request.buy_idx)"),
    tid: zod.string().describe("PG 거래번호(TID)"),
    amount: zod
      .number()
      .describe(
        "승인 금액 (VAT 포함). 견적 금액과 다르면 계약을 확정하지 않는다.",
      ),
    quoteResponseVersionId: zod
      .string()
      .optional()
      .describe(
        "세모 견적 버전 ID — 대사(對査)용 참고값. 판정은 결제창 번호로 한다.",
      ),
  })
  .strict();

/**
 * 파트너에서 탈퇴·정지된 회원을 세모에서도 비활성 처리합니다. 프로필은 변경하지 않습니다. 같은 값으로 여러 번 호출해도 안전합니다(changed=false). 세모에 아직 계정이 없으면 404.
 * @summary 파트너 계정 활성/비활성 전환
 */
export const externalAccountStatusControllerUpdateStatusHeader = zod
  .object({
    "X-API-Key": zod.string(),
  })
  .strict();

export const externalAccountStatusControllerUpdateStatusBody = zod
  .object({
    role: zod.enum(["buyer", "supplier"]).describe("대상 계정 역할"),
    externalId: zod
      .string()
      .describe(
        "파트너 시스템의 회원 고유 ID (가입 시 보낸 externalBuyerId / supplierId 와 같은 값)",
      ),
    isActive: zod
      .boolean()
      .describe("활성 여부. false 면 세모 계정을 비활성 처리한다."),
    reason: zod.string().nullish().describe("변경 사유 (감사 로그용, 선택)"),
  })
  .strict();

export const externalAccountStatusControllerUpdateStatusResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        changed: zod
          .boolean()
          .describe(
            "실제로 값이 바뀌었는지. 이미 같은 상태였으면 false — 파트너가 재시도해도 안전하다.",
          ),
        isActive: zod.boolean().describe("반영된 활성 여부"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 씨마켓 나의 계약 관리에서 계산서가 발행요청·발행·취소되면 호출된다. 같은 통지가 다시 와도 계약 상태가 어긋나지 않는다(멱등). 발행완료 계약에 요청 통지가 뒤늦게 닿으면 무시하고 ignoredAsStale=true 로 응답한다.
 * @summary 씨마켓 계산서 요청·발행·취소 통지
 */
export const externalTaxInvoicesControllerApplyTaxInvoiceEventHeader = zod
  .object({
    "X-API-Key": zod.string(),
  })
  .strict();

export const externalTaxInvoicesControllerApplyTaxInvoiceEventBody = zod
  .object({
    externalContractId: zod
      .string()
      .describe("세모 계약 ID (씨마켓에 등록할 때 보낸 externalContractId)"),
    taxInvoiceTargetId: zod
      .string()
      .describe("씨마켓 세금계산서 축 id (`SI{YYMMDD}{NNNNN}`)"),
    event: zod
      .enum(["REQUESTED", "ISSUED", "CANCELLED"])
      .describe(
        "REQUESTED=발주기관이 발행요청, ISSUED=공급기업이 발행, CANCELLED=발행취소. 모르는 값이 오면 반영하지 않고 ignoredAsStale=true 로 응답한다(400 을 내지 않는다).",
      ),
    mgtKeyTax: zod
      .object({})
      .nullish()
      .describe("팝빌 관리번호(과세분). 발행 전에는 비어 있다."),
    mgtKeyTaxFree: zod
      .object({})
      .nullish()
      .describe(
        "팝빌 관리번호(면세분). 세모 계약은 과세로만 등록되므로 평시엔 비어 있다.",
      ),
    writeDate: zod
      .object({})
      .nullish()
      .describe("발주기관이 지정한 작성일자(ISO 8601). 발행 전에는 비어 있다."),
  })
  .strict();

export const externalTaxInvoicesControllerApplyTaxInvoiceEventResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        contractId: zod.string().describe("상태를 반영한 계약 ID"),
        taxInvoiceStatus: zod
          .enum(["REQUESTED", "ISSUED", "CANCELLED"])
          .nullable()
          .describe(
            "계약이 들고 있는 계산서 상태. NULL 은 아직 아무 사건도 반영되지 않은 상태다.",
          ),
        ignoredAsStale: zod
          .boolean()
          .describe(
            "반영하지 않고 넘겼는지 여부. 발행완료 계약에 요청 통지가 재시도로 뒤늦게 닿았거나, 축 id 가 어긋나거나, 모르는 사건 종류가 온 경우 true — 셋 다 오류가 아니므로 씨마켓이 재시도하지 않도록 2xx 로 응답한다.",
          ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 발주기관 소유와 무관하게, 공개 여부와도 무관하게 세모의 견적요청 전체를 페이지로 돌려줍니다. 회원 토큰이 아니라 파트너 API 키(`X-API-Key`)로 호출합니다.

**`buyerMemberId`** 는 씨마켓 임베드로 가입한 발주기관만 값이 있습니다. 세모에 직접 가입한 발주기관은 `null` 이며, 이 목록에는 그 건도 함께 나옵니다(그것이 이 API 의 목적입니다).

**`responseCount`** 는 캐시 컬럼 기준입니다 — 목록 표시용이며 정산·판정 근거로 쓰지 마세요.

**`isPublic` 필터는 제공하지 않습니다.** 어드민은 공개·비공개를 모두 봐야 하므로 항상 전체가 기본값입니다.

**`categoryType`** 은 단일 값 필터이며(`product`·`construction`·`manufacturing`·`used`), 응답의 `categoryType` 이 내려주는 값을 그대로 넣습니다. `meta.totalCount` 는 **필터가 적용된 건수**입니다 — 페이지 수 계산에 그대로 쓰면 됩니다. 목록에 없는 값을 넣으면 400 이며, 조용히 전체를 돌려주지 않습니다.

**진행중·마감 탭은 `isClosed` 하나로 거세요.** `isClosed=true` 는 수동 마감(`status=CLOSED`) **또는** 마감일 경과입니다 — 이 OR 는 서버가 한 쿼리로 걸어야 총 건수가 맞습니다. 파라미터끼리는 AND 라 `status=CLOSED` 와 `deadlineTo` 를 함께 걸면 교집합이 나옵니다.

**`deadlineFrom`·`deadlineTo`** 는 마감일 축의 범위 필터입니다(`publishedFrom`·`publishedTo` 는 등록일 축이라 다릅니다).

**`status`** 는 계약이 걸린 건을 `CONTRACT_IN_PROGRESS` 로 내려 줍니다 — 상세(`GET /external/quote-requests/{id}`)·회원 피드와 같은 값이라 목록과 상세가 다른 배지를 그리지 않습니다. 계약이 없으면 DB 원값(`IN_PROGRESS`·`ON_HOLD`·`CLOSED`)입니다.

필터로도 네 값을 모두 받습니다. 다만 **`status` 필터는 DB 상태 축**이라, `IN_PROGRESS` 로 거르면 계약이 걸린 건(응답에는 `CONTRACT_IN_PROGRESS` 로 나오는 건)도 DB 상태가 `IN_PROGRESS` 인 한 함께 나옵니다. 계약 건만 고르려면 `status=CONTRACT_IN_PROGRESS` 를 쓰세요.
 * @summary 견적공고 전체 목록 (씨마켓 어드민 전용, 서비스 인증)
 */
export const externalAdminQuoteRequestsControllerFindAllQueryPageDefault = 1;
export const externalAdminQuoteRequestsControllerFindAllQueryLimitDefault = 20;
export const externalAdminQuoteRequestsControllerFindAllQueryLimitMax = 100;

export const externalAdminQuoteRequestsControllerFindAllQueryParams = zod
  .object({
    page: zod.coerce
      .number()
      .default(externalAdminQuoteRequestsControllerFindAllQueryPageDefault)
      .describe("페이지 (1부터)"),
    limit: zod.coerce
      .number()
      .max(externalAdminQuoteRequestsControllerFindAllQueryLimitMax)
      .default(externalAdminQuoteRequestsControllerFindAllQueryLimitDefault)
      .describe("페이지 크기"),
    search: zod.coerce
      .string()
      .optional()
      .describe("통합 검색 — 공고번호 · 공고명 · 발주기관명"),
    status: zod
      .array(
        zod.enum(["IN_PROGRESS", "ON_HOLD", "CLOSED", "CONTRACT_IN_PROGRESS"]),
      )
      .optional()
      .describe(
        "상태 (다중). 쉼표 구분 또는 반복 파라미터. `CONTRACT_IN_PROGRESS` 는 계약이 걸린 건을 고른다",
      ),
    categoryType: zod
      .enum(["product", "construction", "manufacturing", "used"])
      .optional()
      .describe("카테고리 (단일). 미지정이면 전체"),
    publishedFrom: zod.coerce
      .string()
      .optional()
      .describe("등록일 시작 (ISO 8601, 포함)"),
    publishedTo: zod.coerce
      .string()
      .optional()
      .describe("등록일 끝 (ISO 8601, 포함)"),
    deadlineFrom: zod.coerce
      .string()
      .optional()
      .describe(
        "마감일 시작 (ISO 8601, 포함) — `publishedFrom` 과 다른 축이다",
      ),
    deadlineTo: zod.coerce
      .string()
      .optional()
      .describe("마감일 끝 (ISO 8601, 포함)"),
    isClosed: zod.coerce
      .boolean()
      .optional()
      .describe(
        "마감 여부 (서버 시각 기준). `true` = 수동 마감(status=CLOSED) **또는** 마감일 경과, `false` = 그 반대. 진행중·마감 탭은 이 값 하나로 거세요",
      ),
  })
  .strict();

export const externalAdminQuoteRequestsControllerFindAllHeader = zod
  .object({
    "X-API-Key": zod.string(),
  })
  .strict();

export const externalAdminQuoteRequestsControllerFindAllResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod
                .string()
                .describe("견적요청 ID (세모 상세로 건너뛰는 키)"),
              requestNumber: zod.string().describe("공고번호"),
              projectName: zod.string().describe("공고명"),
              buyerName: zod.string().nullish().describe("발주기관명"),
              buyerMemberId: zod
                .string()
                .nullish()
                .describe(
                  "씨마켓 회원 ID. 세모에 직접 가입한 발주기관은 null (씨마켓 회원이 아님)",
                ),
              categoryType: zod
                .enum(["product", "construction", "manufacturing", "used"])
                .describe("카테고리"),
              status: zod
                .enum([
                  "IN_PROGRESS",
                  "ON_HOLD",
                  "CLOSED",
                  "CONTRACT_IN_PROGRESS",
                ])
                .describe(
                  "상태. 계약이 걸린 건은 CONTRACT_IN_PROGRESS (상세와 같은 값), 그 외는 DB 원값",
                ),
              deadline: zod.string().describe("마감일시 (ISO 8601)"),
              publishedAt: zod
                .string()
                .nullish()
                .describe("등록일시 (ISO 8601) — 정렬 키"),
              responseCount: zod.number().describe("응답(응찰) 수"),
              isPublic: zod
                .boolean()
                .nullish()
                .describe(
                  "공개 여부. 표시용이며 이 목록의 필터로는 쓰이지 않는다",
                ),
              isClosed: zod
                .boolean()
                .describe(
                  "마감 여부 — 수동 마감(status=CLOSED)이거나 마감일이 지났다. `isClosed` 필터와 같은 규칙",
                ),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 견적요청을 **사용자 화면에서 감춥니다**. 행은 지우지 않으므로 `POST /external/admin/quote-requests/{id}/restore` 로 되돌릴 수 있습니다.

**식별자**는 조회와 같습니다 — UUID · 공고번호(`AA0115`) · bid id(`AA0115_2`) 모두 받습니다.

**딸린 계약·결제·공급사 견적·채팅방이 함께 감춰집니다.** 공고만 감추면 발주기관 「나의 계약」과 공급사 「내 견적」에 그대로 남기 때문입니다. 참여 업체가 있어도 막지 않습니다.

어드민 목록·정산·수수료 집계는 계속 보입니다 — 감추는 곳은 발주기관·공급사 화면뿐입니다.

**`X-Admin-Actor` 헤더가 필수입니다** — 어느 운영자가 지웠는지 감사 로그에 남깁니다. 파트너 키만으로는 "씨마켓" 까지만 식별됩니다.
 * @summary 견적공고 삭제 (씨마켓 어드민 전용, 복원 가능)
 */
export const externalAdminQuoteRequestsControllerDeleteOneParams = zod
  .object({
    id: zod.coerce
      .string()
      .describe("UUID · 공고번호(AA0115) · bid id(AA0115_2) 모두 허용"),
  })
  .strict();

export const externalAdminQuoteRequestsControllerDeleteOneHeader = zod
  .object({
    "x-admin-actor": zod.string(),
    "user-agent": zod.string(),
    "X-Admin-Actor": zod
      .string()
      .describe("삭제를 실행한 씨마켓 어드민 식별자 (감사 로그용)"),
    "X-API-Key": zod.string(),
  })
  .strict();

export const externalAdminQuoteRequestsControllerDeleteOneResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod.object({}).optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 삭제된 견적요청과 **함께 감춰졌던 계약·결제·견적·채팅방**을 사용자 화면으로 되돌립니다.

삭제되지 않은 공고에 부르면 아무 것도 하지 않고 성공합니다(멱등).

**`X-Admin-Actor` 헤더가 필수입니다.**
 * @summary 견적공고 삭제 취소 (씨마켓 어드민 전용)
 */
export const externalAdminQuoteRequestsControllerRestoreOneParams = zod
  .object({
    id: zod.coerce
      .string()
      .describe("UUID · 공고번호(AA0115) · bid id(AA0115_2) 모두 허용"),
  })
  .strict();

export const externalAdminQuoteRequestsControllerRestoreOneHeader = zod
  .object({
    "x-admin-actor": zod.string(),
    "user-agent": zod.string(),
    "X-Admin-Actor": zod
      .string()
      .describe("복원을 실행한 씨마켓 어드민 식별자 (감사 로그용)"),
    "X-API-Key": zod.string(),
  })
  .strict();

export const externalAdminQuoteRequestsControllerRestoreOneResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod.object({}).optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * `quoteRequestId` · `requestNumber` · `externalSupplierId` 중 **최소 하나**로 방을 찾습니다. 조건이 하나도 없으면 400 입니다(전량 조회는 열지 않습니다).

`requestNumber` 는 씨마켓 bid id 형태('AA0014_2')도 받습니다 — `_` 뒤를 떼고 `SE` 접두사를 붙여 해석합니다.

`externalSupplierId` 는 씨마켓 공급사 회원 ID 입니다(SEMO `suppliers.supplier_id`).
 * @summary 채팅방 목록 조회 (씨마켓 운영자 전용, 읽기 전용)
 */
export const externalAdminChatControllerFindRoomsQueryPageDefault = 1;
export const externalAdminChatControllerFindRoomsQueryLimitDefault = 20;
export const externalAdminChatControllerFindRoomsQueryLimitMax = 100;

export const externalAdminChatControllerFindRoomsQueryParams = zod
  .object({
    quoteRequestId: zod.coerce.string().optional().describe("견적요청 UUID"),
    requestNumber: zod.coerce
      .string()
      .optional()
      .describe(
        "공고번호. 씨마켓 bid id('AA0014_2') 형태도 받는다 — '_' 뒤를 떼고 SE 접두사를 붙여 해석한다.",
      ),
    externalSupplierId: zod.coerce
      .string()
      .optional()
      .describe("씨마켓 공급사 회원 ID (SEMO `suppliers.supplier_id`)"),
    page: zod.coerce
      .number()
      .default(externalAdminChatControllerFindRoomsQueryPageDefault)
      .describe("페이지 (1부터)"),
    limit: zod.coerce
      .number()
      .max(externalAdminChatControllerFindRoomsQueryLimitMax)
      .default(externalAdminChatControllerFindRoomsQueryLimitDefault)
      .describe("페이지 크기"),
  })
  .strict();

export const externalAdminChatControllerFindRoomsHeader = zod
  .object({
    "user-agent": zod.string(),
    "X-API-Key": zod.string(),
  })
  .strict();

export const externalAdminChatControllerFindRoomsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("채팅방 ID"),
              quoteRequestId: zod.string().describe("견적요청 ID"),
              buyerName: zod.string().nullish().describe("발주기관 표시명"),
              supplierName: zod.string().nullish().describe("공급사 표시명"),
              externalSupplierId: zod
                .string()
                .nullish()
                .describe("씨마켓 공급사 회원 ID (`suppliers.supplier_id`)"),
              lastMessageAt: zod
                .string()
                .nullish()
                .describe("마지막 메시지 시각 (ISO 8601)"),
              messageCount: zod.number().describe("메시지 수"),
              participationState: zod
                .enum(["visible", "hidden"])
                .describe(
                  "참여 노출 상태. visible=정상, hidden=숨김(운영자에게만 보인다, 사용자 화면에서는 빠져 있다)",
                ),
              hiddenAt: zod
                .string()
                .nullish()
                .describe("감춘 시각 (ISO 8601). 정상 상태면 null."),
              hasContracted: zod
                .boolean()
                .describe(
                  "계약이 체결된 참여인지. true 면 숨기기·삭제가 막힌다.",
                ),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 응답 형태는 회원용 `GET /chat/rooms/{roomId}/messages` 와 **동일합니다** — admin2 가 기존 화면 코드를 그대로 씁니다.

**발주기관이 본 그대로**를 돌려줍니다. 공급사에게 숨기는 카드(계약서류 선택 등)까지 포함한 전체입니다 — 운영자가 문의에 답하려면 반쪽이 아니라 전체가 필요합니다.

첨부는 만료가 짧은 서명 URL 로 내려갑니다(회원 경로와 같은 생성기).
 * @summary 채팅 메시지 조회 (씨마켓 운영자 전용, 읽기 전용)
 */
export const externalAdminChatControllerFindMessagesParams = zod
  .object({
    roomId: zod.coerce.string().describe("채팅방 UUID"),
  })
  .strict();

export const externalAdminChatControllerFindMessagesQueryLimitDefault = 50;
export const externalAdminChatControllerFindMessagesQueryLimitMax = 100;

export const externalAdminChatControllerFindMessagesQueryParams = zod
  .object({
    cursor: zod.coerce
      .string()
      .optional()
      .describe(
        "커서. 이 메시지보다 이전 것을 가져온다(기존 `before` 와 같다)",
      ),
    limit: zod.coerce
      .number()
      .max(externalAdminChatControllerFindMessagesQueryLimitMax)
      .default(externalAdminChatControllerFindMessagesQueryLimitDefault)
      .describe("페이지 크기"),
  })
  .strict();

export const externalAdminChatControllerFindMessagesHeader = zod
  .object({
    "user-agent": zod.string(),
    "X-API-Key": zod.string(),
  })
  .strict();

export const externalAdminChatControllerFindMessagesResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod
          .array(
            zod.union([
              zod
                .object({
                  id: zod.string().describe("메시지 ID"),
                  roomId: zod.string().describe("채팅방 ID"),
                  senderId: zod.string().describe("발신자 ID"),
                  senderType: zod
                    .enum(["buyer", "supplier", "system"])
                    .describe("발신자 타입"),
                  senderName: zod
                    .string()
                    .optional()
                    .describe(
                      "발신자 이름 (회사명 또는 사용자명) - Realtime 알림용",
                    ),
                  messageType: zod.enum(["text"]).describe("메시지 타입"),
                  message: zod.string().describe("메시지 내용"),
                  isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
                  tempId: zod
                    .string()
                    .optional()
                    .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
                  isRead: zod.boolean().describe("읽음 여부"),
                  readAt: zod.string().optional().describe("읽은 시간"),
                  isDeleted: zod.boolean().describe("삭제 여부"),
                  deletedAt: zod.string().optional().describe("삭제 시간"),
                  createdAt: zod.string().describe("생성 일시"),
                  updatedAt: zod.string().describe("수정 일시"),
                })
                .strict(),
              zod
                .object({
                  id: zod.string().describe("메시지 ID"),
                  roomId: zod.string().describe("채팅방 ID"),
                  senderId: zod.string().describe("발신자 ID"),
                  senderType: zod
                    .enum(["buyer", "supplier", "system"])
                    .describe("발신자 타입"),
                  senderName: zod
                    .string()
                    .optional()
                    .describe(
                      "발신자 이름 (회사명 또는 사용자명) - Realtime 알림용",
                    ),
                  messageType: zod.enum(["attachment"]).describe("메시지 타입"),
                  message: zod.string().describe("메시지 내용"),
                  isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
                  tempId: zod
                    .string()
                    .optional()
                    .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
                  isRead: zod.boolean().describe("읽음 여부"),
                  readAt: zod.string().optional().describe("읽은 시간"),
                  isDeleted: zod.boolean().describe("삭제 여부"),
                  deletedAt: zod.string().optional().describe("삭제 시간"),
                  createdAt: zod.string().describe("생성 일시"),
                  updatedAt: zod.string().describe("수정 일시"),
                  attachment: zod
                    .object({
                      id: zod.string().describe("첨부파일 ID"),
                      fileName: zod.string().describe("파일명"),
                      fileSize: zod.number().describe("파일 크기 (바이트)"),
                      fileType: zod.string().describe("파일 타입"),
                      contentType: zod.string().describe("MIME 타입"),
                      url: zod.string().describe("파일 URL"),
                      description: zod
                        .string()
                        .optional()
                        .describe("파일 설명"),
                      isImage: zod.boolean().describe("이미지 파일 여부"),
                      createdAt: zod
                        .string()
                        .describe("업로드 일시 (ISO 8601 형식)"),
                      uploadStatus: zod
                        .string()
                        .describe(
                          "파일 업로드 상태 (pending: 업로드 중, completed: 완료, failed: 실패)",
                        ),
                      hiddenFromSupplier: zod
                        .boolean()
                        .optional()
                        .describe(
                          "true이면 supplier에게 노출하지 않는 첨부 (buyer 채팅창 전용). 계약서류 자동 발급/SEMO 견적서에서 사용.",
                        ),
                    })
                    .strict()
                    .optional()
                    .describe("첨부파일 정보"),
                })
                .strict(),
              zod
                .object({
                  id: zod.string().describe("메시지 ID"),
                  roomId: zod.string().describe("채팅방 ID"),
                  senderId: zod.string().describe("발신자 ID"),
                  senderType: zod
                    .enum(["buyer", "supplier", "system"])
                    .describe("발신자 타입"),
                  senderName: zod
                    .string()
                    .optional()
                    .describe(
                      "발신자 이름 (회사명 또는 사용자명) - Realtime 알림용",
                    ),
                  messageType: zod.enum(["quote"]).describe("메시지 타입"),
                  message: zod.string().describe("메시지 내용"),
                  isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
                  tempId: zod
                    .string()
                    .optional()
                    .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
                  isRead: zod.boolean().describe("읽음 여부"),
                  readAt: zod.string().optional().describe("읽은 시간"),
                  isDeleted: zod.boolean().describe("삭제 여부"),
                  deletedAt: zod.string().optional().describe("삭제 시간"),
                  createdAt: zod.string().describe("생성 일시"),
                  updatedAt: zod.string().describe("수정 일시"),
                  quoteData: zod
                    .object({
                      quoteResponseId: zod.string().optional(),
                      quoteVersionId: zod
                        .string()
                        .optional()
                        .describe("버전 레코드 ID"),
                      versionNumber: zod.number().optional(),
                      totalAmount: zod.number().optional(),
                      taxType: zod
                        .enum(["EXCLUSIVE", "INCLUSIVE"])
                        .optional()
                        .describe(
                          "단가 입력 축 — EXCLUSIVE(단가가 공급가액, 부가세 가산) | INCLUSIVE(단가가 부가세 포함가, 총액에서 역산)",
                        ),
                      supplyAmount: zod
                        .number()
                        .optional()
                        .describe("공급가액 (부가세 제외)"),
                      taxAmount: zod.number().optional().describe("부가세"),
                      previousAmount: zod
                        .number()
                        .optional()
                        .describe("이전 버전 금액"),
                      createdAt: zod
                        .string()
                        .datetime({})
                        .optional()
                        .describe("버전 생성일"),
                      updatedAt: zod
                        .string()
                        .datetime({})
                        .optional()
                        .describe("버전 수정일"),
                      items: zod
                        .array(
                          zod
                            .object({
                              name: zod.string().optional().describe("항목명"),
                              spec: zod.string().optional().describe("사양"),
                              notes: zod.string().optional().describe("설명"),
                              quantity: zod
                                .number()
                                .optional()
                                .describe("수량"),
                              unit: zod.string().optional().describe("단위"),
                              unitPrice: zod
                                .number()
                                .optional()
                                .describe("단가"),
                              amount: zod
                                .number()
                                .optional()
                                .describe("금액 (quantity × unitPrice)"),
                            })
                            .strict(),
                        )
                        .optional(),
                      supplier: zod
                        .object({
                          id: zod
                            .string()
                            .optional()
                            .describe("공급사 사용자 ID"),
                          companyName: zod
                            .string()
                            .optional()
                            .describe("공급사 회사명"),
                          businessNumber: zod
                            .string()
                            .optional()
                            .describe("사업자 등록번호"),
                          ceoName: zod.string().optional().describe("대표자명"),
                          addressFull: zod.string().optional().describe("주소"),
                          businessType: zod
                            .string()
                            .optional()
                            .describe("업종"),
                          companyPhone: zod
                            .string()
                            .optional()
                            .describe("전화번호"),
                          managerName: zod
                            .string()
                            .optional()
                            .describe("담당자명"),
                          managerPhone: zod
                            .string()
                            .optional()
                            .describe("담당자 연락처"),
                          companySealUrl: zod
                            .string()
                            .optional()
                            .describe("회사 인장 URL"),
                          trustBadge: zod
                            .string()
                            .optional()
                            .describe("신뢰도 배지"),
                          isVerified: zod
                            .boolean()
                            .optional()
                            .describe("검증 여부"),
                        })
                        .strict()
                        .optional(),
                      buyer: zod
                        .object({
                          name: zod.string().optional().describe("담당자 이름"),
                          phone: zod
                            .string()
                            .optional()
                            .describe("담당자 연락처"),
                        })
                        .strict()
                        .optional(),
                      pdfUrl: zod
                        .string()
                        .url()
                        .optional()
                        .describe("PDF 다운로드 URL (Supabase Storage)"),
                      description: zod
                        .string()
                        .optional()
                        .describe("견적 설명"),
                      projectName: zod
                        .string()
                        .optional()
                        .describe("프로젝트명"),
                      isContracted: zod
                        .boolean()
                        .optional()
                        .describe("계약 완료 여부 (FREE plan 다운로드 제한용)"),
                      contractId: zod.string().optional().describe("계약 ID"),
                      attachments: zod
                        .array(
                          zod
                            .object({
                              fileName: zod
                                .string()
                                .optional()
                                .describe("파일명"),
                              url: zod
                                .string()
                                .url()
                                .optional()
                                .describe("파일 공개 URL"),
                              filePath: zod
                                .string()
                                .optional()
                                .describe("스토리지 경로 (재서명에 사용)"),
                              fileSize: zod
                                .number()
                                .optional()
                                .describe("파일 크기 (바이트)"),
                              contentType: zod
                                .string()
                                .optional()
                                .describe("MIME 타입"),
                            })
                            .strict(),
                        )
                        .optional()
                        .describe("첨부파일 목록"),
                    })
                    .strict()
                    .optional()
                    .describe("견적서 데이터 (풍부한 정보 포함)"),
                })
                .strict(),
              zod
                .object({
                  id: zod.string().describe("메시지 ID"),
                  roomId: zod.string().describe("채팅방 ID"),
                  senderId: zod.string().describe("발신자 ID"),
                  senderType: zod
                    .enum(["buyer", "supplier", "system"])
                    .describe("발신자 타입"),
                  senderName: zod
                    .string()
                    .optional()
                    .describe(
                      "발신자 이름 (회사명 또는 사용자명) - Realtime 알림용",
                    ),
                  messageType: zod.enum(["contract"]).describe("메시지 타입"),
                  message: zod.string().describe("메시지 내용"),
                  isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
                  tempId: zod
                    .string()
                    .optional()
                    .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
                  isRead: zod.boolean().describe("읽음 여부"),
                  readAt: zod.string().optional().describe("읽은 시간"),
                  isDeleted: zod.boolean().describe("삭제 여부"),
                  deletedAt: zod.string().optional().describe("삭제 시간"),
                  createdAt: zod.string().describe("생성 일시"),
                  updatedAt: zod.string().describe("수정 일시"),
                  contractInfo: zod
                    .object({
                      contractId: zod.string().describe("계약 ID"),
                      paymentId: zod.string().describe("결제 ID"),
                      tid: zod
                        .string()
                        .optional()
                        .describe("Innopay 거래 고유번호 (TID)"),
                      totalAmount: zod.number().describe("총 계약 금액"),
                      contractedAt: zod.string().describe("계약 체결 일시"),
                      status: zod
                        .enum(["complete", "cancelled", "pending"])
                        .describe("계약 상태"),
                      paymentMethod: zod
                        .enum(["CARD", "CASH", "DIRECT", "CMARKET_CARD"])
                        .optional()
                        .describe(
                          "결제 거래의 수단(payment_transactions 축). CMARKET_CARD 는 씨마켓 결제창을 거쳐 공급기업 가맹점으로 승인된 건이다. 계약 시 고른 현금/카드는 이 필드가 아니라 paymentChannel 이다.",
                        ),
                      paymentChannel: zod
                        .enum(["cash", "card"])
                        .nullish()
                        .describe(
                          "계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.",
                        ),
                      taxInvoiceStatus: zod
                        .enum(["REQUESTED", "ISSUED", "CANCELLED"])
                        .nullish()
                        .describe(
                          "씨마켓 계산서 진행 상태 (contracts.tax_invoice_status 실시간 조회). REQUESTED=발행요청됨, ISSUED=발행완료. NULL 은 아직 아무 통지도 오지 않은 상태다. 현금 계약에서 카드의 isPaid 와 같은 자리를 맡는다 — 스냅샷이 아니라 매 조회마다 계약에서 읽는다.",
                        ),
                      settlesOnCmarket: zod
                        .boolean()
                        .optional()
                        .describe(
                          "이 계약의 대금·계산서를 씨마켓에서 정리하는가(계약-먼저 길인가). 세모 안심결제 계약은 false — 대금은 세모가 이미 받았고 씨마켓에 갈 일이 없다. 카드의 「대금 정리」 칸을 그릴지 이 값 하나로 정한다. 지급 수단으로 되짚지 말 것.",
                        ),
                      supplierCompanyName: zod
                        .string()
                        .optional()
                        .describe("공급자 상호명"),
                      supplierCeoName: zod
                        .string()
                        .optional()
                        .describe("공급자 대표자명"),
                      supplierBusinessNumber: zod
                        .string()
                        .optional()
                        .describe("공급자 사업자등록번호"),
                      supplierAddress: zod
                        .string()
                        .optional()
                        .describe("공급자 주소"),
                      supplierPhone: zod
                        .string()
                        .optional()
                        .describe("공급자 연락처"),
                      supplierEmail: zod
                        .string()
                        .optional()
                        .describe("공급자 이메일"),
                      buyerAgencyName: zod
                        .string()
                        .optional()
                        .describe("구매자 상호명/기관명"),
                      buyerManagerName: zod
                        .string()
                        .optional()
                        .describe("구매자 담당자명"),
                      buyerAddress: zod
                        .string()
                        .optional()
                        .describe("구매자 배송지 주소"),
                      deliveryAddress: zod
                        .string()
                        .optional()
                        .describe("배송지 주소 (legacy or alternate)"),
                      buyerManagerPhone: zod
                        .string()
                        .optional()
                        .describe(
                          "[deprecated] 담당자 개인 연락처 — 더는 채우지 않는다(항상 빈 문자열)",
                        ),
                      buyerOrganizationPhone: zod
                        .string()
                        .optional()
                        .describe(
                          "발주기관 대표번호 (담당자 개인 휴대폰이 아니다)",
                        ),
                      buyerBusinessNumber: zod
                        .string()
                        .optional()
                        .describe("구매자 사업자번호 (보조)"),
                      itemName: zod
                        .string()
                        .optional()
                        .describe("대표 상품/서비스명"),
                      items: zod
                        .array(
                          zod
                            .object({
                              name: zod.string().optional(),
                              spec: zod.string().optional(),
                              quantity: zod.number().optional(),
                              unit: zod.string().optional(),
                              unitPrice: zod.number().optional(),
                              amount: zod.number().optional(),
                            })
                            .strict(),
                        )
                        .optional()
                        .describe("상세 품목 리스트 (거래명세서용)"),
                      authCode: zod
                        .string()
                        .optional()
                        .describe("카드 승인번호 (Innopay)"),
                      reason: zod
                        .string()
                        .optional()
                        .describe("취소 사유 (cancelled 상태일 때)"),
                      isPrepaid: zod
                        .boolean()
                        .optional()
                        .describe(
                          "결제 방법 스냅샷. true=선결제, false=후불결제.",
                        ),
                      paidAt: zod
                        .string()
                        .datetime({})
                        .nullish()
                        .describe("결제 완료 시각. NULL 이면 미결제."),
                    })
                    .strict()
                    .describe("계약 정보"),
                })
                .strict(),
              zod
                .object({
                  id: zod.string().describe("메시지 ID"),
                  roomId: zod.string().describe("채팅방 ID"),
                  senderId: zod.string().describe("발신자 ID"),
                  senderType: zod
                    .enum(["buyer", "supplier", "system"])
                    .describe("발신자 타입"),
                  senderName: zod
                    .string()
                    .optional()
                    .describe(
                      "발신자 이름 (회사명 또는 사용자명) - Realtime 알림용",
                    ),
                  messageType: zod.enum(["system"]).describe("메시지 타입"),
                  message: zod.string().describe("메시지 내용"),
                  isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
                  tempId: zod
                    .string()
                    .optional()
                    .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
                  isRead: zod.boolean().describe("읽음 여부"),
                  readAt: zod.string().optional().describe("읽은 시간"),
                  isDeleted: zod.boolean().describe("삭제 여부"),
                  deletedAt: zod.string().optional().describe("삭제 시간"),
                  createdAt: zod.string().describe("생성 일시"),
                  updatedAt: zod.string().describe("수정 일시"),
                })
                .strict(),
              zod
                .object({
                  id: zod.string().describe("메시지 ID"),
                  roomId: zod.string().describe("채팅방 ID"),
                  senderId: zod.string().describe("발신자 ID"),
                  senderType: zod
                    .enum(["buyer", "supplier", "system"])
                    .describe("발신자 타입"),
                  senderName: zod
                    .string()
                    .optional()
                    .describe(
                      "발신자 이름 (회사명 또는 사용자명) - Realtime 알림용",
                    ),
                  messageType: zod
                    .enum(["payment_pending"])
                    .describe("메시지 타입"),
                  message: zod.string().describe("메시지 내용"),
                  isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
                  tempId: zod
                    .string()
                    .optional()
                    .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
                  isRead: zod.boolean().describe("읽음 여부"),
                  readAt: zod.string().optional().describe("읽은 시간"),
                  isDeleted: zod.boolean().describe("삭제 여부"),
                  deletedAt: zod.string().optional().describe("삭제 시간"),
                  createdAt: zod.string().describe("생성 일시"),
                  updatedAt: zod.string().describe("수정 일시"),
                  paymentPendingData: zod
                    .object({
                      moid: zod.string().describe("주문번호 (MOID)"),
                      amount: zod.number().describe("결제 대기 금액"),
                      bankAccount: zod
                        .string()
                        .describe("입금 계좌번호 (가상계좌/무통장)"),
                      createdAt: zod.string().describe("생성 일시"),
                      expiresAt: zod.string().describe("만료 일시 (입금 기한)"),
                      rejectedAt: zod.string().optional().describe("거절 일시"),
                      rejectionReason: zod
                        .string()
                        .optional()
                        .describe("거절 사유"),
                      status: zod
                        .enum(["PENDING", "APPROVED", "REJECTED", "EXPIRED"])
                        .optional()
                        .describe("결제 상태"),
                      approvedAt: zod.string().optional().describe("승인 일시"),
                    })
                    .strict()
                    .describe("입금 대기 정보"),
                })
                .strict(),
              zod
                .object({
                  id: zod.string().describe("메시지 ID"),
                  roomId: zod.string().describe("채팅방 ID"),
                  senderId: zod.string().describe("발신자 ID"),
                  senderType: zod
                    .enum(["buyer", "supplier", "system"])
                    .describe("발신자 타입"),
                  senderName: zod
                    .string()
                    .optional()
                    .describe(
                      "발신자 이름 (회사명 또는 사용자명) - Realtime 알림용",
                    ),
                  messageType: zod
                    .enum(["cancellation_request"])
                    .describe("메시지 타입"),
                  message: zod.string().describe("메시지 내용"),
                  isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
                  tempId: zod
                    .string()
                    .optional()
                    .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
                  isRead: zod.boolean().describe("읽음 여부"),
                  readAt: zod.string().optional().describe("읽은 시간"),
                  isDeleted: zod.boolean().describe("삭제 여부"),
                  deletedAt: zod.string().optional().describe("삭제 시간"),
                  createdAt: zod.string().describe("생성 일시"),
                  updatedAt: zod.string().describe("수정 일시"),
                  cancellationRequestData: zod
                    .object({
                      refundId: zod.string().describe("환불 ID"),
                      contractId: zod.string().describe("계약 ID"),
                      requestReason: zod.string().describe("취소 사유"),
                      requesterRole: zod
                        .enum(["buyer", "supplier"])
                        .describe(
                          "취소 요청 주체 (buyer: 발주기관, supplier: 공급사). 승인/반려 버튼은 상대방에게만 노출해야 함. 레거시 메시지는 buyer로 응답됨.",
                        ),
                      rejectionReason: zod
                        .string()
                        .optional()
                        .describe("반려 사유"),
                      tid: zod.string().optional().describe("거래 번호 (환불)"),
                      paymentMethod: zod
                        .enum(["CARD", "CASH", "DIRECT"])
                        .optional()
                        .describe("결제 수단"),
                      totalAmount: zod
                        .number()
                        .optional()
                        .describe("취소 금액"),
                      status: zod
                        .enum(["pending", "approved", "rejected"])
                        .describe("요청 상태"),
                    })
                    .strict()
                    .describe("계약 취소 요청 정보"),
                })
                .strict(),
              zod
                .object({
                  id: zod.string().describe("메시지 ID"),
                  roomId: zod.string().describe("채팅방 ID"),
                  senderId: zod.string().describe("발신자 ID"),
                  senderType: zod
                    .enum(["buyer", "supplier", "system"])
                    .describe("발신자 타입"),
                  senderName: zod
                    .string()
                    .optional()
                    .describe(
                      "발신자 이름 (회사명 또는 사용자명) - Realtime 알림용",
                    ),
                  messageType: zod
                    .enum(["review_submitted"])
                    .describe("메시지 타입"),
                  message: zod.string().describe("메시지 내용"),
                  isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
                  tempId: zod
                    .string()
                    .optional()
                    .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
                  isRead: zod.boolean().describe("읽음 여부"),
                  readAt: zod.string().optional().describe("읽은 시간"),
                  isDeleted: zod.boolean().describe("삭제 여부"),
                  deletedAt: zod.string().optional().describe("삭제 시간"),
                  createdAt: zod.string().describe("생성 일시"),
                  updatedAt: zod.string().describe("수정 일시"),
                  reviewSubmittedData: zod
                    .object({
                      contractId: zod.string().describe("계약 ID"),
                      reviewId: zod.string().describe("리뷰 ID"),
                      status: zod.enum(["submitted"]).describe("리뷰 상태"),
                    })
                    .strict()
                    .describe("리뷰 작성 완료 정보"),
                })
                .strict(),
              zod
                .object({
                  id: zod.string().describe("메시지 ID"),
                  roomId: zod.string().describe("채팅방 ID"),
                  senderId: zod.string().describe("발신자 ID"),
                  senderType: zod
                    .enum(["buyer", "supplier", "system"])
                    .describe("발신자 타입"),
                  senderName: zod
                    .string()
                    .optional()
                    .describe(
                      "발신자 이름 (회사명 또는 사용자명) - Realtime 알림용",
                    ),
                  messageType: zod
                    .enum(["document_request"])
                    .describe("메시지 타입"),
                  message: zod.string().describe("메시지 내용"),
                  isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
                  tempId: zod
                    .string()
                    .optional()
                    .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
                  isRead: zod.boolean().describe("읽음 여부"),
                  readAt: zod.string().optional().describe("읽은 시간"),
                  isDeleted: zod.boolean().describe("삭제 여부"),
                  deletedAt: zod.string().optional().describe("삭제 시간"),
                  createdAt: zod.string().describe("생성 일시"),
                  updatedAt: zod.string().describe("수정 일시"),
                  documentRequestData: zod
                    .object({
                      contractId: zod.string().describe("계약 ID"),
                      bidType: zod
                        .enum(["goods", "service", "construction", "sale"])
                        .describe(
                          "c-market 거래유형 (quote_requests.category_type 매핑)",
                        ),
                      documents: zod
                        .array(
                          zod
                            .object({
                              paperCode: zod
                                .number()
                                .describe("c-market 서류 코드"),
                              name: zod.string().describe("서류 이름"),
                              isDefault: zod
                                .boolean()
                                .describe(
                                  "운영자 기본값 여부 - 선택 화면에서 미리 체크",
                                ),
                              autoGenerated: zod
                                .boolean()
                                .describe(
                                  "시스템 자동 생성 가능 여부 (false: 공급사 직접 제출 대상)",
                                ),
                            })
                            .strict(),
                        )
                        .describe(
                          "선택 가능한 계약서류 목록 (pending 카드 렌더용 스냅샷)",
                        ),
                      status: zod
                        .enum(["pending", "requested"])
                        .describe("요청 상태"),
                      issuedPaperCodes: zod
                        .array(zod.number())
                        .describe("발급 완료된 c-market 계약서류 코드"),
                      contractDocuments: zod
                        .array(
                          zod
                            .object({
                              id: zod
                                .string()
                                .describe("contract_documents.id"),
                              paperCode: zod
                                .number()
                                .describe("c-market paperCode"),
                              name: zod.string().describe("서류 이름"),
                              kind: zod
                                .enum(["auto", "auto_pending_input", "manual"])
                                .describe(
                                  "auto: 즉시 자동 생성. auto_pending_input: 자동 생성이지만 supplier 별도 입력값 필요. manual: 직접 제출",
                                ),
                              status: zod
                                .enum(["pending", "completed"])
                                .describe("대기(pending) vs 완료(completed)"),
                              fileUrl: zod
                                .object({})
                                .optional()
                                .describe(
                                  "다운로드 가능한 파일 URL (완료 시 존재)",
                                ),
                              fileName: zod
                                .object({})
                                .optional()
                                .describe("원본 파일명 (완료 시 존재)"),
                              fileSize: zod
                                .object({})
                                .optional()
                                .describe("파일 크기 (bytes)"),
                              contentType: zod
                                .object({})
                                .optional()
                                .describe("MIME 타입"),
                              uploadedAt: zod
                                .object({})
                                .optional()
                                .describe("업로드 시각 (ISO 8601)"),
                            })
                            .strict(),
                        )
                        .optional()
                        .describe(
                          '[계약 서류 관리] 카드 항목 목록. status=\"requested\" 로 전환된 이후에만 채워진다.',
                        ),
                      paymentMethod: zod
                        .enum(["prepaid", "postpaid"])
                        .optional()
                        .describe(
                          "견적요청의 결제 방법 스냅샷 (2026-07-31). 2026-08-04 부터 신규는 전량 postpaid 라 카드 렌더 판단에는 쓰지 않는다(표시·디버깅용). 결제 CTA 는 paymentChannel 이 정한다.",
                        ),
                      paymentChannel: zod
                        .enum(["cash", "card"])
                        .nullish()
                        .describe(
                          "계약 시 고른 결제 수단 (contracts.payment_channel 실시간 조회). cash → [계산서 발행요청], card → [카드결제하기]. null 이면 카드가 결제 CTA 를 그리지 않는다 — 컬럼 신설(2026-08-04) 이전 레거시 계약이 여기 해당한다.",
                        ),
                      isPaid: zod
                        .boolean()
                        .optional()
                        .describe(
                          "결제 완료 여부 (contracts.paid_at 유무). CONTRACT 메시지 카드와 같은 판정을 쓴다.",
                        ),
                      taxInvoiceStatus: zod
                        .enum(["REQUESTED", "ISSUED", "CANCELLED"])
                        .nullish()
                        .describe(
                          "씨마켓 계산서 진행 상태 (contracts.tax_invoice_status 실시간 조회). REQUESTED=발행요청됨, ISSUED=발행완료. 현금 계약에서 isPaid 와 같은 자리를 맡는다.",
                        ),
                      restrictionConfirm: zod
                        .object({
                          answers: zod
                            .array(zod.enum(["YES", "NO"]))
                            .describe("8개 문항 응답 원본"),
                          flaggedIndexes: zod
                            .array(zod.number())
                            .describe(
                              '\"예\"로 응답한 문항 인덱스(0-based). 비어있으면 경고 없음.',
                            ),
                          submittedAt: zod
                            .string()
                            .describe("supplier 제출 시각 (ISO 8601)"),
                          buyerConfirmation: zod
                            .enum(["YES", "NO"])
                            .nullable()
                            .describe(
                              '발주기관 최종 확인 응답. 전 문항 \"NO\" 는 null(확인 절차 없음). \"예\" 포함 상태에서 buyer 미확인이면 null, 확인 후 잠긴다.',
                            ),
                          confirmedAt: zod
                            .object({})
                            .nullable()
                            .describe(
                              "buyer 확인 제출 시각 (ISO 8601). 미제출이면 null.",
                            ),
                        })
                        .strict()
                        .optional()
                        .describe(
                          "paperCode 135(수의계약체결제한여부확인서) 제출 스냅샷 (2026-08-02). 미제출이면 undefined.",
                        ),
                    })
                    .strict()
                    .describe("계약서류 선택 요청 정보"),
                })
                .strict(),
              zod
                .object({
                  id: zod.string().describe("메시지 ID"),
                  roomId: zod.string().describe("채팅방 ID"),
                  senderId: zod.string().describe("발신자 ID"),
                  senderType: zod
                    .enum(["buyer", "supplier", "system"])
                    .describe("발신자 타입"),
                  senderName: zod
                    .string()
                    .optional()
                    .describe(
                      "발신자 이름 (회사명 또는 사용자명) - Realtime 알림용",
                    ),
                  messageType: zod
                    .enum(["contract_restriction_confirm"])
                    .describe("메시지 타입"),
                  message: zod.string().describe("메시지 내용"),
                  isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
                  tempId: zod
                    .string()
                    .optional()
                    .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
                  isRead: zod.boolean().describe("읽음 여부"),
                  readAt: zod.string().optional().describe("읽은 시간"),
                  isDeleted: zod.boolean().describe("삭제 여부"),
                  deletedAt: zod.string().optional().describe("삭제 시간"),
                  createdAt: zod.string().describe("생성 일시"),
                  updatedAt: zod.string().describe("수정 일시"),
                  contractRestrictionConfirmData: zod
                    .object({
                      contractId: zod.string().describe("계약 ID"),
                      documentRequestMessageId: zod
                        .string()
                        .describe("짝이 되는 [계약 서류 관리] 카드 메시지 ID"),
                      answers: zod
                        .array(zod.string())
                        .describe("8개 문항 응답 원본"),
                      flaggedIndexes: zod
                        .array(zod.number())
                        .describe('\"예\"로 응답한 문항 인덱스(0..7)'),
                      submittedAt: zod
                        .string()
                        .describe("공급사 제출 시각 (ISO 8601)"),
                      buyerConfirmation: zod
                        .enum(["YES", "NO"])
                        .nullable()
                        .describe("발주기관 최종 확인 응답. 미제출이면 null."),
                      confirmedAt: zod
                        .object({})
                        .nullable()
                        .describe(
                          "buyer 확인 제출 시각 (ISO 8601). 미제출이면 null.",
                        ),
                    })
                    .strict()
                    .describe("수의계약 체결 제한 확인 요청 정보"),
                })
                .strict(),
            ]),
          )
          .describe("채팅 메시지 목록"),
        nextCursor: zod.string().nullable().describe("다음 커서"),
        hasMore: zod.boolean().describe("추가 데이터 여부"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 이 참여(채팅방 + 딸린 견적)를 **발주기관·공급사 화면에서 감춥니다.** 참여 수와 「견적 N건」에서도 함께 빠집니다.

운영자 목록(`GET /external/admin/chat-rooms`)에는 `participationState: "hidden"` 으로 계속 나옵니다 — 감춘 것이 보여야 되살릴 수 있습니다.

**계약이 진행 중이거나 결제가 오간 참여는 409 로 막힙니다.** 계약서·세금계산서가 그 견적을 되읽기 때문에, 감추는 순간 데이터 정리가 아니라 기능 고장이 됩니다.

이미 숨김 상태면 성공으로 끝나되 `changed: false` 로 옵니다.

**`X-Admin-Actor` 헤더가 필수입니다** — 어느 운영자가 감췄는지 감사 로그에 남깁니다.
 * @summary 공급사 참여 이력 숨기기 (씨마켓 운영자 전용, 되살릴 수 있음)
 */
export const externalAdminParticipationsControllerHideParams = zod
  .object({
    roomId: zod.coerce.string().describe("참여의 채팅방 UUID"),
  })
  .strict();

export const externalAdminParticipationsControllerHideHeader = zod
  .object({
    "x-admin-actor": zod.string(),
    "user-agent": zod.string(),
    "X-Admin-Actor": zod
      .string()
      .describe("숨김을 실행한 씨마켓 어드민 식별자 (감사 로그용)"),
    "X-API-Key": zod.string(),
  })
  .strict();

export const externalAdminParticipationsControllerHideResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        chatRoomId: zod.string().describe("대상 참여의 채팅방 ID"),
        state: zod
          .enum(["visible", "hidden"])
          .describe(
            "바뀐 뒤 상태. visible=정상, hidden=숨김(마스터에만 흐리게)",
          ),
        previousState: zod
          .enum(["visible", "hidden"])
          .optional()
          .describe("바뀌기 전 상태. 이미 같은 상태였으면 생략된다."),
        changed: zod
          .boolean()
          .describe(
            "실제로 상태가 바뀌었는지. false 면 이미 그 상태였다는 뜻이다.",
          ),
        quoteResponses: zod
          .number()
          .describe(
            "함께 표시된 견적 행 수. 견적을 내지 않고 방만 열린 참여는 0 이다.",
          ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 숨김 상태의 참여를 발주기관·공급사 화면으로 되돌립니다. 참여 수와 「견적 N건」도 함께 돌아옵니다.

이미 정상 상태면 성공으로 끝나되 `changed: false` 로 옵니다.

**`X-Admin-Actor` 헤더가 필수입니다.**
 * @summary 숨긴 참여 이력 되살리기 (씨마켓 운영자 전용)
 */
export const externalAdminParticipationsControllerUnhideParams = zod
  .object({
    roomId: zod.coerce.string().describe("참여의 채팅방 UUID"),
  })
  .strict();

export const externalAdminParticipationsControllerUnhideHeader = zod
  .object({
    "x-admin-actor": zod.string(),
    "user-agent": zod.string(),
    "X-Admin-Actor": zod
      .string()
      .describe("되살리기를 실행한 씨마켓 어드민 식별자 (감사 로그용)"),
    "X-API-Key": zod.string(),
  })
  .strict();

export const externalAdminParticipationsControllerUnhideResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        chatRoomId: zod.string().describe("대상 참여의 채팅방 ID"),
        state: zod
          .enum(["visible", "hidden"])
          .describe(
            "바뀐 뒤 상태. visible=정상, hidden=숨김(마스터에만 흐리게)",
          ),
        previousState: zod
          .enum(["visible", "hidden"])
          .optional()
          .describe("바뀌기 전 상태. 이미 같은 상태였으면 생략된다."),
        changed: zod
          .boolean()
          .describe(
            "실제로 상태가 바뀌었는지. false 면 이미 그 상태였다는 뜻이다.",
          ),
        quoteResponses: zod
          .number()
          .describe(
            "함께 표시된 견적 행 수. 견적을 내지 않고 방만 열린 참여는 0 이다.",
          ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 숨김 상태의 참여를 **실제로 지웁니다.** 견적·견적서 버전·대화방과 그 업체와 주고받은 대화가 함께 사라지며 **되돌릴 수 없습니다.**

**숨김을 거치지 않은 참여는 409 로 막힙니다** — 먼저 `POST /external/admin/participations/{roomId}/hide` 를 부르고, 감춰진 결과를 확인한 뒤에 지웁니다. 계약·결제가 걸린 참여도 409 입니다.

무엇이 사라졌는지를 수치로 돌려줍니다. 화면에서 사람에게 그대로 보여 주십시오.

**`X-Admin-Actor` 헤더가 필수입니다.**
 * @summary 참여 이력 삭제 (씨마켓 운영자 전용) — 되돌릴 수 없음
 */
export const externalAdminParticipationsControllerRemoveParams = zod
  .object({
    roomId: zod.coerce.string().describe("참여의 채팅방 UUID"),
  })
  .strict();

export const externalAdminParticipationsControllerRemoveHeader = zod
  .object({
    "x-admin-actor": zod.string(),
    "user-agent": zod.string(),
    "X-Admin-Actor": zod
      .string()
      .describe("삭제를 실행한 씨마켓 어드민 식별자 (감사 로그용)"),
    "X-API-Key": zod.string(),
  })
  .strict();

export const externalAdminParticipationsControllerRemoveResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        chatRoomId: zod.string().describe("지운 참여의 채팅방 ID"),
        quoteRequestId: zod.string().describe("이 참여가 속했던 공고 ID"),
        supplierId: zod.string().describe("이 참여의 공급사 users.id"),
        quoteResponses: zod.number().describe("함께 사라진 견적 수"),
        quoteVersions: zod.number().describe("함께 사라진 견적서 버전 수"),
        chatMessages: zod
          .number()
          .describe("함께 사라진 대화 메시지 수. 되돌릴 수 없다."),
        chatRooms: zod.number().describe("함께 사라진 대화방 수"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();
